import { effectScope as Qo, ref as B, markRaw as Le, toRaw as Ye, computed as $, isRef as Ie, isReactive as Lt, toRef as xe, hasInjectionContext as is, inject as us, getCurrentInstance as cs, watch as Y, unref as O, reactive as mn, nextTick as Mt, getCurrentScope as ds, onScopeDispose as ps, toRefs as In, defineComponent as W, createElementBlock as v, createCommentVNode as P, openBlock as b, normalizeStyle as ms, normalizeClass as q, createElementVNode as C, createVNode as V, renderSlot as ve, createTextVNode as Ze, toDisplayString as L, withDirectives as fe, vShow as rt, Fragment as se, renderList as we, useTemplateRef as Ne, vModelDynamic as fs, onBeforeMount as ft, createBlock as z, vModelRadio as ea, vModelSelect as ta, vModelText as fn, withCtx as He, withModifiers as Pe, onMounted as et, onUnmounted as hn, withKeys as $e, createApp as hs, onBeforeUnmount as ys, resolveDynamicComponent as vt, resolveComponent as _s, defineCustomElement as yn } from "vue";
var bs = Object.create, na = Object.defineProperty, gs = Object.getOwnPropertyDescriptor, _n = Object.getOwnPropertyNames, vs = Object.getPrototypeOf, ws = Object.prototype.hasOwnProperty, Es = (e, t) => function() {
  return e && (t = (0, e[_n(e)[0]])(e = 0)), t;
}, Cs = (e, t) => function() {
  return t || (0, e[_n(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, Ss = (e, t, n, o) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let a of _n(t))
      !ws.call(e, a) && a !== n && na(e, a, { get: () => t[a], enumerable: !(o = gs(t, a)) || o.enumerable });
  return e;
}, As = (e, t, n) => (n = e != null ? bs(vs(e)) : {}, Ss(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  na(n, "default", { value: e, enumerable: !0 }),
  e
)), ht = Es({
  "../../node_modules/.pnpm/tsup@8.4.0_@microsoft+api-extractor@7.51.1_@types+node@22.13.14__jiti@2.4.2_postcss@8.5_96eb05a9d65343021e53791dd83f3773/node_modules/tsup/assets/esm_shims.js"() {
  }
}), ks = Cs({
  "../../node_modules/.pnpm/rfdc@1.4.1/node_modules/rfdc/index.js"(e, t) {
    ht(), t.exports = o;
    function n(s) {
      return s instanceof Buffer ? Buffer.from(s) : new s.constructor(s.buffer.slice(), s.byteOffset, s.length);
    }
    function o(s) {
      if (s = s || {}, s.circles) return a(s);
      const r = /* @__PURE__ */ new Map();
      if (r.set(Date, (_) => new Date(_)), r.set(Map, (_, w) => new Map(i(Array.from(_), w))), r.set(Set, (_, w) => new Set(i(Array.from(_), w))), s.constructorHandlers)
        for (const _ of s.constructorHandlers)
          r.set(_[0], _[1]);
      let l = null;
      return s.proto ? g : u;
      function i(_, w) {
        const p = Object.keys(_), f = new Array(p.length);
        for (let h = 0; h < p.length; h++) {
          const m = p[h], d = _[m];
          typeof d != "object" || d === null ? f[m] = d : d.constructor !== Object && (l = r.get(d.constructor)) ? f[m] = l(d, w) : ArrayBuffer.isView(d) ? f[m] = n(d) : f[m] = w(d);
        }
        return f;
      }
      function u(_) {
        if (typeof _ != "object" || _ === null) return _;
        if (Array.isArray(_)) return i(_, u);
        if (_.constructor !== Object && (l = r.get(_.constructor)))
          return l(_, u);
        const w = {};
        for (const p in _) {
          if (Object.hasOwnProperty.call(_, p) === !1) continue;
          const f = _[p];
          typeof f != "object" || f === null ? w[p] = f : f.constructor !== Object && (l = r.get(f.constructor)) ? w[p] = l(f, u) : ArrayBuffer.isView(f) ? w[p] = n(f) : w[p] = u(f);
        }
        return w;
      }
      function g(_) {
        if (typeof _ != "object" || _ === null) return _;
        if (Array.isArray(_)) return i(_, g);
        if (_.constructor !== Object && (l = r.get(_.constructor)))
          return l(_, g);
        const w = {};
        for (const p in _) {
          const f = _[p];
          typeof f != "object" || f === null ? w[p] = f : f.constructor !== Object && (l = r.get(f.constructor)) ? w[p] = l(f, g) : ArrayBuffer.isView(f) ? w[p] = n(f) : w[p] = g(f);
        }
        return w;
      }
    }
    function a(s) {
      const r = [], l = [], i = /* @__PURE__ */ new Map();
      if (i.set(Date, (p) => new Date(p)), i.set(Map, (p, f) => new Map(g(Array.from(p), f))), i.set(Set, (p, f) => new Set(g(Array.from(p), f))), s.constructorHandlers)
        for (const p of s.constructorHandlers)
          i.set(p[0], p[1]);
      let u = null;
      return s.proto ? w : _;
      function g(p, f) {
        const h = Object.keys(p), m = new Array(h.length);
        for (let d = 0; d < h.length; d++) {
          const c = h[d], y = p[c];
          if (typeof y != "object" || y === null)
            m[c] = y;
          else if (y.constructor !== Object && (u = i.get(y.constructor)))
            m[c] = u(y, f);
          else if (ArrayBuffer.isView(y))
            m[c] = n(y);
          else {
            const A = r.indexOf(y);
            A !== -1 ? m[c] = l[A] : m[c] = f(y);
          }
        }
        return m;
      }
      function _(p) {
        if (typeof p != "object" || p === null) return p;
        if (Array.isArray(p)) return g(p, _);
        if (p.constructor !== Object && (u = i.get(p.constructor)))
          return u(p, _);
        const f = {};
        r.push(p), l.push(f);
        for (const h in p) {
          if (Object.hasOwnProperty.call(p, h) === !1) continue;
          const m = p[h];
          if (typeof m != "object" || m === null)
            f[h] = m;
          else if (m.constructor !== Object && (u = i.get(m.constructor)))
            f[h] = u(m, _);
          else if (ArrayBuffer.isView(m))
            f[h] = n(m);
          else {
            const d = r.indexOf(m);
            d !== -1 ? f[h] = l[d] : f[h] = _(m);
          }
        }
        return r.pop(), l.pop(), f;
      }
      function w(p) {
        if (typeof p != "object" || p === null) return p;
        if (Array.isArray(p)) return g(p, w);
        if (p.constructor !== Object && (u = i.get(p.constructor)))
          return u(p, w);
        const f = {};
        r.push(p), l.push(f);
        for (const h in p) {
          const m = p[h];
          if (typeof m != "object" || m === null)
            f[h] = m;
          else if (m.constructor !== Object && (u = i.get(m.constructor)))
            f[h] = u(m, w);
          else if (ArrayBuffer.isView(m))
            f[h] = n(m);
          else {
            const d = r.indexOf(m);
            d !== -1 ? f[h] = l[d] : f[h] = w(m);
          }
        }
        return r.pop(), l.pop(), f;
      }
    }
  }
});
ht();
ht();
ht();
var oa = typeof navigator < "u", F = typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : {};
typeof F.chrome < "u" && F.chrome.devtools;
oa && (F.self, F.top);
var Nn;
typeof navigator < "u" && ((Nn = navigator.userAgent) == null || Nn.toLowerCase().includes("electron"));
ht();
var Ts = As(ks()), Os = /(?:^|[-_/])(\w)/g;
function Ps(e, t) {
  return t ? t.toUpperCase() : "";
}
function Ms(e) {
  return e && `${e}`.replace(Os, Ps);
}
function Fs(e, t) {
  let n = e.replace(/^[a-z]:/i, "").replace(/\\/g, "/");
  n.endsWith(`index${t}`) && (n = n.replace(`/index${t}`, t));
  const o = n.lastIndexOf("/"), a = n.substring(o + 1);
  {
    const s = a.lastIndexOf(t);
    return a.substring(0, s);
  }
}
var $n = (0, Ts.default)({ circles: !0 });
const Bs = {
  trailing: !0
};
function Xe(e, t = 25, n = {}) {
  if (n = { ...Bs, ...n }, !Number.isFinite(t))
    throw new TypeError("Expected `wait` to be a finite number");
  let o, a, s = [], r, l;
  const i = (u, g) => (r = Ds(e, u, g), r.finally(() => {
    if (r = null, n.trailing && l && !a) {
      const _ = i(u, l);
      return l = null, _;
    }
  }), r);
  return function(...u) {
    return r ? (n.trailing && (l = u), r) : new Promise((g) => {
      const _ = !a && n.leading;
      clearTimeout(a), a = setTimeout(() => {
        a = null;
        const w = n.leading ? o : i(this, u);
        for (const p of s)
          p(w);
        s = [];
      }, t), _ ? (o = i(this, u), g(o)) : s.push(g);
    });
  };
}
async function Ds(e, t, n) {
  return await e.apply(t, n);
}
function Zt(e, t = {}, n) {
  for (const o in e) {
    const a = e[o], s = n ? `${n}:${o}` : o;
    typeof a == "object" && a !== null ? Zt(a, t, s) : typeof a == "function" && (t[s] = a);
  }
  return t;
}
const Ls = { run: (e) => e() }, Rs = () => Ls, aa = typeof console.createTask < "u" ? console.createTask : Rs;
function xs(e, t) {
  const n = t.shift(), o = aa(n);
  return e.reduce(
    (a, s) => a.then(() => o.run(() => s(...t))),
    Promise.resolve()
  );
}
function Is(e, t) {
  const n = t.shift(), o = aa(n);
  return Promise.all(e.map((a) => o.run(() => a(...t))));
}
function Ut(e, t) {
  for (const n of [...e])
    n(t);
}
class Ns {
  constructor() {
    this._hooks = {}, this._before = void 0, this._after = void 0, this._deprecatedMessages = void 0, this._deprecatedHooks = {}, this.hook = this.hook.bind(this), this.callHook = this.callHook.bind(this), this.callHookWith = this.callHookWith.bind(this);
  }
  hook(t, n, o = {}) {
    if (!t || typeof n != "function")
      return () => {
      };
    const a = t;
    let s;
    for (; this._deprecatedHooks[t]; )
      s = this._deprecatedHooks[t], t = s.to;
    if (s && !o.allowDeprecated) {
      let r = s.message;
      r || (r = `${a} hook has been deprecated` + (s.to ? `, please use ${s.to}` : "")), this._deprecatedMessages || (this._deprecatedMessages = /* @__PURE__ */ new Set()), this._deprecatedMessages.has(r) || (console.warn(r), this._deprecatedMessages.add(r));
    }
    if (!n.name)
      try {
        Object.defineProperty(n, "name", {
          get: () => "_" + t.replace(/\W+/g, "_") + "_hook_cb",
          configurable: !0
        });
      } catch {
      }
    return this._hooks[t] = this._hooks[t] || [], this._hooks[t].push(n), () => {
      n && (this.removeHook(t, n), n = void 0);
    };
  }
  hookOnce(t, n) {
    let o, a = (...s) => (typeof o == "function" && o(), o = void 0, a = void 0, n(...s));
    return o = this.hook(t, a), o;
  }
  removeHook(t, n) {
    if (this._hooks[t]) {
      const o = this._hooks[t].indexOf(n);
      o !== -1 && this._hooks[t].splice(o, 1), this._hooks[t].length === 0 && delete this._hooks[t];
    }
  }
  deprecateHook(t, n) {
    this._deprecatedHooks[t] = typeof n == "string" ? { to: n } : n;
    const o = this._hooks[t] || [];
    delete this._hooks[t];
    for (const a of o)
      this.hook(t, a);
  }
  deprecateHooks(t) {
    Object.assign(this._deprecatedHooks, t);
    for (const n in t)
      this.deprecateHook(n, t[n]);
  }
  addHooks(t) {
    const n = Zt(t), o = Object.keys(n).map(
      (a) => this.hook(a, n[a])
    );
    return () => {
      for (const a of o.splice(0, o.length))
        a();
    };
  }
  removeHooks(t) {
    const n = Zt(t);
    for (const o in n)
      this.removeHook(o, n[o]);
  }
  removeAllHooks() {
    for (const t in this._hooks)
      delete this._hooks[t];
  }
  callHook(t, ...n) {
    return n.unshift(t), this.callHookWith(xs, t, ...n);
  }
  callHookParallel(t, ...n) {
    return n.unshift(t), this.callHookWith(Is, t, ...n);
  }
  callHookWith(t, n, ...o) {
    const a = this._before || this._after ? { name: n, args: o, context: {} } : void 0;
    this._before && Ut(this._before, a);
    const s = t(
      n in this._hooks ? [...this._hooks[n]] : [],
      o
    );
    return s instanceof Promise ? s.finally(() => {
      this._after && a && Ut(this._after, a);
    }) : (this._after && a && Ut(this._after, a), s);
  }
  beforeEach(t) {
    return this._before = this._before || [], this._before.push(t), () => {
      if (this._before !== void 0) {
        const n = this._before.indexOf(t);
        n !== -1 && this._before.splice(n, 1);
      }
    };
  }
  afterEach(t) {
    return this._after = this._after || [], this._after.push(t), () => {
      if (this._after !== void 0) {
        const n = this._after.indexOf(t);
        n !== -1 && this._after.splice(n, 1);
      }
    };
  }
}
function sa() {
  return new Ns();
}
var $s = Object.create, ra = Object.defineProperty, Vs = Object.getOwnPropertyDescriptor, bn = Object.getOwnPropertyNames, Us = Object.getPrototypeOf, Gs = Object.prototype.hasOwnProperty, Hs = (e, t) => function() {
  return e && (t = (0, e[bn(e)[0]])(e = 0)), t;
}, la = (e, t) => function() {
  return t || (0, e[bn(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, Ws = (e, t, n, o) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let a of bn(t))
      !Gs.call(e, a) && a !== n && ra(e, a, { get: () => t[a], enumerable: !(o = Vs(t, a)) || o.enumerable });
  return e;
}, zs = (e, t, n) => (n = e != null ? $s(Us(e)) : {}, Ws(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  ra(n, "default", { value: e, enumerable: !0 }),
  e
)), E = Hs({
  "../../node_modules/.pnpm/tsup@8.4.0_@microsoft+api-extractor@7.51.1_@types+node@22.13.14__jiti@2.4.2_postcss@8.5_96eb05a9d65343021e53791dd83f3773/node_modules/tsup/assets/esm_shims.js"() {
  }
}), Ks = la({
  "../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/lib/speakingurl.js"(e, t) {
    E(), (function(n) {
      var o = {
        // latin
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "Ae",
        Å: "A",
        Æ: "AE",
        Ç: "C",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        Ð: "D",
        Ñ: "N",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "Oe",
        Ő: "O",
        Ø: "O",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "Ue",
        Ű: "U",
        Ý: "Y",
        Þ: "TH",
        ß: "ss",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "ae",
        å: "a",
        æ: "ae",
        ç: "c",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        ð: "d",
        ñ: "n",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "oe",
        ő: "o",
        ø: "o",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "ue",
        ű: "u",
        ý: "y",
        þ: "th",
        ÿ: "y",
        "ẞ": "SS",
        // language specific
        // Arabic
        ا: "a",
        أ: "a",
        إ: "i",
        آ: "aa",
        ؤ: "u",
        ئ: "e",
        ء: "a",
        ب: "b",
        ت: "t",
        ث: "th",
        ج: "j",
        ح: "h",
        خ: "kh",
        د: "d",
        ذ: "th",
        ر: "r",
        ز: "z",
        س: "s",
        ش: "sh",
        ص: "s",
        ض: "dh",
        ط: "t",
        ظ: "z",
        ع: "a",
        غ: "gh",
        ف: "f",
        ق: "q",
        ك: "k",
        ل: "l",
        م: "m",
        ن: "n",
        ه: "h",
        و: "w",
        ي: "y",
        ى: "a",
        ة: "h",
        ﻻ: "la",
        ﻷ: "laa",
        ﻹ: "lai",
        ﻵ: "laa",
        // Persian additional characters than Arabic
        گ: "g",
        چ: "ch",
        پ: "p",
        ژ: "zh",
        ک: "k",
        ی: "y",
        // Arabic diactrics
        "َ": "a",
        "ً": "an",
        "ِ": "e",
        "ٍ": "en",
        "ُ": "u",
        "ٌ": "on",
        "ْ": "",
        // Arabic numbers
        "٠": "0",
        "١": "1",
        "٢": "2",
        "٣": "3",
        "٤": "4",
        "٥": "5",
        "٦": "6",
        "٧": "7",
        "٨": "8",
        "٩": "9",
        // Persian numbers
        "۰": "0",
        "۱": "1",
        "۲": "2",
        "۳": "3",
        "۴": "4",
        "۵": "5",
        "۶": "6",
        "۷": "7",
        "۸": "8",
        "۹": "9",
        // Burmese consonants
        က: "k",
        ခ: "kh",
        ဂ: "g",
        ဃ: "ga",
        င: "ng",
        စ: "s",
        ဆ: "sa",
        ဇ: "z",
        "စျ": "za",
        ည: "ny",
        ဋ: "t",
        ဌ: "ta",
        ဍ: "d",
        ဎ: "da",
        ဏ: "na",
        တ: "t",
        ထ: "ta",
        ဒ: "d",
        ဓ: "da",
        န: "n",
        ပ: "p",
        ဖ: "pa",
        ဗ: "b",
        ဘ: "ba",
        မ: "m",
        ယ: "y",
        ရ: "ya",
        လ: "l",
        ဝ: "w",
        သ: "th",
        ဟ: "h",
        ဠ: "la",
        အ: "a",
        // consonant character combos
        "ြ": "y",
        "ျ": "ya",
        "ွ": "w",
        "ြွ": "yw",
        "ျွ": "ywa",
        "ှ": "h",
        // independent vowels
        ဧ: "e",
        "၏": "-e",
        ဣ: "i",
        ဤ: "-i",
        ဉ: "u",
        ဦ: "-u",
        ဩ: "aw",
        "သြော": "aw",
        ဪ: "aw",
        // numbers
        "၀": "0",
        "၁": "1",
        "၂": "2",
        "၃": "3",
        "၄": "4",
        "၅": "5",
        "၆": "6",
        "၇": "7",
        "၈": "8",
        "၉": "9",
        // virama and tone marks which are silent in transliteration
        "္": "",
        "့": "",
        "း": "",
        // Czech
        č: "c",
        ď: "d",
        ě: "e",
        ň: "n",
        ř: "r",
        š: "s",
        ť: "t",
        ů: "u",
        ž: "z",
        Č: "C",
        Ď: "D",
        Ě: "E",
        Ň: "N",
        Ř: "R",
        Š: "S",
        Ť: "T",
        Ů: "U",
        Ž: "Z",
        // Dhivehi
        ހ: "h",
        ށ: "sh",
        ނ: "n",
        ރ: "r",
        ބ: "b",
        ޅ: "lh",
        ކ: "k",
        އ: "a",
        ވ: "v",
        މ: "m",
        ފ: "f",
        ދ: "dh",
        ތ: "th",
        ލ: "l",
        ގ: "g",
        ޏ: "gn",
        ސ: "s",
        ޑ: "d",
        ޒ: "z",
        ޓ: "t",
        ޔ: "y",
        ޕ: "p",
        ޖ: "j",
        ޗ: "ch",
        ޘ: "tt",
        ޙ: "hh",
        ޚ: "kh",
        ޛ: "th",
        ޜ: "z",
        ޝ: "sh",
        ޞ: "s",
        ޟ: "d",
        ޠ: "t",
        ޡ: "z",
        ޢ: "a",
        ޣ: "gh",
        ޤ: "q",
        ޥ: "w",
        "ަ": "a",
        "ާ": "aa",
        "ި": "i",
        "ީ": "ee",
        "ު": "u",
        "ޫ": "oo",
        "ެ": "e",
        "ޭ": "ey",
        "ޮ": "o",
        "ޯ": "oa",
        "ް": "",
        // Georgian https://en.wikipedia.org/wiki/Romanization_of_Georgian
        // National system (2002)
        ა: "a",
        ბ: "b",
        გ: "g",
        დ: "d",
        ე: "e",
        ვ: "v",
        ზ: "z",
        თ: "t",
        ი: "i",
        კ: "k",
        ლ: "l",
        მ: "m",
        ნ: "n",
        ო: "o",
        პ: "p",
        ჟ: "zh",
        რ: "r",
        ს: "s",
        ტ: "t",
        უ: "u",
        ფ: "p",
        ქ: "k",
        ღ: "gh",
        ყ: "q",
        შ: "sh",
        ჩ: "ch",
        ც: "ts",
        ძ: "dz",
        წ: "ts",
        ჭ: "ch",
        ხ: "kh",
        ჯ: "j",
        ჰ: "h",
        // Greek
        α: "a",
        β: "v",
        γ: "g",
        δ: "d",
        ε: "e",
        ζ: "z",
        η: "i",
        θ: "th",
        ι: "i",
        κ: "k",
        λ: "l",
        μ: "m",
        ν: "n",
        ξ: "ks",
        ο: "o",
        π: "p",
        ρ: "r",
        σ: "s",
        τ: "t",
        υ: "y",
        φ: "f",
        χ: "x",
        ψ: "ps",
        ω: "o",
        ά: "a",
        έ: "e",
        ί: "i",
        ό: "o",
        ύ: "y",
        ή: "i",
        ώ: "o",
        ς: "s",
        ϊ: "i",
        ΰ: "y",
        ϋ: "y",
        ΐ: "i",
        Α: "A",
        Β: "B",
        Γ: "G",
        Δ: "D",
        Ε: "E",
        Ζ: "Z",
        Η: "I",
        Θ: "TH",
        Ι: "I",
        Κ: "K",
        Λ: "L",
        Μ: "M",
        Ν: "N",
        Ξ: "KS",
        Ο: "O",
        Π: "P",
        Ρ: "R",
        Σ: "S",
        Τ: "T",
        Υ: "Y",
        Φ: "F",
        Χ: "X",
        Ψ: "PS",
        Ω: "O",
        Ά: "A",
        Έ: "E",
        Ί: "I",
        Ό: "O",
        Ύ: "Y",
        Ή: "I",
        Ώ: "O",
        Ϊ: "I",
        Ϋ: "Y",
        // Latvian
        ā: "a",
        // 'č': 'c', // duplicate
        ē: "e",
        ģ: "g",
        ī: "i",
        ķ: "k",
        ļ: "l",
        ņ: "n",
        // 'š': 's', // duplicate
        ū: "u",
        // 'ž': 'z', // duplicate
        Ā: "A",
        // 'Č': 'C', // duplicate
        Ē: "E",
        Ģ: "G",
        Ī: "I",
        Ķ: "k",
        Ļ: "L",
        Ņ: "N",
        // 'Š': 'S', // duplicate
        Ū: "U",
        // 'Ž': 'Z', // duplicate
        // Macedonian
        Ќ: "Kj",
        ќ: "kj",
        Љ: "Lj",
        љ: "lj",
        Њ: "Nj",
        њ: "nj",
        Тс: "Ts",
        тс: "ts",
        // Polish
        ą: "a",
        ć: "c",
        ę: "e",
        ł: "l",
        ń: "n",
        // 'ó': 'o', // duplicate
        ś: "s",
        ź: "z",
        ż: "z",
        Ą: "A",
        Ć: "C",
        Ę: "E",
        Ł: "L",
        Ń: "N",
        Ś: "S",
        Ź: "Z",
        Ż: "Z",
        // Ukranian
        Є: "Ye",
        І: "I",
        Ї: "Yi",
        Ґ: "G",
        є: "ye",
        і: "i",
        ї: "yi",
        ґ: "g",
        // Romanian
        ă: "a",
        Ă: "A",
        ș: "s",
        Ș: "S",
        // 'ş': 's', // duplicate
        // 'Ş': 'S', // duplicate
        ț: "t",
        Ț: "T",
        ţ: "t",
        Ţ: "T",
        // Russian https://en.wikipedia.org/wiki/Romanization_of_Russian
        // ICAO
        а: "a",
        б: "b",
        в: "v",
        г: "g",
        д: "d",
        е: "e",
        ё: "yo",
        ж: "zh",
        з: "z",
        и: "i",
        й: "i",
        к: "k",
        л: "l",
        м: "m",
        н: "n",
        о: "o",
        п: "p",
        р: "r",
        с: "s",
        т: "t",
        у: "u",
        ф: "f",
        х: "kh",
        ц: "c",
        ч: "ch",
        ш: "sh",
        щ: "sh",
        ъ: "",
        ы: "y",
        ь: "",
        э: "e",
        ю: "yu",
        я: "ya",
        А: "A",
        Б: "B",
        В: "V",
        Г: "G",
        Д: "D",
        Е: "E",
        Ё: "Yo",
        Ж: "Zh",
        З: "Z",
        И: "I",
        Й: "I",
        К: "K",
        Л: "L",
        М: "M",
        Н: "N",
        О: "O",
        П: "P",
        Р: "R",
        С: "S",
        Т: "T",
        У: "U",
        Ф: "F",
        Х: "Kh",
        Ц: "C",
        Ч: "Ch",
        Ш: "Sh",
        Щ: "Sh",
        Ъ: "",
        Ы: "Y",
        Ь: "",
        Э: "E",
        Ю: "Yu",
        Я: "Ya",
        // Serbian
        ђ: "dj",
        ј: "j",
        // 'љ': 'lj',  // duplicate
        // 'њ': 'nj', // duplicate
        ћ: "c",
        џ: "dz",
        Ђ: "Dj",
        Ј: "j",
        // 'Љ': 'Lj', // duplicate
        // 'Њ': 'Nj', // duplicate
        Ћ: "C",
        Џ: "Dz",
        // Slovak
        ľ: "l",
        ĺ: "l",
        ŕ: "r",
        Ľ: "L",
        Ĺ: "L",
        Ŕ: "R",
        // Turkish
        ş: "s",
        Ş: "S",
        ı: "i",
        İ: "I",
        // 'ç': 'c', // duplicate
        // 'Ç': 'C', // duplicate
        // 'ü': 'u', // duplicate, see langCharMap
        // 'Ü': 'U', // duplicate, see langCharMap
        // 'ö': 'o', // duplicate, see langCharMap
        // 'Ö': 'O', // duplicate, see langCharMap
        ğ: "g",
        Ğ: "G",
        // Vietnamese
        ả: "a",
        Ả: "A",
        ẳ: "a",
        Ẳ: "A",
        ẩ: "a",
        Ẩ: "A",
        đ: "d",
        Đ: "D",
        ẹ: "e",
        Ẹ: "E",
        ẽ: "e",
        Ẽ: "E",
        ẻ: "e",
        Ẻ: "E",
        ế: "e",
        Ế: "E",
        ề: "e",
        Ề: "E",
        ệ: "e",
        Ệ: "E",
        ễ: "e",
        Ễ: "E",
        ể: "e",
        Ể: "E",
        ỏ: "o",
        ọ: "o",
        Ọ: "o",
        ố: "o",
        Ố: "O",
        ồ: "o",
        Ồ: "O",
        ổ: "o",
        Ổ: "O",
        ộ: "o",
        Ộ: "O",
        ỗ: "o",
        Ỗ: "O",
        ơ: "o",
        Ơ: "O",
        ớ: "o",
        Ớ: "O",
        ờ: "o",
        Ờ: "O",
        ợ: "o",
        Ợ: "O",
        ỡ: "o",
        Ỡ: "O",
        Ở: "o",
        ở: "o",
        ị: "i",
        Ị: "I",
        ĩ: "i",
        Ĩ: "I",
        ỉ: "i",
        Ỉ: "i",
        ủ: "u",
        Ủ: "U",
        ụ: "u",
        Ụ: "U",
        ũ: "u",
        Ũ: "U",
        ư: "u",
        Ư: "U",
        ứ: "u",
        Ứ: "U",
        ừ: "u",
        Ừ: "U",
        ự: "u",
        Ự: "U",
        ữ: "u",
        Ữ: "U",
        ử: "u",
        Ử: "ư",
        ỷ: "y",
        Ỷ: "y",
        ỳ: "y",
        Ỳ: "Y",
        ỵ: "y",
        Ỵ: "Y",
        ỹ: "y",
        Ỹ: "Y",
        ạ: "a",
        Ạ: "A",
        ấ: "a",
        Ấ: "A",
        ầ: "a",
        Ầ: "A",
        ậ: "a",
        Ậ: "A",
        ẫ: "a",
        Ẫ: "A",
        // 'ă': 'a', // duplicate
        // 'Ă': 'A', // duplicate
        ắ: "a",
        Ắ: "A",
        ằ: "a",
        Ằ: "A",
        ặ: "a",
        Ặ: "A",
        ẵ: "a",
        Ẵ: "A",
        "⓪": "0",
        "①": "1",
        "②": "2",
        "③": "3",
        "④": "4",
        "⑤": "5",
        "⑥": "6",
        "⑦": "7",
        "⑧": "8",
        "⑨": "9",
        "⑩": "10",
        "⑪": "11",
        "⑫": "12",
        "⑬": "13",
        "⑭": "14",
        "⑮": "15",
        "⑯": "16",
        "⑰": "17",
        "⑱": "18",
        "⑲": "18",
        "⑳": "18",
        "⓵": "1",
        "⓶": "2",
        "⓷": "3",
        "⓸": "4",
        "⓹": "5",
        "⓺": "6",
        "⓻": "7",
        "⓼": "8",
        "⓽": "9",
        "⓾": "10",
        "⓿": "0",
        "⓫": "11",
        "⓬": "12",
        "⓭": "13",
        "⓮": "14",
        "⓯": "15",
        "⓰": "16",
        "⓱": "17",
        "⓲": "18",
        "⓳": "19",
        "⓴": "20",
        "Ⓐ": "A",
        "Ⓑ": "B",
        "Ⓒ": "C",
        "Ⓓ": "D",
        "Ⓔ": "E",
        "Ⓕ": "F",
        "Ⓖ": "G",
        "Ⓗ": "H",
        "Ⓘ": "I",
        "Ⓙ": "J",
        "Ⓚ": "K",
        "Ⓛ": "L",
        "Ⓜ": "M",
        "Ⓝ": "N",
        "Ⓞ": "O",
        "Ⓟ": "P",
        "Ⓠ": "Q",
        "Ⓡ": "R",
        "Ⓢ": "S",
        "Ⓣ": "T",
        "Ⓤ": "U",
        "Ⓥ": "V",
        "Ⓦ": "W",
        "Ⓧ": "X",
        "Ⓨ": "Y",
        "Ⓩ": "Z",
        "ⓐ": "a",
        "ⓑ": "b",
        "ⓒ": "c",
        "ⓓ": "d",
        "ⓔ": "e",
        "ⓕ": "f",
        "ⓖ": "g",
        "ⓗ": "h",
        "ⓘ": "i",
        "ⓙ": "j",
        "ⓚ": "k",
        "ⓛ": "l",
        "ⓜ": "m",
        "ⓝ": "n",
        "ⓞ": "o",
        "ⓟ": "p",
        "ⓠ": "q",
        "ⓡ": "r",
        "ⓢ": "s",
        "ⓣ": "t",
        "ⓤ": "u",
        "ⓦ": "v",
        "ⓥ": "w",
        "ⓧ": "x",
        "ⓨ": "y",
        "ⓩ": "z",
        // symbols
        "“": '"',
        "”": '"',
        "‘": "'",
        "’": "'",
        "∂": "d",
        ƒ: "f",
        "™": "(TM)",
        "©": "(C)",
        œ: "oe",
        Œ: "OE",
        "®": "(R)",
        "†": "+",
        "℠": "(SM)",
        "…": "...",
        "˚": "o",
        º: "o",
        ª: "a",
        "•": "*",
        "၊": ",",
        "။": ".",
        // currency
        $: "USD",
        "€": "EUR",
        "₢": "BRN",
        "₣": "FRF",
        "£": "GBP",
        "₤": "ITL",
        "₦": "NGN",
        "₧": "ESP",
        "₩": "KRW",
        "₪": "ILS",
        "₫": "VND",
        "₭": "LAK",
        "₮": "MNT",
        "₯": "GRD",
        "₱": "ARS",
        "₲": "PYG",
        "₳": "ARA",
        "₴": "UAH",
        "₵": "GHS",
        "¢": "cent",
        "¥": "CNY",
        元: "CNY",
        円: "YEN",
        "﷼": "IRR",
        "₠": "EWE",
        "฿": "THB",
        "₨": "INR",
        "₹": "INR",
        "₰": "PF",
        "₺": "TRY",
        "؋": "AFN",
        "₼": "AZN",
        лв: "BGN",
        "៛": "KHR",
        "₡": "CRC",
        "₸": "KZT",
        ден: "MKD",
        zł: "PLN",
        "₽": "RUB",
        "₾": "GEL"
      }, a = [
        // burmese
        "်",
        // Dhivehi
        "ް"
      ], s = {
        // Burmese
        // dependent vowels
        "ာ": "a",
        "ါ": "a",
        "ေ": "e",
        "ဲ": "e",
        "ိ": "i",
        "ီ": "i",
        "ို": "o",
        "ု": "u",
        "ူ": "u",
        "ေါင်": "aung",
        "ော": "aw",
        "ော်": "aw",
        "ေါ": "aw",
        "ေါ်": "aw",
        "်": "်",
        // this is special case but the character will be converted to latin in the code
        "က်": "et",
        "ိုက်": "aik",
        "ောက်": "auk",
        "င်": "in",
        "ိုင်": "aing",
        "ောင်": "aung",
        "စ်": "it",
        "ည်": "i",
        "တ်": "at",
        "ိတ်": "eik",
        "ုတ်": "ok",
        "ွတ်": "ut",
        "ေတ်": "it",
        "ဒ်": "d",
        "ိုဒ်": "ok",
        "ုဒ်": "ait",
        "န်": "an",
        "ာန်": "an",
        "ိန်": "ein",
        "ုန်": "on",
        "ွန်": "un",
        "ပ်": "at",
        "ိပ်": "eik",
        "ုပ်": "ok",
        "ွပ်": "ut",
        "န်ုပ်": "nub",
        "မ်": "an",
        "ိမ်": "ein",
        "ုမ်": "on",
        "ွမ်": "un",
        "ယ်": "e",
        "ိုလ်": "ol",
        "ဉ်": "in",
        "ံ": "an",
        "ိံ": "ein",
        "ုံ": "on",
        // Dhivehi
        "ައް": "ah",
        "ަށް": "ah"
      }, r = {
        en: {},
        // default language
        az: {
          // Azerbaijani
          ç: "c",
          ə: "e",
          ğ: "g",
          ı: "i",
          ö: "o",
          ş: "s",
          ü: "u",
          Ç: "C",
          Ə: "E",
          Ğ: "G",
          İ: "I",
          Ö: "O",
          Ş: "S",
          Ü: "U"
        },
        cs: {
          // Czech
          č: "c",
          ď: "d",
          ě: "e",
          ň: "n",
          ř: "r",
          š: "s",
          ť: "t",
          ů: "u",
          ž: "z",
          Č: "C",
          Ď: "D",
          Ě: "E",
          Ň: "N",
          Ř: "R",
          Š: "S",
          Ť: "T",
          Ů: "U",
          Ž: "Z"
        },
        fi: {
          // Finnish
          // 'å': 'a', duplicate see charMap/latin
          // 'Å': 'A', duplicate see charMap/latin
          ä: "a",
          // ok
          Ä: "A",
          // ok
          ö: "o",
          // ok
          Ö: "O"
          // ok
        },
        hu: {
          // Hungarian
          ä: "a",
          // ok
          Ä: "A",
          // ok
          // 'á': 'a', duplicate see charMap/latin
          // 'Á': 'A', duplicate see charMap/latin
          ö: "o",
          // ok
          Ö: "O",
          // ok
          // 'ő': 'o', duplicate see charMap/latin
          // 'Ő': 'O', duplicate see charMap/latin
          ü: "u",
          Ü: "U",
          ű: "u",
          Ű: "U"
        },
        lt: {
          // Lithuanian
          ą: "a",
          č: "c",
          ę: "e",
          ė: "e",
          į: "i",
          š: "s",
          ų: "u",
          ū: "u",
          ž: "z",
          Ą: "A",
          Č: "C",
          Ę: "E",
          Ė: "E",
          Į: "I",
          Š: "S",
          Ų: "U",
          Ū: "U"
        },
        lv: {
          // Latvian
          ā: "a",
          č: "c",
          ē: "e",
          ģ: "g",
          ī: "i",
          ķ: "k",
          ļ: "l",
          ņ: "n",
          š: "s",
          ū: "u",
          ž: "z",
          Ā: "A",
          Č: "C",
          Ē: "E",
          Ģ: "G",
          Ī: "i",
          Ķ: "k",
          Ļ: "L",
          Ņ: "N",
          Š: "S",
          Ū: "u",
          Ž: "Z"
        },
        pl: {
          // Polish
          ą: "a",
          ć: "c",
          ę: "e",
          ł: "l",
          ń: "n",
          ó: "o",
          ś: "s",
          ź: "z",
          ż: "z",
          Ą: "A",
          Ć: "C",
          Ę: "e",
          Ł: "L",
          Ń: "N",
          Ó: "O",
          Ś: "S",
          Ź: "Z",
          Ż: "Z"
        },
        sv: {
          // Swedish
          // 'å': 'a', duplicate see charMap/latin
          // 'Å': 'A', duplicate see charMap/latin
          ä: "a",
          // ok
          Ä: "A",
          // ok
          ö: "o",
          // ok
          Ö: "O"
          // ok
        },
        sk: {
          // Slovak
          ä: "a",
          Ä: "A"
        },
        sr: {
          // Serbian
          љ: "lj",
          њ: "nj",
          Љ: "Lj",
          Њ: "Nj",
          đ: "dj",
          Đ: "Dj"
        },
        tr: {
          // Turkish
          Ü: "U",
          Ö: "O",
          ü: "u",
          ö: "o"
        }
      }, l = {
        ar: {
          "∆": "delta",
          "∞": "la-nihaya",
          "♥": "hob",
          "&": "wa",
          "|": "aw",
          "<": "aqal-men",
          ">": "akbar-men",
          "∑": "majmou",
          "¤": "omla"
        },
        az: {},
        ca: {
          "∆": "delta",
          "∞": "infinit",
          "♥": "amor",
          "&": "i",
          "|": "o",
          "<": "menys que",
          ">": "mes que",
          "∑": "suma dels",
          "¤": "moneda"
        },
        cs: {
          "∆": "delta",
          "∞": "nekonecno",
          "♥": "laska",
          "&": "a",
          "|": "nebo",
          "<": "mensi nez",
          ">": "vetsi nez",
          "∑": "soucet",
          "¤": "mena"
        },
        de: {
          "∆": "delta",
          "∞": "unendlich",
          "♥": "Liebe",
          "&": "und",
          "|": "oder",
          "<": "kleiner als",
          ">": "groesser als",
          "∑": "Summe von",
          "¤": "Waehrung"
        },
        dv: {
          "∆": "delta",
          "∞": "kolunulaa",
          "♥": "loabi",
          "&": "aai",
          "|": "noonee",
          "<": "ah vure kuda",
          ">": "ah vure bodu",
          "∑": "jumula",
          "¤": "faisaa"
        },
        en: {
          "∆": "delta",
          "∞": "infinity",
          "♥": "love",
          "&": "and",
          "|": "or",
          "<": "less than",
          ">": "greater than",
          "∑": "sum",
          "¤": "currency"
        },
        es: {
          "∆": "delta",
          "∞": "infinito",
          "♥": "amor",
          "&": "y",
          "|": "u",
          "<": "menos que",
          ">": "mas que",
          "∑": "suma de los",
          "¤": "moneda"
        },
        fa: {
          "∆": "delta",
          "∞": "bi-nahayat",
          "♥": "eshgh",
          "&": "va",
          "|": "ya",
          "<": "kamtar-az",
          ">": "bishtar-az",
          "∑": "majmooe",
          "¤": "vahed"
        },
        fi: {
          "∆": "delta",
          "∞": "aarettomyys",
          "♥": "rakkaus",
          "&": "ja",
          "|": "tai",
          "<": "pienempi kuin",
          ">": "suurempi kuin",
          "∑": "summa",
          "¤": "valuutta"
        },
        fr: {
          "∆": "delta",
          "∞": "infiniment",
          "♥": "Amour",
          "&": "et",
          "|": "ou",
          "<": "moins que",
          ">": "superieure a",
          "∑": "somme des",
          "¤": "monnaie"
        },
        ge: {
          "∆": "delta",
          "∞": "usasruloba",
          "♥": "siqvaruli",
          "&": "da",
          "|": "an",
          "<": "naklebi",
          ">": "meti",
          "∑": "jami",
          "¤": "valuta"
        },
        gr: {},
        hu: {
          "∆": "delta",
          "∞": "vegtelen",
          "♥": "szerelem",
          "&": "es",
          "|": "vagy",
          "<": "kisebb mint",
          ">": "nagyobb mint",
          "∑": "szumma",
          "¤": "penznem"
        },
        it: {
          "∆": "delta",
          "∞": "infinito",
          "♥": "amore",
          "&": "e",
          "|": "o",
          "<": "minore di",
          ">": "maggiore di",
          "∑": "somma",
          "¤": "moneta"
        },
        lt: {
          "∆": "delta",
          "∞": "begalybe",
          "♥": "meile",
          "&": "ir",
          "|": "ar",
          "<": "maziau nei",
          ">": "daugiau nei",
          "∑": "suma",
          "¤": "valiuta"
        },
        lv: {
          "∆": "delta",
          "∞": "bezgaliba",
          "♥": "milestiba",
          "&": "un",
          "|": "vai",
          "<": "mazak neka",
          ">": "lielaks neka",
          "∑": "summa",
          "¤": "valuta"
        },
        my: {
          "∆": "kwahkhyaet",
          "∞": "asaonasme",
          "♥": "akhyait",
          "&": "nhin",
          "|": "tho",
          "<": "ngethaw",
          ">": "kyithaw",
          "∑": "paungld",
          "¤": "ngwekye"
        },
        mk: {},
        nl: {
          "∆": "delta",
          "∞": "oneindig",
          "♥": "liefde",
          "&": "en",
          "|": "of",
          "<": "kleiner dan",
          ">": "groter dan",
          "∑": "som",
          "¤": "valuta"
        },
        pl: {
          "∆": "delta",
          "∞": "nieskonczonosc",
          "♥": "milosc",
          "&": "i",
          "|": "lub",
          "<": "mniejsze niz",
          ">": "wieksze niz",
          "∑": "suma",
          "¤": "waluta"
        },
        pt: {
          "∆": "delta",
          "∞": "infinito",
          "♥": "amor",
          "&": "e",
          "|": "ou",
          "<": "menor que",
          ">": "maior que",
          "∑": "soma",
          "¤": "moeda"
        },
        ro: {
          "∆": "delta",
          "∞": "infinit",
          "♥": "dragoste",
          "&": "si",
          "|": "sau",
          "<": "mai mic ca",
          ">": "mai mare ca",
          "∑": "suma",
          "¤": "valuta"
        },
        ru: {
          "∆": "delta",
          "∞": "beskonechno",
          "♥": "lubov",
          "&": "i",
          "|": "ili",
          "<": "menshe",
          ">": "bolshe",
          "∑": "summa",
          "¤": "valjuta"
        },
        sk: {
          "∆": "delta",
          "∞": "nekonecno",
          "♥": "laska",
          "&": "a",
          "|": "alebo",
          "<": "menej ako",
          ">": "viac ako",
          "∑": "sucet",
          "¤": "mena"
        },
        sr: {},
        tr: {
          "∆": "delta",
          "∞": "sonsuzluk",
          "♥": "ask",
          "&": "ve",
          "|": "veya",
          "<": "kucuktur",
          ">": "buyuktur",
          "∑": "toplam",
          "¤": "para birimi"
        },
        uk: {
          "∆": "delta",
          "∞": "bezkinechnist",
          "♥": "lubov",
          "&": "i",
          "|": "abo",
          "<": "menshe",
          ">": "bilshe",
          "∑": "suma",
          "¤": "valjuta"
        },
        vn: {
          "∆": "delta",
          "∞": "vo cuc",
          "♥": "yeu",
          "&": "va",
          "|": "hoac",
          "<": "nho hon",
          ">": "lon hon",
          "∑": "tong",
          "¤": "tien te"
        }
      }, i = [";", "?", ":", "@", "&", "=", "+", "$", ",", "/"].join(""), u = [";", "?", ":", "@", "&", "=", "+", "$", ","].join(""), g = [".", "!", "~", "*", "'", "(", ")"].join(""), _ = function(m, d) {
        var c = "-", y = "", A = "", k = !0, R = {}, T, K, Z, M, S, U, x, G, N, H, D, ne, X, ye, Ee = "";
        if (typeof m != "string")
          return "";
        if (typeof d == "string" && (c = d), x = l.en, G = r.en, typeof d == "object") {
          T = d.maintainCase || !1, R = d.custom && typeof d.custom == "object" ? d.custom : R, Z = +d.truncate > 1 && d.truncate || !1, M = d.uric || !1, S = d.uricNoSlash || !1, U = d.mark || !1, k = !(d.symbols === !1 || d.lang === !1), c = d.separator || c, M && (Ee += i), S && (Ee += u), U && (Ee += g), x = d.lang && l[d.lang] && k ? l[d.lang] : k ? l.en : {}, G = d.lang && r[d.lang] ? r[d.lang] : d.lang === !1 || d.lang === !0 ? {} : r.en, d.titleCase && typeof d.titleCase.length == "number" && Array.prototype.toString.call(d.titleCase) ? (d.titleCase.forEach(function(pe) {
            R[pe + ""] = pe + "";
          }), K = !0) : K = !!d.titleCase, d.custom && typeof d.custom.length == "number" && Array.prototype.toString.call(d.custom) && d.custom.forEach(function(pe) {
            R[pe + ""] = pe + "";
          }), Object.keys(R).forEach(function(pe) {
            var I;
            pe.length > 1 ? I = new RegExp("\\b" + p(pe) + "\\b", "gi") : I = new RegExp(p(pe), "gi"), m = m.replace(I, R[pe]);
          });
          for (D in R)
            Ee += D;
        }
        for (Ee += c, Ee = p(Ee), m = m.replace(/(^\s+|\s+$)/g, ""), X = !1, ye = !1, H = 0, ne = m.length; H < ne; H++)
          D = m[H], f(D, R) ? X = !1 : G[D] ? (D = X && G[D].match(/[A-Za-z0-9]/) ? " " + G[D] : G[D], X = !1) : D in o ? (H + 1 < ne && a.indexOf(m[H + 1]) >= 0 ? (A += D, D = "") : ye === !0 ? (D = s[A] + o[D], A = "") : D = X && o[D].match(/[A-Za-z0-9]/) ? " " + o[D] : o[D], X = !1, ye = !1) : D in s ? (A += D, D = "", H === ne - 1 && (D = s[A]), ye = !0) : /* process symbol chars */ x[D] && !(M && i.indexOf(D) !== -1) && !(S && u.indexOf(D) !== -1) ? (D = X || y.substr(-1).match(/[A-Za-z0-9]/) ? c + x[D] : x[D], D += m[H + 1] !== void 0 && m[H + 1].match(/[A-Za-z0-9]/) ? c : "", X = !0) : (ye === !0 ? (D = s[A] + D, A = "", ye = !1) : X && (/[A-Za-z0-9]/.test(D) || y.substr(-1).match(/A-Za-z0-9]/)) && (D = " " + D), X = !1), y += D.replace(new RegExp("[^\\w\\s" + Ee + "_-]", "g"), c);
        return K && (y = y.replace(/(\w)(\S*)/g, function(pe, I, j) {
          var oe = I.toUpperCase() + (j !== null ? j : "");
          return Object.keys(R).indexOf(oe.toLowerCase()) < 0 ? oe : oe.toLowerCase();
        })), y = y.replace(/\s+/g, c).replace(new RegExp("\\" + c + "+", "g"), c).replace(new RegExp("(^\\" + c + "+|\\" + c + "+$)", "g"), ""), Z && y.length > Z && (N = y.charAt(Z) === c, y = y.slice(0, Z), N || (y = y.slice(0, y.lastIndexOf(c)))), !T && !K && (y = y.toLowerCase()), y;
      }, w = function(m) {
        return function(c) {
          return _(c, m);
        };
      }, p = function(m) {
        return m.replace(/[-\\^$*+?.()|[\]{}\/]/g, "\\$&");
      }, f = function(h, m) {
        for (var d in m)
          if (m[d] === h)
            return !0;
      };
      if (typeof t < "u" && t.exports)
        t.exports = _, t.exports.createSlug = w;
      else if (typeof define < "u" && define.amd)
        define([], function() {
          return _;
        });
      else
        try {
          if (n.getSlug || n.createSlug)
            throw "speakingurl: globals exists /(getSlug|createSlug)/";
          n.getSlug = _, n.createSlug = w;
        } catch {
        }
    })(e);
  }
}), js = la({
  "../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/index.js"(e, t) {
    E(), t.exports = Ks();
  }
});
E();
E();
E();
E();
E();
E();
E();
E();
function qs(e) {
  var t;
  const n = e.name || e._componentTag || e.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ || e.__name;
  return n === "index" && ((t = e.__file) != null && t.endsWith("index.vue")) ? "" : n;
}
function Ys(e) {
  const t = e.__file;
  if (t)
    return Ms(Fs(t, ".vue"));
}
function Vn(e, t) {
  return e.type.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ = t, t;
}
function gn(e) {
  if (e.__VUE_DEVTOOLS_NEXT_APP_RECORD__)
    return e.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
  if (e.root)
    return e.appContext.app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
}
function ia(e) {
  var t, n;
  const o = (t = e.subTree) == null ? void 0 : t.type, a = gn(e);
  return a ? ((n = a?.types) == null ? void 0 : n.Fragment) === o : !1;
}
function Rt(e) {
  var t, n, o;
  const a = qs(e?.type || {});
  if (a)
    return a;
  if (e?.root === e)
    return "Root";
  for (const r in (n = (t = e.parent) == null ? void 0 : t.type) == null ? void 0 : n.components)
    if (e.parent.type.components[r] === e?.type)
      return Vn(e, r);
  for (const r in (o = e.appContext) == null ? void 0 : o.components)
    if (e.appContext.components[r] === e?.type)
      return Vn(e, r);
  const s = Ys(e?.type || {});
  return s || "Anonymous Component";
}
function Zs(e) {
  var t, n, o;
  const a = (o = (n = (t = e?.appContext) == null ? void 0 : t.app) == null ? void 0 : n.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__) != null ? o : 0, s = e === e?.root ? "root" : e.uid;
  return `${a}:${s}`;
}
function Xt(e, t) {
  return t = t || `${e.id}:root`, e.instanceMap.get(t) || e.instanceMap.get(":root");
}
function Xs() {
  const e = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    get width() {
      return e.right - e.left;
    },
    get height() {
      return e.bottom - e.top;
    }
  };
  return e;
}
var bt;
function Js(e) {
  return bt || (bt = document.createRange()), bt.selectNode(e), bt.getBoundingClientRect();
}
function Qs(e) {
  const t = Xs();
  if (!e.children)
    return t;
  for (let n = 0, o = e.children.length; n < o; n++) {
    const a = e.children[n];
    let s;
    if (a.component)
      s = Ve(a.component);
    else if (a.el) {
      const r = a.el;
      r.nodeType === 1 || r.getBoundingClientRect ? s = r.getBoundingClientRect() : r.nodeType === 3 && r.data.trim() && (s = Js(r));
    }
    s && er(t, s);
  }
  return t;
}
function er(e, t) {
  return (!e.top || t.top < e.top) && (e.top = t.top), (!e.bottom || t.bottom > e.bottom) && (e.bottom = t.bottom), (!e.left || t.left < e.left) && (e.left = t.left), (!e.right || t.right > e.right) && (e.right = t.right), e;
}
var Un = {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  width: 0,
  height: 0
};
function Ve(e) {
  const t = e.subTree.el;
  return typeof window > "u" ? Un : ia(e) ? Qs(e.subTree) : t?.nodeType === 1 ? t?.getBoundingClientRect() : e.subTree.component ? Ve(e.subTree.component) : Un;
}
E();
function vn(e) {
  return ia(e) ? tr(e.subTree) : e.subTree ? [e.subTree.el] : [];
}
function tr(e) {
  if (!e.children)
    return [];
  const t = [];
  return e.children.forEach((n) => {
    n.component ? t.push(...vn(n.component)) : n?.el && t.push(n.el);
  }), t;
}
var ua = "__vue-devtools-component-inspector__", ca = "__vue-devtools-component-inspector__card__", da = "__vue-devtools-component-inspector__name__", pa = "__vue-devtools-component-inspector__indicator__", ma = {
  display: "block",
  zIndex: 2147483640,
  position: "fixed",
  backgroundColor: "#42b88325",
  border: "1px solid #42b88350",
  borderRadius: "5px",
  transition: "all 0.1s ease-in",
  pointerEvents: "none"
}, nr = {
  fontFamily: "Arial, Helvetica, sans-serif",
  padding: "5px 8px",
  borderRadius: "4px",
  textAlign: "left",
  position: "absolute",
  left: 0,
  color: "#e9e9e9",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "24px",
  backgroundColor: "#42b883",
  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)"
}, or = {
  display: "inline-block",
  fontWeight: 400,
  fontStyle: "normal",
  fontSize: "12px",
  opacity: 0.7
};
function tt() {
  return document.getElementById(ua);
}
function ar() {
  return document.getElementById(ca);
}
function sr() {
  return document.getElementById(pa);
}
function rr() {
  return document.getElementById(da);
}
function wn(e) {
  return {
    left: `${Math.round(e.left * 100) / 100}px`,
    top: `${Math.round(e.top * 100) / 100}px`,
    width: `${Math.round(e.width * 100) / 100}px`,
    height: `${Math.round(e.height * 100) / 100}px`
  };
}
function En(e) {
  var t;
  const n = document.createElement("div");
  n.id = (t = e.elementId) != null ? t : ua, Object.assign(n.style, {
    ...ma,
    ...wn(e.bounds),
    ...e.style
  });
  const o = document.createElement("span");
  o.id = ca, Object.assign(o.style, {
    ...nr,
    top: e.bounds.top < 35 ? 0 : "-35px"
  });
  const a = document.createElement("span");
  a.id = da, a.innerHTML = `&lt;${e.name}&gt;&nbsp;&nbsp;`;
  const s = document.createElement("i");
  return s.id = pa, s.innerHTML = `${Math.round(e.bounds.width * 100) / 100} x ${Math.round(e.bounds.height * 100) / 100}`, Object.assign(s.style, or), o.appendChild(a), o.appendChild(s), n.appendChild(o), document.body.appendChild(n), n;
}
function Cn(e) {
  const t = tt(), n = ar(), o = rr(), a = sr();
  t && (Object.assign(t.style, {
    ...ma,
    ...wn(e.bounds)
  }), Object.assign(n.style, {
    top: e.bounds.top < 35 ? 0 : "-35px"
  }), o.innerHTML = `&lt;${e.name}&gt;&nbsp;&nbsp;`, a.innerHTML = `${Math.round(e.bounds.width * 100) / 100} x ${Math.round(e.bounds.height * 100) / 100}`);
}
function lr(e) {
  const t = Ve(e);
  if (!t.width && !t.height)
    return;
  const n = Rt(e);
  tt() ? Cn({ bounds: t, name: n }) : En({ bounds: t, name: n });
}
function fa() {
  const e = tt();
  e && (e.style.display = "none");
}
var Jt = null;
function Qt(e) {
  const t = e.target;
  if (t) {
    const n = t.__vueParentComponent;
    if (n && (Jt = n, n.vnode.el)) {
      const a = Ve(n), s = Rt(n);
      tt() ? Cn({ bounds: a, name: s }) : En({ bounds: a, name: s });
    }
  }
}
function ir(e, t) {
  if (e.preventDefault(), e.stopPropagation(), Jt) {
    const n = Zs(Jt);
    t(n);
  }
}
var Ft = null;
function ur() {
  fa(), window.removeEventListener("mouseover", Qt), window.removeEventListener("click", Ft, !0), Ft = null;
}
function cr() {
  return window.addEventListener("mouseover", Qt), new Promise((e) => {
    function t(n) {
      n.preventDefault(), n.stopPropagation(), ir(n, (o) => {
        window.removeEventListener("click", t, !0), Ft = null, window.removeEventListener("mouseover", Qt);
        const a = tt();
        a && (a.style.display = "none"), e(JSON.stringify({ id: o }));
      });
    }
    Ft = t, window.addEventListener("click", t, !0);
  });
}
function dr(e) {
  const t = Xt(ce.value, e.id);
  if (t) {
    const [n] = vn(t);
    if (typeof n.scrollIntoView == "function")
      n.scrollIntoView({
        behavior: "smooth"
      });
    else {
      const o = Ve(t), a = document.createElement("div"), s = {
        ...wn(o),
        position: "absolute"
      };
      Object.assign(a.style, s), document.body.appendChild(a), a.scrollIntoView({
        behavior: "smooth"
      }), setTimeout(() => {
        document.body.removeChild(a);
      }, 2e3);
    }
    setTimeout(() => {
      const o = Ve(t);
      if (o.width || o.height) {
        const a = Rt(t), s = tt();
        s ? Cn({ ...e, name: a, bounds: o }) : En({ ...e, name: a, bounds: o }), setTimeout(() => {
          s && (s.style.display = "none");
        }, 1500);
      }
    }, 1200);
  }
}
E();
var Gn, Hn;
(Hn = (Gn = F).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__) != null || (Gn.__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ = !0);
function pr(e) {
  let t = 0;
  const n = setInterval(() => {
    F.__VUE_INSPECTOR__ && (clearInterval(n), t += 30, e()), t >= /* 5s */
    5e3 && clearInterval(n);
  }, 30);
}
function mr() {
  const e = F.__VUE_INSPECTOR__, t = e.openInEditor;
  e.openInEditor = async (...n) => {
    e.disable(), t(...n);
  };
}
function fr() {
  return new Promise((e) => {
    function t() {
      mr(), e(F.__VUE_INSPECTOR__);
    }
    F.__VUE_INSPECTOR__ ? t() : pr(() => {
      t();
    });
  });
}
E();
E();
function hr(e) {
  return !!(e && e.__v_isReadonly);
}
function ha(e) {
  return hr(e) ? ha(e.__v_raw) : !!(e && e.__v_isReactive);
}
function Gt(e) {
  return !!(e && e.__v_isRef === !0);
}
function at(e) {
  const t = e && e.__v_raw;
  return t ? at(t) : e;
}
var yr = class {
  constructor() {
    this.refEditor = new _r();
  }
  set(e, t, n, o) {
    const a = Array.isArray(t) ? t : t.split(".");
    for (; a.length > 1; ) {
      const l = a.shift();
      e instanceof Map ? e = e.get(l) : e instanceof Set ? e = Array.from(e.values())[l] : e = e[l], this.refEditor.isRef(e) && (e = this.refEditor.get(e));
    }
    const s = a[0], r = this.refEditor.get(e)[s];
    o ? o(e, s, n) : this.refEditor.isRef(r) ? this.refEditor.set(r, n) : e[s] = n;
  }
  get(e, t) {
    const n = Array.isArray(t) ? t : t.split(".");
    for (let o = 0; o < n.length; o++)
      if (e instanceof Map ? e = e.get(n[o]) : e = e[n[o]], this.refEditor.isRef(e) && (e = this.refEditor.get(e)), !e)
        return;
    return e;
  }
  has(e, t, n = !1) {
    if (typeof e > "u")
      return !1;
    const o = Array.isArray(t) ? t.slice() : t.split("."), a = n ? 2 : 1;
    for (; e && o.length > a; ) {
      const s = o.shift();
      e = e[s], this.refEditor.isRef(e) && (e = this.refEditor.get(e));
    }
    return e != null && Object.prototype.hasOwnProperty.call(e, o[0]);
  }
  createDefaultSetCallback(e) {
    return (t, n, o) => {
      if ((e.remove || e.newKey) && (Array.isArray(t) ? t.splice(n, 1) : at(t) instanceof Map ? t.delete(n) : at(t) instanceof Set ? t.delete(Array.from(t.values())[n]) : Reflect.deleteProperty(t, n)), !e.remove) {
        const a = t[e.newKey || n];
        this.refEditor.isRef(a) ? this.refEditor.set(a, o) : at(t) instanceof Map ? t.set(e.newKey || n, o) : at(t) instanceof Set ? t.add(o) : t[e.newKey || n] = o;
      }
    };
  }
}, _r = class {
  set(e, t) {
    if (Gt(e))
      e.value = t;
    else {
      if (e instanceof Set && Array.isArray(t)) {
        e.clear(), t.forEach((a) => e.add(a));
        return;
      }
      const n = Object.keys(t);
      if (e instanceof Map) {
        const a = new Set(e.keys());
        n.forEach((s) => {
          e.set(s, Reflect.get(t, s)), a.delete(s);
        }), a.forEach((s) => e.delete(s));
        return;
      }
      const o = new Set(Object.keys(e));
      n.forEach((a) => {
        Reflect.set(e, a, Reflect.get(t, a)), o.delete(a);
      }), o.forEach((a) => Reflect.deleteProperty(e, a));
    }
  }
  get(e) {
    return Gt(e) ? e.value : e;
  }
  isRef(e) {
    return Gt(e) || ha(e);
  }
};
E();
E();
E();
var br = "__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS_STATE__";
function gr() {
  if (!oa || typeof localStorage > "u" || localStorage === null)
    return {
      recordingState: !1,
      mouseEventEnabled: !1,
      keyboardEventEnabled: !1,
      componentEventEnabled: !1,
      performanceEventEnabled: !1,
      selected: ""
    };
  const e = localStorage.getItem(br);
  return e ? JSON.parse(e) : {
    recordingState: !1,
    mouseEventEnabled: !1,
    keyboardEventEnabled: !1,
    componentEventEnabled: !1,
    performanceEventEnabled: !1,
    selected: ""
  };
}
E();
E();
E();
var Wn, zn;
(zn = (Wn = F).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS) != null || (Wn.__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS = []);
var vr = new Proxy(F.__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS, {
  get(e, t, n) {
    return Reflect.get(e, t, n);
  }
});
function wr(e, t) {
  ae.timelineLayersState[t.id] = !1, vr.push({
    ...e,
    descriptorId: t.id,
    appRecord: gn(t.app)
  });
}
var Kn, jn;
(jn = (Kn = F).__VUE_DEVTOOLS_KIT_INSPECTOR__) != null || (Kn.__VUE_DEVTOOLS_KIT_INSPECTOR__ = []);
var Sn = new Proxy(F.__VUE_DEVTOOLS_KIT_INSPECTOR__, {
  get(e, t, n) {
    return Reflect.get(e, t, n);
  }
}), ya = Xe(() => {
  nt.hooks.callHook("sendInspectorToClient", _a());
});
function Er(e, t) {
  var n, o;
  Sn.push({
    options: e,
    descriptor: t,
    treeFilterPlaceholder: (n = e.treeFilterPlaceholder) != null ? n : "Search tree...",
    stateFilterPlaceholder: (o = e.stateFilterPlaceholder) != null ? o : "Search state...",
    treeFilter: "",
    selectedNodeId: "",
    appRecord: gn(t.app)
  }), ya();
}
function _a() {
  return Sn.filter((e) => e.descriptor.app === ce.value.app).filter((e) => e.descriptor.id !== "components").map((e) => {
    var t;
    const n = e.descriptor, o = e.options;
    return {
      id: o.id,
      label: o.label,
      logo: n.logo,
      icon: `custom-ic-baseline-${(t = o?.icon) == null ? void 0 : t.replace(/_/g, "-")}`,
      packageName: n.packageName,
      homepage: n.homepage,
      pluginId: n.id
    };
  });
}
function wt(e, t) {
  return Sn.find((n) => n.options.id === e && (t ? n.descriptor.app === t : !0));
}
function Cr() {
  const e = sa();
  e.hook("addInspector", ({ inspector: o, plugin: a }) => {
    Er(o, a.descriptor);
  });
  const t = Xe(async ({ inspectorId: o, plugin: a }) => {
    var s;
    if (!o || !((s = a?.descriptor) != null && s.app) || ae.highPerfModeEnabled)
      return;
    const r = wt(o, a.descriptor.app), l = {
      app: a.descriptor.app,
      inspectorId: o,
      filter: r?.treeFilter || "",
      rootNodes: []
    };
    await new Promise((i) => {
      e.callHookWith(
        async (u) => {
          await Promise.all(u.map((g) => g(l))), i();
        },
        "getInspectorTree"
        /* GET_INSPECTOR_TREE */
      );
    }), e.callHookWith(
      async (i) => {
        await Promise.all(i.map((u) => u({
          inspectorId: o,
          rootNodes: l.rootNodes
        })));
      },
      "sendInspectorTreeToClient"
      /* SEND_INSPECTOR_TREE_TO_CLIENT */
    );
  }, 120);
  e.hook("sendInspectorTree", t);
  const n = Xe(async ({ inspectorId: o, plugin: a }) => {
    var s;
    if (!o || !((s = a?.descriptor) != null && s.app) || ae.highPerfModeEnabled)
      return;
    const r = wt(o, a.descriptor.app), l = {
      app: a.descriptor.app,
      inspectorId: o,
      nodeId: r?.selectedNodeId || "",
      state: null
    }, i = {
      currentTab: `custom-inspector:${o}`
    };
    l.nodeId && await new Promise((u) => {
      e.callHookWith(
        async (g) => {
          await Promise.all(g.map((_) => _(l, i))), u();
        },
        "getInspectorState"
        /* GET_INSPECTOR_STATE */
      );
    }), e.callHookWith(
      async (u) => {
        await Promise.all(u.map((g) => g({
          inspectorId: o,
          nodeId: l.nodeId,
          state: l.state
        })));
      },
      "sendInspectorStateToClient"
      /* SEND_INSPECTOR_STATE_TO_CLIENT */
    );
  }, 120);
  return e.hook("sendInspectorState", n), e.hook("customInspectorSelectNode", ({ inspectorId: o, nodeId: a, plugin: s }) => {
    const r = wt(o, s.descriptor.app);
    r && (r.selectedNodeId = a);
  }), e.hook("timelineLayerAdded", ({ options: o, plugin: a }) => {
    wr(o, a.descriptor);
  }), e.hook("timelineEventAdded", ({ options: o, plugin: a }) => {
    var s;
    const r = ["performance", "component-event", "keyboard", "mouse"];
    ae.highPerfModeEnabled || !((s = ae.timelineLayersState) != null && s[a.descriptor.id]) && !r.includes(o.layerId) || e.callHookWith(
      async (l) => {
        await Promise.all(l.map((i) => i(o)));
      },
      "sendTimelineEventToClient"
      /* SEND_TIMELINE_EVENT_TO_CLIENT */
    );
  }), e.hook("getComponentInstances", async ({ app: o }) => {
    const a = o.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
    if (!a)
      return null;
    const s = a.id.toString();
    return [...a.instanceMap].filter(([l]) => l.split(":")[0] === s).map(([, l]) => l);
  }), e.hook("getComponentBounds", async ({ instance: o }) => Ve(o)), e.hook("getComponentName", ({ instance: o }) => Rt(o)), e.hook("componentHighlight", ({ uid: o }) => {
    const a = ce.value.instanceMap.get(o);
    a && lr(a);
  }), e.hook("componentUnhighlight", () => {
    fa();
  }), e;
}
var qn, Yn;
(Yn = (qn = F).__VUE_DEVTOOLS_KIT_APP_RECORDS__) != null || (qn.__VUE_DEVTOOLS_KIT_APP_RECORDS__ = []);
var Zn, Xn;
(Xn = (Zn = F).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__) != null || (Zn.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = {});
var Jn, Qn;
(Qn = (Jn = F).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__) != null || (Jn.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = "");
var eo, to;
(to = (eo = F).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__) != null || (eo.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__ = []);
var no, oo;
(oo = (no = F).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__) != null || (no.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ = []);
var Re = "__VUE_DEVTOOLS_KIT_GLOBAL_STATE__";
function Sr() {
  return {
    connected: !1,
    clientConnected: !1,
    vitePluginDetected: !0,
    appRecords: [],
    activeAppRecordId: "",
    tabs: [],
    commands: [],
    highPerfModeEnabled: !0,
    devtoolsClientDetected: {},
    perfUniqueGroupId: 0,
    timelineLayersState: gr()
  };
}
var ao, so;
(so = (ao = F)[Re]) != null || (ao[Re] = Sr());
var Ar = Xe((e) => {
  nt.hooks.callHook("devtoolsStateUpdated", { state: e });
});
Xe((e, t) => {
  nt.hooks.callHook("devtoolsConnectedUpdated", { state: e, oldState: t });
});
var xt = new Proxy(F.__VUE_DEVTOOLS_KIT_APP_RECORDS__, {
  get(e, t, n) {
    return t === "value" ? F.__VUE_DEVTOOLS_KIT_APP_RECORDS__ : F.__VUE_DEVTOOLS_KIT_APP_RECORDS__[t];
  }
}), ce = new Proxy(F.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__, {
  get(e, t, n) {
    return t === "value" ? F.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ : t === "id" ? F.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ : F.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__[t];
  }
});
function ba() {
  Ar({
    ...F[Re],
    appRecords: xt.value,
    activeAppRecordId: ce.id,
    tabs: F.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__,
    commands: F.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__
  });
}
function kr(e) {
  F.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = e, ba();
}
function Tr(e) {
  F.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = e, ba();
}
var ae = new Proxy(F[Re], {
  get(e, t) {
    return t === "appRecords" ? xt : t === "activeAppRecordId" ? ce.id : t === "tabs" ? F.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__ : t === "commands" ? F.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ : F[Re][t];
  },
  deleteProperty(e, t) {
    return delete e[t], !0;
  },
  set(e, t, n) {
    return { ...F[Re] }, e[t] = n, F[Re][t] = n, !0;
  }
});
function Or(e = {}) {
  var t, n, o;
  const { file: a, host: s, baseUrl: r = window.location.origin, line: l = 0, column: i = 0 } = e;
  if (a) {
    if (s === "chrome-extension") {
      const u = a.replace(/\\/g, "\\\\"), g = (n = (t = window.VUE_DEVTOOLS_CONFIG) == null ? void 0 : t.openInEditorHost) != null ? n : "/";
      fetch(`${g}__open-in-editor?file=${encodeURI(a)}`).then((_) => {
        if (!_.ok) {
          const w = `Opening component ${u} failed`;
          console.log(`%c${w}`, "color:red");
        }
      });
    } else if (ae.vitePluginDetected) {
      const u = (o = F.__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__) != null ? o : r;
      F.__VUE_INSPECTOR__.openInEditor(u, a, l, i);
    }
  }
}
E();
E();
E();
E();
E();
var ro, lo;
(lo = (ro = F).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__) != null || (ro.__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__ = []);
var An = new Proxy(F.__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__, {
  get(e, t, n) {
    return Reflect.get(e, t, n);
  }
});
function en(e) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = e[n].defaultValue;
  }), t;
}
function kn(e) {
  return `__VUE_DEVTOOLS_NEXT_PLUGIN_SETTINGS__${e}__`;
}
function Pr(e) {
  var t, n, o;
  const a = (n = (t = An.find((s) => {
    var r;
    return s[0].id === e && !!((r = s[0]) != null && r.settings);
  })) == null ? void 0 : t[0]) != null ? n : null;
  return (o = a?.settings) != null ? o : null;
}
function ga(e, t) {
  var n, o, a;
  const s = kn(e);
  if (s) {
    const r = localStorage.getItem(s);
    if (r)
      return JSON.parse(r);
  }
  if (e) {
    const r = (o = (n = An.find((l) => l[0].id === e)) == null ? void 0 : n[0]) != null ? o : null;
    return en((a = r?.settings) != null ? a : {});
  }
  return en(t);
}
function Mr(e, t) {
  const n = kn(e);
  localStorage.getItem(n) || localStorage.setItem(n, JSON.stringify(en(t)));
}
function Fr(e, t, n) {
  const o = kn(e), a = localStorage.getItem(o), s = JSON.parse(a || "{}"), r = {
    ...s,
    [t]: n
  };
  localStorage.setItem(o, JSON.stringify(r)), nt.hooks.callHookWith(
    (l) => {
      l.forEach((i) => i({
        pluginId: e,
        key: t,
        oldValue: s[t],
        newValue: n,
        settings: r
      }));
    },
    "setPluginSettings"
    /* SET_PLUGIN_SETTINGS */
  );
}
E();
E();
E();
E();
E();
E();
E();
E();
E();
E();
E();
var io, uo, me = (uo = (io = F).__VUE_DEVTOOLS_HOOK) != null ? uo : io.__VUE_DEVTOOLS_HOOK = sa(), Br = {
  vueAppInit(e) {
    me.hook("app:init", e);
  },
  vueAppUnmount(e) {
    me.hook("app:unmount", e);
  },
  vueAppConnected(e) {
    me.hook("app:connected", e);
  },
  componentAdded(e) {
    return me.hook("component:added", e);
  },
  componentEmit(e) {
    return me.hook("component:emit", e);
  },
  componentUpdated(e) {
    return me.hook("component:updated", e);
  },
  componentRemoved(e) {
    return me.hook("component:removed", e);
  },
  setupDevtoolsPlugin(e) {
    me.hook("devtools-plugin:setup", e);
  },
  perfStart(e) {
    return me.hook("perf:start", e);
  },
  perfEnd(e) {
    return me.hook("perf:end", e);
  }
}, va = {
  on: Br,
  setupDevToolsPlugin(e, t) {
    return me.callHook("devtools-plugin:setup", e, t);
  }
}, Dr = class {
  constructor({ plugin: e, ctx: t }) {
    this.hooks = t.hooks, this.plugin = e;
  }
  get on() {
    return {
      // component inspector
      visitComponentTree: (e) => {
        this.hooks.hook("visitComponentTree", e);
      },
      inspectComponent: (e) => {
        this.hooks.hook("inspectComponent", e);
      },
      editComponentState: (e) => {
        this.hooks.hook("editComponentState", e);
      },
      // custom inspector
      getInspectorTree: (e) => {
        this.hooks.hook("getInspectorTree", e);
      },
      getInspectorState: (e) => {
        this.hooks.hook("getInspectorState", e);
      },
      editInspectorState: (e) => {
        this.hooks.hook("editInspectorState", e);
      },
      // timeline
      inspectTimelineEvent: (e) => {
        this.hooks.hook("inspectTimelineEvent", e);
      },
      timelineCleared: (e) => {
        this.hooks.hook("timelineCleared", e);
      },
      // settings
      setPluginSettings: (e) => {
        this.hooks.hook("setPluginSettings", e);
      }
    };
  }
  // component inspector
  notifyComponentUpdate(e) {
    var t;
    if (ae.highPerfModeEnabled)
      return;
    const n = _a().find((o) => o.packageName === this.plugin.descriptor.packageName);
    if (n?.id) {
      if (e) {
        const o = [
          e.appContext.app,
          e.uid,
          (t = e.parent) == null ? void 0 : t.uid,
          e
        ];
        me.callHook("component:updated", ...o);
      } else
        me.callHook(
          "component:updated"
          /* COMPONENT_UPDATED */
        );
      this.hooks.callHook("sendInspectorState", { inspectorId: n.id, plugin: this.plugin });
    }
  }
  // custom inspector
  addInspector(e) {
    this.hooks.callHook("addInspector", { inspector: e, plugin: this.plugin }), this.plugin.descriptor.settings && Mr(e.id, this.plugin.descriptor.settings);
  }
  sendInspectorTree(e) {
    ae.highPerfModeEnabled || this.hooks.callHook("sendInspectorTree", { inspectorId: e, plugin: this.plugin });
  }
  sendInspectorState(e) {
    ae.highPerfModeEnabled || this.hooks.callHook("sendInspectorState", { inspectorId: e, plugin: this.plugin });
  }
  selectInspectorNode(e, t) {
    this.hooks.callHook("customInspectorSelectNode", { inspectorId: e, nodeId: t, plugin: this.plugin });
  }
  visitComponentTree(e) {
    return this.hooks.callHook("visitComponentTree", e);
  }
  // timeline
  now() {
    return ae.highPerfModeEnabled ? 0 : Date.now();
  }
  addTimelineLayer(e) {
    this.hooks.callHook("timelineLayerAdded", { options: e, plugin: this.plugin });
  }
  addTimelineEvent(e) {
    ae.highPerfModeEnabled || this.hooks.callHook("timelineEventAdded", { options: e, plugin: this.plugin });
  }
  // settings
  getSettings(e) {
    return ga(e ?? this.plugin.descriptor.id, this.plugin.descriptor.settings);
  }
  // utilities
  getComponentInstances(e) {
    return this.hooks.callHook("getComponentInstances", { app: e });
  }
  getComponentBounds(e) {
    return this.hooks.callHook("getComponentBounds", { instance: e });
  }
  getComponentName(e) {
    return this.hooks.callHook("getComponentName", { instance: e });
  }
  highlightElement(e) {
    const t = e.__VUE_DEVTOOLS_NEXT_UID__;
    return this.hooks.callHook("componentHighlight", { uid: t });
  }
  unhighlightElement() {
    return this.hooks.callHook(
      "componentUnhighlight"
      /* COMPONENT_UNHIGHLIGHT */
    );
  }
}, Lr = Dr;
E();
E();
E();
E();
var Rr = "__vue_devtool_undefined__", xr = "__vue_devtool_infinity__", Ir = "__vue_devtool_negative_infinity__", Nr = "__vue_devtool_nan__";
E();
E();
var $r = {
  [Rr]: "undefined",
  [Nr]: "NaN",
  [xr]: "Infinity",
  [Ir]: "-Infinity"
};
Object.entries($r).reduce((e, [t, n]) => (e[n] = t, e), {});
E();
E();
E();
E();
E();
var co, po;
(po = (co = F).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__) != null || (co.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__ = /* @__PURE__ */ new Set());
function wa(e, t) {
  return va.setupDevToolsPlugin(e, t);
}
function Vr(e, t) {
  const [n, o] = e;
  if (n.app !== t)
    return;
  const a = new Lr({
    plugin: {
      setupFn: o,
      descriptor: n
    },
    ctx: nt
  });
  n.packageName === "vuex" && a.on.editInspectorState((s) => {
    a.sendInspectorState(s.inspectorId);
  }), o(a);
}
function Ea(e, t) {
  F.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.has(e) || ae.highPerfModeEnabled && !t?.inspectingComponent || (F.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.add(e), An.forEach((n) => {
    Vr(n, e);
  }));
}
E();
E();
var ut = "__VUE_DEVTOOLS_ROUTER__", Je = "__VUE_DEVTOOLS_ROUTER_INFO__", mo, fo;
(fo = (mo = F)[Je]) != null || (mo[Je] = {
  currentRoute: null,
  routes: []
});
var ho, yo;
(yo = (ho = F)[ut]) != null || (ho[ut] = {});
new Proxy(F[Je], {
  get(e, t) {
    return F[Je][t];
  }
});
new Proxy(F[ut], {
  get(e, t) {
    if (t === "value")
      return F[ut];
  }
});
function Ur(e) {
  const t = /* @__PURE__ */ new Map();
  return (e?.getRoutes() || []).filter((n) => !t.has(n.path) && t.set(n.path, 1));
}
function Tn(e) {
  return e.map((t) => {
    let { path: n, name: o, children: a, meta: s } = t;
    return a?.length && (a = Tn(a)), {
      path: n,
      name: o,
      children: a,
      meta: s
    };
  });
}
function Gr(e) {
  if (e) {
    const { fullPath: t, hash: n, href: o, path: a, name: s, matched: r, params: l, query: i } = e;
    return {
      fullPath: t,
      hash: n,
      href: o,
      path: a,
      name: s,
      params: l,
      query: i,
      matched: Tn(r)
    };
  }
  return e;
}
function Hr(e, t) {
  function n() {
    var o;
    const a = (o = e.app) == null ? void 0 : o.config.globalProperties.$router, s = Gr(a?.currentRoute.value), r = Tn(Ur(a)), l = console.warn;
    console.warn = () => {
    }, F[Je] = {
      currentRoute: s ? $n(s) : {},
      routes: $n(r)
    }, F[ut] = a, console.warn = l;
  }
  n(), va.on.componentUpdated(Xe(() => {
    var o;
    ((o = t.value) == null ? void 0 : o.app) === e.app && (n(), !ae.highPerfModeEnabled && nt.hooks.callHook("routerInfoUpdated", { state: F[Je] }));
  }, 200));
}
function Wr(e) {
  return {
    // get inspector tree
    async getInspectorTree(t) {
      const n = {
        ...t,
        app: ce.value.app,
        rootNodes: []
      };
      return await new Promise((o) => {
        e.callHookWith(
          async (a) => {
            await Promise.all(a.map((s) => s(n))), o();
          },
          "getInspectorTree"
          /* GET_INSPECTOR_TREE */
        );
      }), n.rootNodes;
    },
    // get inspector state
    async getInspectorState(t) {
      const n = {
        ...t,
        app: ce.value.app,
        state: null
      }, o = {
        currentTab: `custom-inspector:${t.inspectorId}`
      };
      return await new Promise((a) => {
        e.callHookWith(
          async (s) => {
            await Promise.all(s.map((r) => r(n, o))), a();
          },
          "getInspectorState"
          /* GET_INSPECTOR_STATE */
        );
      }), n.state;
    },
    // edit inspector state
    editInspectorState(t) {
      const n = new yr(), o = {
        ...t,
        app: ce.value.app,
        set: (a, s = t.path, r = t.state.value, l) => {
          n.set(a, s, r, l || n.createDefaultSetCallback(t.state));
        }
      };
      e.callHookWith(
        (a) => {
          a.forEach((s) => s(o));
        },
        "editInspectorState"
        /* EDIT_INSPECTOR_STATE */
      );
    },
    // send inspector state
    sendInspectorState(t) {
      const n = wt(t);
      e.callHook("sendInspectorState", { inspectorId: t, plugin: {
        descriptor: n.descriptor,
        setupFn: () => ({})
      } });
    },
    // inspect component inspector
    inspectComponentInspector() {
      return cr();
    },
    // cancel inspect component inspector
    cancelInspectComponentInspector() {
      return ur();
    },
    // get component render code
    getComponentRenderCode(t) {
      const n = Xt(ce.value, t);
      if (n)
        return typeof n?.type != "function" ? n.render.toString() : n.type.toString();
    },
    // scroll to component
    scrollToComponent(t) {
      return dr({ id: t });
    },
    // open in editor
    openInEditor: Or,
    // get vue inspector
    getVueInspector: fr,
    // toggle app
    toggleApp(t, n) {
      const o = xt.value.find((a) => a.id === t);
      o && (Tr(t), kr(o), Hr(o, ce), ya(), Ea(o.app, n));
    },
    // inspect dom
    inspectDOM(t) {
      const n = Xt(ce.value, t);
      if (n) {
        const [o] = vn(n);
        o && (F.__VUE_DEVTOOLS_INSPECT_DOM_TARGET__ = o);
      }
    },
    updatePluginSettings(t, n, o) {
      Fr(t, n, o);
    },
    getPluginSettings(t) {
      return {
        options: Pr(t),
        values: ga(t)
      };
    }
  };
}
E();
var _o, bo;
(bo = (_o = F).__VUE_DEVTOOLS_ENV__) != null || (_o.__VUE_DEVTOOLS_ENV__ = {
  vitePluginDetected: !1
});
var go = Cr(), vo, wo;
(wo = (vo = F).__VUE_DEVTOOLS_KIT_CONTEXT__) != null || (vo.__VUE_DEVTOOLS_KIT_CONTEXT__ = {
  hooks: go,
  get state() {
    return {
      ...ae,
      activeAppRecordId: ce.id,
      activeAppRecord: ce.value,
      appRecords: xt.value
    };
  },
  api: Wr(go)
});
var nt = F.__VUE_DEVTOOLS_KIT_CONTEXT__;
E();
zs(js());
var Eo, Co;
(Co = (Eo = F).__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__) != null || (Eo.__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__ = {
  id: 0,
  appIds: /* @__PURE__ */ new Set()
});
E();
E();
function zr(e) {
  ae.highPerfModeEnabled = e ?? !ae.highPerfModeEnabled, !e && ce.value && Ea(ce.value.app);
}
E();
E();
E();
function Kr(e) {
  ae.devtoolsClientDetected = {
    ...ae.devtoolsClientDetected,
    ...e
  };
  const t = Object.values(ae.devtoolsClientDetected).some(Boolean);
  zr(!t);
}
var So, Ao;
(Ao = (So = F).__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__) != null || (So.__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__ = Kr);
E();
E();
E();
E();
E();
E();
E();
var jr = class {
  constructor() {
    this.keyToValue = /* @__PURE__ */ new Map(), this.valueToKey = /* @__PURE__ */ new Map();
  }
  set(e, t) {
    this.keyToValue.set(e, t), this.valueToKey.set(t, e);
  }
  getByKey(e) {
    return this.keyToValue.get(e);
  }
  getByValue(e) {
    return this.valueToKey.get(e);
  }
  clear() {
    this.keyToValue.clear(), this.valueToKey.clear();
  }
}, Ca = class {
  constructor(e) {
    this.generateIdentifier = e, this.kv = new jr();
  }
  register(e, t) {
    this.kv.getByValue(e) || (t || (t = this.generateIdentifier(e)), this.kv.set(t, e));
  }
  clear() {
    this.kv.clear();
  }
  getIdentifier(e) {
    return this.kv.getByValue(e);
  }
  getValue(e) {
    return this.kv.getByKey(e);
  }
}, qr = class extends Ca {
  constructor() {
    super((e) => e.name), this.classToAllowedProps = /* @__PURE__ */ new Map();
  }
  register(e, t) {
    typeof t == "object" ? (t.allowProps && this.classToAllowedProps.set(e, t.allowProps), super.register(e, t.identifier)) : super.register(e, t);
  }
  getAllowedProps(e) {
    return this.classToAllowedProps.get(e);
  }
};
E();
E();
function Yr(e) {
  if ("values" in Object)
    return Object.values(e);
  const t = [];
  for (const n in e)
    e.hasOwnProperty(n) && t.push(e[n]);
  return t;
}
function Zr(e, t) {
  const n = Yr(e);
  if ("find" in n)
    return n.find(t);
  const o = n;
  for (let a = 0; a < o.length; a++) {
    const s = o[a];
    if (t(s))
      return s;
  }
}
function Qe(e, t) {
  Object.entries(e).forEach(([n, o]) => t(o, n));
}
function Et(e, t) {
  return e.indexOf(t) !== -1;
}
function ko(e, t) {
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    if (t(o))
      return o;
  }
}
var Xr = class {
  constructor() {
    this.transfomers = {};
  }
  register(e) {
    this.transfomers[e.name] = e;
  }
  findApplicable(e) {
    return Zr(this.transfomers, (t) => t.isApplicable(e));
  }
  findByName(e) {
    return this.transfomers[e];
  }
};
E();
E();
var Jr = (e) => Object.prototype.toString.call(e).slice(8, -1), Sa = (e) => typeof e > "u", Qr = (e) => e === null, ct = (e) => typeof e != "object" || e === null || e === Object.prototype ? !1 : Object.getPrototypeOf(e) === null ? !0 : Object.getPrototypeOf(e) === Object.prototype, tn = (e) => ct(e) && Object.keys(e).length === 0, Be = (e) => Array.isArray(e), el = (e) => typeof e == "string", tl = (e) => typeof e == "number" && !isNaN(e), nl = (e) => typeof e == "boolean", ol = (e) => e instanceof RegExp, dt = (e) => e instanceof Map, pt = (e) => e instanceof Set, Aa = (e) => Jr(e) === "Symbol", al = (e) => e instanceof Date && !isNaN(e.valueOf()), sl = (e) => e instanceof Error, To = (e) => typeof e == "number" && isNaN(e), rl = (e) => nl(e) || Qr(e) || Sa(e) || tl(e) || el(e) || Aa(e), ll = (e) => typeof e == "bigint", il = (e) => e === 1 / 0 || e === -1 / 0, ul = (e) => ArrayBuffer.isView(e) && !(e instanceof DataView), cl = (e) => e instanceof URL;
E();
var ka = (e) => e.replace(/\./g, "\\."), Ht = (e) => e.map(String).map(ka).join("."), lt = (e) => {
  const t = [];
  let n = "";
  for (let a = 0; a < e.length; a++) {
    let s = e.charAt(a);
    if (s === "\\" && e.charAt(a + 1) === ".") {
      n += ".", a++;
      continue;
    }
    if (s === ".") {
      t.push(n), n = "";
      continue;
    }
    n += s;
  }
  const o = n;
  return t.push(o), t;
};
E();
function Se(e, t, n, o) {
  return {
    isApplicable: e,
    annotation: t,
    transform: n,
    untransform: o
  };
}
var Ta = [
  Se(Sa, "undefined", () => null, () => {
  }),
  Se(ll, "bigint", (e) => e.toString(), (e) => typeof BigInt < "u" ? BigInt(e) : (console.error("Please add a BigInt polyfill."), e)),
  Se(al, "Date", (e) => e.toISOString(), (e) => new Date(e)),
  Se(sl, "Error", (e, t) => {
    const n = {
      name: e.name,
      message: e.message
    };
    return t.allowedErrorProps.forEach((o) => {
      n[o] = e[o];
    }), n;
  }, (e, t) => {
    const n = new Error(e.message);
    return n.name = e.name, n.stack = e.stack, t.allowedErrorProps.forEach((o) => {
      n[o] = e[o];
    }), n;
  }),
  Se(ol, "regexp", (e) => "" + e, (e) => {
    const t = e.slice(1, e.lastIndexOf("/")), n = e.slice(e.lastIndexOf("/") + 1);
    return new RegExp(t, n);
  }),
  Se(
    pt,
    "set",
    // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    (e) => [...e.values()],
    (e) => new Set(e)
  ),
  Se(dt, "map", (e) => [...e.entries()], (e) => new Map(e)),
  Se((e) => To(e) || il(e), "number", (e) => To(e) ? "NaN" : e > 0 ? "Infinity" : "-Infinity", Number),
  Se((e) => e === 0 && 1 / e === -1 / 0, "number", () => "-0", Number),
  Se(cl, "URL", (e) => e.toString(), (e) => new URL(e))
];
function It(e, t, n, o) {
  return {
    isApplicable: e,
    annotation: t,
    transform: n,
    untransform: o
  };
}
var Oa = It((e, t) => Aa(e) ? !!t.symbolRegistry.getIdentifier(e) : !1, (e, t) => ["symbol", t.symbolRegistry.getIdentifier(e)], (e) => e.description, (e, t, n) => {
  const o = n.symbolRegistry.getValue(t[1]);
  if (!o)
    throw new Error("Trying to deserialize unknown symbol");
  return o;
}), dl = [
  Int8Array,
  Uint8Array,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array,
  Uint8ClampedArray
].reduce((e, t) => (e[t.name] = t, e), {}), Pa = It(ul, (e) => ["typed-array", e.constructor.name], (e) => [...e], (e, t) => {
  const n = dl[t[1]];
  if (!n)
    throw new Error("Trying to deserialize unknown typed array");
  return new n(e);
});
function Ma(e, t) {
  return e?.constructor ? !!t.classRegistry.getIdentifier(e.constructor) : !1;
}
var Fa = It(Ma, (e, t) => ["class", t.classRegistry.getIdentifier(e.constructor)], (e, t) => {
  const n = t.classRegistry.getAllowedProps(e.constructor);
  if (!n)
    return { ...e };
  const o = {};
  return n.forEach((a) => {
    o[a] = e[a];
  }), o;
}, (e, t, n) => {
  const o = n.classRegistry.getValue(t[1]);
  if (!o)
    throw new Error(`Trying to deserialize unknown class '${t[1]}' - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564`);
  return Object.assign(Object.create(o.prototype), e);
}), Ba = It((e, t) => !!t.customTransformerRegistry.findApplicable(e), (e, t) => ["custom", t.customTransformerRegistry.findApplicable(e).name], (e, t) => t.customTransformerRegistry.findApplicable(e).serialize(e), (e, t, n) => {
  const o = n.customTransformerRegistry.findByName(t[1]);
  if (!o)
    throw new Error("Trying to deserialize unknown custom value");
  return o.deserialize(e);
}), pl = [Fa, Oa, Ba, Pa], Oo = (e, t) => {
  const n = ko(pl, (a) => a.isApplicable(e, t));
  if (n)
    return {
      value: n.transform(e, t),
      type: n.annotation(e, t)
    };
  const o = ko(Ta, (a) => a.isApplicable(e, t));
  if (o)
    return {
      value: o.transform(e, t),
      type: o.annotation
    };
}, Da = {};
Ta.forEach((e) => {
  Da[e.annotation] = e;
});
var ml = (e, t, n) => {
  if (Be(t))
    switch (t[0]) {
      case "symbol":
        return Oa.untransform(e, t, n);
      case "class":
        return Fa.untransform(e, t, n);
      case "custom":
        return Ba.untransform(e, t, n);
      case "typed-array":
        return Pa.untransform(e, t, n);
      default:
        throw new Error("Unknown transformation: " + t);
    }
  else {
    const o = Da[t];
    if (!o)
      throw new Error("Unknown transformation: " + t);
    return o.untransform(e, n);
  }
};
E();
var je = (e, t) => {
  if (t > e.size)
    throw new Error("index out of bounds");
  const n = e.keys();
  for (; t > 0; )
    n.next(), t--;
  return n.next().value;
};
function La(e) {
  if (Et(e, "__proto__"))
    throw new Error("__proto__ is not allowed as a property");
  if (Et(e, "prototype"))
    throw new Error("prototype is not allowed as a property");
  if (Et(e, "constructor"))
    throw new Error("constructor is not allowed as a property");
}
var fl = (e, t) => {
  La(t);
  for (let n = 0; n < t.length; n++) {
    const o = t[n];
    if (pt(e))
      e = je(e, +o);
    else if (dt(e)) {
      const a = +o, s = +t[++n] == 0 ? "key" : "value", r = je(e, a);
      switch (s) {
        case "key":
          e = r;
          break;
        case "value":
          e = e.get(r);
          break;
      }
    } else
      e = e[o];
  }
  return e;
}, nn = (e, t, n) => {
  if (La(t), t.length === 0)
    return n(e);
  let o = e;
  for (let s = 0; s < t.length - 1; s++) {
    const r = t[s];
    if (Be(o)) {
      const l = +r;
      o = o[l];
    } else if (ct(o))
      o = o[r];
    else if (pt(o)) {
      const l = +r;
      o = je(o, l);
    } else if (dt(o)) {
      if (s === t.length - 2)
        break;
      const i = +r, u = +t[++s] == 0 ? "key" : "value", g = je(o, i);
      switch (u) {
        case "key":
          o = g;
          break;
        case "value":
          o = o.get(g);
          break;
      }
    }
  }
  const a = t[t.length - 1];
  if (Be(o) ? o[+a] = n(o[+a]) : ct(o) && (o[a] = n(o[a])), pt(o)) {
    const s = je(o, +a), r = n(s);
    s !== r && (o.delete(s), o.add(r));
  }
  if (dt(o)) {
    const s = +t[t.length - 2], r = je(o, s);
    switch (+a == 0 ? "key" : "value") {
      case "key": {
        const i = n(r);
        o.set(i, o.get(r)), i !== r && o.delete(r);
        break;
      }
      case "value": {
        o.set(r, n(o.get(r)));
        break;
      }
    }
  }
  return e;
};
function on(e, t, n = []) {
  if (!e)
    return;
  if (!Be(e)) {
    Qe(e, (s, r) => on(s, t, [...n, ...lt(r)]));
    return;
  }
  const [o, a] = e;
  a && Qe(a, (s, r) => {
    on(s, t, [...n, ...lt(r)]);
  }), t(o, n);
}
function hl(e, t, n) {
  return on(t, (o, a) => {
    e = nn(e, a, (s) => ml(s, o, n));
  }), e;
}
function yl(e, t) {
  function n(o, a) {
    const s = fl(e, lt(a));
    o.map(lt).forEach((r) => {
      e = nn(e, r, () => s);
    });
  }
  if (Be(t)) {
    const [o, a] = t;
    o.forEach((s) => {
      e = nn(e, lt(s), () => e);
    }), a && Qe(a, n);
  } else
    Qe(t, n);
  return e;
}
var _l = (e, t) => ct(e) || Be(e) || dt(e) || pt(e) || Ma(e, t);
function bl(e, t, n) {
  const o = n.get(e);
  o ? o.push(t) : n.set(e, [t]);
}
function gl(e, t) {
  const n = {};
  let o;
  return e.forEach((a) => {
    if (a.length <= 1)
      return;
    t || (a = a.map((l) => l.map(String)).sort((l, i) => l.length - i.length));
    const [s, ...r] = a;
    s.length === 0 ? o = r.map(Ht) : n[Ht(s)] = r.map(Ht);
  }), o ? tn(n) ? [o] : [o, n] : tn(n) ? void 0 : n;
}
var Ra = (e, t, n, o, a = [], s = [], r = /* @__PURE__ */ new Map()) => {
  var l;
  const i = rl(e);
  if (!i) {
    bl(e, a, t);
    const f = r.get(e);
    if (f)
      return o ? {
        transformedValue: null
      } : f;
  }
  if (!_l(e, n)) {
    const f = Oo(e, n), h = f ? {
      transformedValue: f.value,
      annotations: [f.type]
    } : {
      transformedValue: e
    };
    return i || r.set(e, h), h;
  }
  if (Et(s, e))
    return {
      transformedValue: null
    };
  const u = Oo(e, n), g = (l = u?.value) != null ? l : e, _ = Be(g) ? [] : {}, w = {};
  Qe(g, (f, h) => {
    if (h === "__proto__" || h === "constructor" || h === "prototype")
      throw new Error(`Detected property ${h}. This is a prototype pollution risk, please remove it from your object.`);
    const m = Ra(f, t, n, o, [...a, h], [...s, e], r);
    _[h] = m.transformedValue, Be(m.annotations) ? w[h] = m.annotations : ct(m.annotations) && Qe(m.annotations, (d, c) => {
      w[ka(h) + "." + c] = d;
    });
  });
  const p = tn(w) ? {
    transformedValue: _,
    annotations: u ? [u.type] : void 0
  } : {
    transformedValue: _,
    annotations: u ? [u.type, w] : w
  };
  return i || r.set(e, p), p;
};
E();
E();
function xa(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function Po(e) {
  return xa(e) === "Array";
}
function vl(e) {
  if (xa(e) !== "Object")
    return !1;
  const t = Object.getPrototypeOf(e);
  return !!t && t.constructor === Object && t === Object.prototype;
}
function wl(e, t, n, o, a) {
  const s = {}.propertyIsEnumerable.call(o, t) ? "enumerable" : "nonenumerable";
  s === "enumerable" && (e[t] = n), a && s === "nonenumerable" && Object.defineProperty(e, t, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}
function an(e, t = {}) {
  if (Po(e))
    return e.map((a) => an(a, t));
  if (!vl(e))
    return e;
  const n = Object.getOwnPropertyNames(e), o = Object.getOwnPropertySymbols(e);
  return [...n, ...o].reduce((a, s) => {
    if (Po(t.props) && !t.props.includes(s))
      return a;
    const r = e[s], l = an(r, t);
    return wl(a, s, l, e, t.nonenumerable), a;
  }, {});
}
var Q = class {
  /**
   * @param dedupeReferentialEqualities  If true, SuperJSON will make sure only one instance of referentially equal objects are serialized and the rest are replaced with `null`.
   */
  constructor({ dedupe: e = !1 } = {}) {
    this.classRegistry = new qr(), this.symbolRegistry = new Ca((t) => {
      var n;
      return (n = t.description) != null ? n : "";
    }), this.customTransformerRegistry = new Xr(), this.allowedErrorProps = [], this.dedupe = e;
  }
  serialize(e) {
    const t = /* @__PURE__ */ new Map(), n = Ra(e, t, this, this.dedupe), o = {
      json: n.transformedValue
    };
    n.annotations && (o.meta = {
      ...o.meta,
      values: n.annotations
    });
    const a = gl(t, this.dedupe);
    return a && (o.meta = {
      ...o.meta,
      referentialEqualities: a
    }), o;
  }
  deserialize(e) {
    const { json: t, meta: n } = e;
    let o = an(t);
    return n?.values && (o = hl(o, n.values, this)), n?.referentialEqualities && (o = yl(o, n.referentialEqualities)), o;
  }
  stringify(e) {
    return JSON.stringify(this.serialize(e));
  }
  parse(e) {
    return this.deserialize(JSON.parse(e));
  }
  registerClass(e, t) {
    this.classRegistry.register(e, t);
  }
  registerSymbol(e, t) {
    this.symbolRegistry.register(e, t);
  }
  registerCustom(e, t) {
    this.customTransformerRegistry.register({
      name: t,
      ...e
    });
  }
  allowErrorProps(...e) {
    this.allowedErrorProps.push(...e);
  }
};
Q.defaultInstance = new Q();
Q.serialize = Q.defaultInstance.serialize.bind(Q.defaultInstance);
Q.deserialize = Q.defaultInstance.deserialize.bind(Q.defaultInstance);
Q.stringify = Q.defaultInstance.stringify.bind(Q.defaultInstance);
Q.parse = Q.defaultInstance.parse.bind(Q.defaultInstance);
Q.registerClass = Q.defaultInstance.registerClass.bind(Q.defaultInstance);
Q.registerSymbol = Q.defaultInstance.registerSymbol.bind(Q.defaultInstance);
Q.registerCustom = Q.defaultInstance.registerCustom.bind(Q.defaultInstance);
Q.allowErrorProps = Q.defaultInstance.allowErrorProps.bind(Q.defaultInstance);
E();
E();
E();
E();
E();
E();
E();
E();
E();
E();
E();
E();
E();
E();
E();
E();
E();
E();
E();
E();
E();
E();
E();
var Mo, Fo;
(Fo = (Mo = F).__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__) != null || (Mo.__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__ = []);
var Bo, Do;
(Do = (Bo = F).__VUE_DEVTOOLS_KIT_RPC_CLIENT__) != null || (Bo.__VUE_DEVTOOLS_KIT_RPC_CLIENT__ = null);
var Lo, Ro;
(Ro = (Lo = F).__VUE_DEVTOOLS_KIT_RPC_SERVER__) != null || (Lo.__VUE_DEVTOOLS_KIT_RPC_SERVER__ = null);
var xo, Io;
(Io = (xo = F).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__) != null || (xo.__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ = null);
var No, $o;
($o = (No = F).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__) != null || (No.__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ = null);
var Vo, Uo;
(Uo = (Vo = F).__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__) != null || (Vo.__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__ = null);
E();
E();
E();
E();
E();
E();
E();
/*!
 * pinia v3.0.3
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */
let st;
const Ue = (e) => st = e, Ia = process.env.NODE_ENV !== "production" ? Symbol("pinia") : (
  /* istanbul ignore next */
  Symbol()
);
function Ge(e) {
  return e && typeof e == "object" && Object.prototype.toString.call(e) === "[object Object]" && typeof e.toJSON != "function";
}
var Ae;
(function(e) {
  e.direct = "direct", e.patchObject = "patch object", e.patchFunction = "patch function";
})(Ae || (Ae = {}));
const Me = typeof window < "u", Go = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof global == "object" && global.global === global ? global : typeof globalThis == "object" ? globalThis : { HTMLElement: null };
function El(e, { autoBom: t = !1 } = {}) {
  return t && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob(["\uFEFF", e], { type: e.type }) : e;
}
function On(e, t, n) {
  const o = new XMLHttpRequest();
  o.open("GET", e), o.responseType = "blob", o.onload = function() {
    Va(o.response, t, n);
  }, o.onerror = function() {
    console.error("could not download file");
  }, o.send();
}
function Na(e) {
  const t = new XMLHttpRequest();
  t.open("HEAD", e, !1);
  try {
    t.send();
  } catch {
  }
  return t.status >= 200 && t.status <= 299;
}
function Ct(e) {
  try {
    e.dispatchEvent(new MouseEvent("click"));
  } catch {
    const n = new MouseEvent("click", {
      bubbles: !0,
      cancelable: !0,
      view: window,
      detail: 0,
      screenX: 80,
      screenY: 20,
      clientX: 80,
      clientY: 20,
      ctrlKey: !1,
      altKey: !1,
      shiftKey: !1,
      metaKey: !1,
      button: 0,
      relatedTarget: null
    });
    e.dispatchEvent(n);
  }
}
const St = typeof navigator == "object" ? navigator : { userAgent: "" }, $a = /Macintosh/.test(St.userAgent) && /AppleWebKit/.test(St.userAgent) && !/Safari/.test(St.userAgent), Va = Me ? (
  // Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView or mini program
  typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype && !$a ? Cl : (
    // Use msSaveOrOpenBlob as a second approach
    "msSaveOrOpenBlob" in St ? Sl : (
      // Fallback to using FileReader and a popup
      Al
    )
  )
) : () => {
};
function Cl(e, t = "download", n) {
  const o = document.createElement("a");
  o.download = t, o.rel = "noopener", typeof e == "string" ? (o.href = e, o.origin !== location.origin ? Na(o.href) ? On(e, t, n) : (o.target = "_blank", Ct(o)) : Ct(o)) : (o.href = URL.createObjectURL(e), setTimeout(function() {
    URL.revokeObjectURL(o.href);
  }, 4e4), setTimeout(function() {
    Ct(o);
  }, 0));
}
function Sl(e, t = "download", n) {
  if (typeof e == "string")
    if (Na(e))
      On(e, t, n);
    else {
      const o = document.createElement("a");
      o.href = e, o.target = "_blank", setTimeout(function() {
        Ct(o);
      });
    }
  else
    navigator.msSaveOrOpenBlob(El(e, n), t);
}
function Al(e, t, n, o) {
  if (o = o || open("", "_blank"), o && (o.document.title = o.document.body.innerText = "downloading..."), typeof e == "string")
    return On(e, t, n);
  const a = e.type === "application/octet-stream", s = /constructor/i.test(String(Go.HTMLElement)) || "safari" in Go, r = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((r || a && s || $a) && typeof FileReader < "u") {
    const l = new FileReader();
    l.onloadend = function() {
      let i = l.result;
      if (typeof i != "string")
        throw o = null, new Error("Wrong reader.result type");
      i = r ? i : i.replace(/^data:[^;]*;/, "data:attachment/file;"), o ? o.location.href = i : location.assign(i), o = null;
    }, l.readAsDataURL(e);
  } else {
    const l = URL.createObjectURL(e);
    o ? o.location.assign(l) : location.href = l, o = null, setTimeout(function() {
      URL.revokeObjectURL(l);
    }, 4e4);
  }
}
function re(e, t) {
  const n = "🍍 " + e;
  typeof __VUE_DEVTOOLS_TOAST__ == "function" ? __VUE_DEVTOOLS_TOAST__(n, t) : t === "error" ? console.error(n) : t === "warn" ? console.warn(n) : console.log(n);
}
function Pn(e) {
  return "_a" in e && "install" in e;
}
function Ua() {
  if (!("clipboard" in navigator))
    return re("Your browser doesn't support the Clipboard API", "error"), !0;
}
function Ga(e) {
  return e instanceof Error && e.message.toLowerCase().includes("document is not focused") ? (re('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', "warn"), !0) : !1;
}
async function kl(e) {
  if (!Ua())
    try {
      await navigator.clipboard.writeText(JSON.stringify(e.state.value)), re("Global state copied to clipboard.");
    } catch (t) {
      if (Ga(t))
        return;
      re("Failed to serialize the state. Check the console for more details.", "error"), console.error(t);
    }
}
async function Tl(e) {
  if (!Ua())
    try {
      Ha(e, JSON.parse(await navigator.clipboard.readText())), re("Global state pasted from clipboard.");
    } catch (t) {
      if (Ga(t))
        return;
      re("Failed to deserialize the state from clipboard. Check the console for more details.", "error"), console.error(t);
    }
}
async function Ol(e) {
  try {
    Va(new Blob([JSON.stringify(e.state.value)], {
      type: "text/plain;charset=utf-8"
    }), "pinia-state.json");
  } catch (t) {
    re("Failed to export the state as JSON. Check the console for more details.", "error"), console.error(t);
  }
}
let Te;
function Pl() {
  Te || (Te = document.createElement("input"), Te.type = "file", Te.accept = ".json");
  function e() {
    return new Promise((t, n) => {
      Te.onchange = async () => {
        const o = Te.files;
        if (!o)
          return t(null);
        const a = o.item(0);
        return t(a ? { text: await a.text(), file: a } : null);
      }, Te.oncancel = () => t(null), Te.onerror = n, Te.click();
    });
  }
  return e;
}
async function Ml(e) {
  try {
    const n = await Pl()();
    if (!n)
      return;
    const { text: o, file: a } = n;
    Ha(e, JSON.parse(o)), re(`Global state imported from "${a.name}".`);
  } catch (t) {
    re("Failed to import the state from JSON. Check the console for more details.", "error"), console.error(t);
  }
}
function Ha(e, t) {
  for (const n in t) {
    const o = e.state.value[n];
    o ? Object.assign(o, t[n]) : e.state.value[n] = t[n];
  }
}
function ge(e) {
  return {
    _custom: {
      display: e
    }
  };
}
const Wa = "🍍 Pinia (root)", At = "_root";
function Fl(e) {
  return Pn(e) ? {
    id: At,
    label: Wa
  } : {
    id: e.$id,
    label: e.$id
  };
}
function Bl(e) {
  if (Pn(e)) {
    const n = Array.from(e._s.keys()), o = e._s;
    return {
      state: n.map((s) => ({
        editable: !0,
        key: s,
        value: e.state.value[s]
      })),
      getters: n.filter((s) => o.get(s)._getters).map((s) => {
        const r = o.get(s);
        return {
          editable: !1,
          key: s,
          value: r._getters.reduce((l, i) => (l[i] = r[i], l), {})
        };
      })
    };
  }
  const t = {
    state: Object.keys(e.$state).map((n) => ({
      editable: !0,
      key: n,
      value: e.$state[n]
    }))
  };
  return e._getters && e._getters.length && (t.getters = e._getters.map((n) => ({
    editable: !1,
    key: n,
    value: e[n]
  }))), e._customProperties.size && (t.customProperties = Array.from(e._customProperties).map((n) => ({
    editable: !0,
    key: n,
    value: e[n]
  }))), t;
}
function Dl(e) {
  return e ? Array.isArray(e) ? e.reduce((t, n) => (t.keys.push(n.key), t.operations.push(n.type), t.oldValue[n.key] = n.oldValue, t.newValue[n.key] = n.newValue, t), {
    oldValue: {},
    keys: [],
    operations: [],
    newValue: {}
  }) : {
    operation: ge(e.type),
    key: ge(e.key),
    oldValue: e.oldValue,
    newValue: e.newValue
  } : {};
}
function Ll(e) {
  switch (e) {
    case Ae.direct:
      return "mutation";
    case Ae.patchFunction:
      return "$patch";
    case Ae.patchObject:
      return "$patch";
    default:
      return "unknown";
  }
}
let qe = !0;
const kt = [], De = "pinia:mutations", ue = "pinia", { assign: Rl } = Object, Bt = (e) => "🍍 " + e;
function xl(e, t) {
  wa({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes: kt,
    app: e
  }, (n) => {
    typeof n.now != "function" && re("You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html."), n.addTimelineLayer({
      id: De,
      label: "Pinia 🍍",
      color: 15064968
    }), n.addInspector({
      id: ue,
      label: "Pinia 🍍",
      icon: "storage",
      treeFilterPlaceholder: "Search stores",
      actions: [
        {
          icon: "content_copy",
          action: () => {
            kl(t);
          },
          tooltip: "Serialize and copy the state"
        },
        {
          icon: "content_paste",
          action: async () => {
            await Tl(t), n.sendInspectorTree(ue), n.sendInspectorState(ue);
          },
          tooltip: "Replace the state with the content of your clipboard"
        },
        {
          icon: "save",
          action: () => {
            Ol(t);
          },
          tooltip: "Save the state as a JSON file"
        },
        {
          icon: "folder_open",
          action: async () => {
            await Ml(t), n.sendInspectorTree(ue), n.sendInspectorState(ue);
          },
          tooltip: "Import the state from a JSON file"
        }
      ],
      nodeActions: [
        {
          icon: "restore",
          tooltip: 'Reset the state (with "$reset")',
          action: (o) => {
            const a = t._s.get(o);
            a ? typeof a.$reset != "function" ? re(`Cannot reset "${o}" store because it doesn't have a "$reset" method implemented.`, "warn") : (a.$reset(), re(`Store "${o}" reset.`)) : re(`Cannot reset "${o}" store because it wasn't found.`, "warn");
          }
        }
      ]
    }), n.on.inspectComponent((o) => {
      const a = o.componentInstance && o.componentInstance.proxy;
      if (a && a._pStores) {
        const s = o.componentInstance.proxy._pStores;
        Object.values(s).forEach((r) => {
          o.instanceData.state.push({
            type: Bt(r.$id),
            key: "state",
            editable: !0,
            value: r._isOptionsAPI ? {
              _custom: {
                value: Ye(r.$state),
                actions: [
                  {
                    icon: "restore",
                    tooltip: "Reset the state of this store",
                    action: () => r.$reset()
                  }
                ]
              }
            } : (
              // NOTE: workaround to unwrap transferred refs
              Object.keys(r.$state).reduce((l, i) => (l[i] = r.$state[i], l), {})
            )
          }), r._getters && r._getters.length && o.instanceData.state.push({
            type: Bt(r.$id),
            key: "getters",
            editable: !1,
            value: r._getters.reduce((l, i) => {
              try {
                l[i] = r[i];
              } catch (u) {
                l[i] = u;
              }
              return l;
            }, {})
          });
        });
      }
    }), n.on.getInspectorTree((o) => {
      if (o.app === e && o.inspectorId === ue) {
        let a = [t];
        a = a.concat(Array.from(t._s.values())), o.rootNodes = (o.filter ? a.filter((s) => "$id" in s ? s.$id.toLowerCase().includes(o.filter.toLowerCase()) : Wa.toLowerCase().includes(o.filter.toLowerCase())) : a).map(Fl);
      }
    }), globalThis.$pinia = t, n.on.getInspectorState((o) => {
      if (o.app === e && o.inspectorId === ue) {
        const a = o.nodeId === At ? t : t._s.get(o.nodeId);
        if (!a)
          return;
        a && (o.nodeId !== At && (globalThis.$store = Ye(a)), o.state = Bl(a));
      }
    }), n.on.editInspectorState((o) => {
      if (o.app === e && o.inspectorId === ue) {
        const a = o.nodeId === At ? t : t._s.get(o.nodeId);
        if (!a)
          return re(`store "${o.nodeId}" not found`, "error");
        const { path: s } = o;
        Pn(a) ? s.unshift("state") : (s.length !== 1 || !a._customProperties.has(s[0]) || s[0] in a.$state) && s.unshift("$state"), qe = !1, o.set(a, s, o.state.value), qe = !0;
      }
    }), n.on.editComponentState((o) => {
      if (o.type.startsWith("🍍")) {
        const a = o.type.replace(/^🍍\s*/, ""), s = t._s.get(a);
        if (!s)
          return re(`store "${a}" not found`, "error");
        const { path: r } = o;
        if (r[0] !== "state")
          return re(`Invalid path for store "${a}":
${r}
Only state can be modified.`);
        r[0] = "$state", qe = !1, o.set(s, r, o.state.value), qe = !0;
      }
    });
  });
}
function Il(e, t) {
  kt.includes(Bt(t.$id)) || kt.push(Bt(t.$id)), wa({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes: kt,
    app: e,
    settings: {
      logStoreChanges: {
        label: "Notify about new/deleted stores",
        type: "boolean",
        defaultValue: !0
      }
      // useEmojis: {
      //   label: 'Use emojis in messages ⚡️',
      //   type: 'boolean',
      //   defaultValue: true,
      // },
    }
  }, (n) => {
    const o = typeof n.now == "function" ? n.now.bind(n) : Date.now;
    t.$onAction(({ after: r, onError: l, name: i, args: u }) => {
      const g = za++;
      n.addTimelineEvent({
        layerId: De,
        event: {
          time: o(),
          title: "🛫 " + i,
          subtitle: "start",
          data: {
            store: ge(t.$id),
            action: ge(i),
            args: u
          },
          groupId: g
        }
      }), r((_) => {
        Fe = void 0, n.addTimelineEvent({
          layerId: De,
          event: {
            time: o(),
            title: "🛬 " + i,
            subtitle: "end",
            data: {
              store: ge(t.$id),
              action: ge(i),
              args: u,
              result: _
            },
            groupId: g
          }
        });
      }), l((_) => {
        Fe = void 0, n.addTimelineEvent({
          layerId: De,
          event: {
            time: o(),
            logType: "error",
            title: "💥 " + i,
            subtitle: "end",
            data: {
              store: ge(t.$id),
              action: ge(i),
              args: u,
              error: _
            },
            groupId: g
          }
        });
      });
    }, !0), t._customProperties.forEach((r) => {
      Y(() => O(t[r]), (l, i) => {
        n.notifyComponentUpdate(), n.sendInspectorState(ue), qe && n.addTimelineEvent({
          layerId: De,
          event: {
            time: o(),
            title: "Change",
            subtitle: r,
            data: {
              newValue: l,
              oldValue: i
            },
            groupId: Fe
          }
        });
      }, { deep: !0 });
    }), t.$subscribe(({ events: r, type: l }, i) => {
      if (n.notifyComponentUpdate(), n.sendInspectorState(ue), !qe)
        return;
      const u = {
        time: o(),
        title: Ll(l),
        data: Rl({ store: ge(t.$id) }, Dl(r)),
        groupId: Fe
      };
      l === Ae.patchFunction ? u.subtitle = "⤵️" : l === Ae.patchObject ? u.subtitle = "🧩" : r && !Array.isArray(r) && (u.subtitle = r.type), r && (u.data["rawEvent(s)"] = {
        _custom: {
          display: "DebuggerEvent",
          type: "object",
          tooltip: "raw DebuggerEvent[]",
          value: r
        }
      }), n.addTimelineEvent({
        layerId: De,
        event: u
      });
    }, { detached: !0, flush: "sync" });
    const a = t._hotUpdate;
    t._hotUpdate = Le((r) => {
      a(r), n.addTimelineEvent({
        layerId: De,
        event: {
          time: o(),
          title: "🔥 " + t.$id,
          subtitle: "HMR update",
          data: {
            store: ge(t.$id),
            info: ge("HMR update")
          }
        }
      }), n.notifyComponentUpdate(), n.sendInspectorTree(ue), n.sendInspectorState(ue);
    });
    const { $dispose: s } = t;
    t.$dispose = () => {
      s(), n.notifyComponentUpdate(), n.sendInspectorTree(ue), n.sendInspectorState(ue), n.getSettings().logStoreChanges && re(`Disposed "${t.$id}" store 🗑`);
    }, n.notifyComponentUpdate(), n.sendInspectorTree(ue), n.sendInspectorState(ue), n.getSettings().logStoreChanges && re(`"${t.$id}" store installed 🆕`);
  });
}
let za = 0, Fe;
function Ho(e, t, n) {
  const o = t.reduce((a, s) => (a[s] = Ye(e)[s], a), {});
  for (const a in o)
    e[a] = function() {
      const s = za, r = n ? new Proxy(e, {
        get(...i) {
          return Fe = s, Reflect.get(...i);
        },
        set(...i) {
          return Fe = s, Reflect.set(...i);
        }
      }) : e;
      Fe = s;
      const l = o[a].apply(r, arguments);
      return Fe = void 0, l;
    };
}
function Nl({ app: e, store: t, options: n }) {
  if (!t.$id.startsWith("__hot:")) {
    if (t._isOptionsAPI = !!n.state, !t._p._testing) {
      Ho(t, Object.keys(n.actions), t._isOptionsAPI);
      const o = t._hotUpdate;
      Ye(t)._hotUpdate = function(a) {
        o.apply(this, arguments), Ho(t, Object.keys(a._hmrPayload.actions), !!t._isOptionsAPI);
      };
    }
    Il(
      e,
      // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
      t
    );
  }
}
function Ka() {
  const e = Qo(!0), t = e.run(() => B({}));
  let n = [], o = [];
  const a = Le({
    install(s) {
      Ue(a), a._a = s, s.provide(Ia, a), s.config.globalProperties.$pinia = a, process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && Me && xl(s, a), o.forEach((r) => n.push(r)), o = [];
    },
    use(s) {
      return this._a ? n.push(s) : o.push(s), this;
    },
    _p: n,
    // it's actually undefined here
    // @ts-expect-error
    _a: null,
    _e: e,
    _s: /* @__PURE__ */ new Map(),
    state: t
  });
  return process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && Me && typeof Proxy < "u" && a.use(Nl), a;
}
function ja(e, t) {
  for (const n in t) {
    const o = t[n];
    if (!(n in e))
      continue;
    const a = e[n];
    Ge(a) && Ge(o) && !Ie(o) && !Lt(o) ? e[n] = ja(a, o) : e[n] = o;
  }
  return e;
}
const qa = () => {
};
function Wo(e, t, n, o = qa) {
  e.push(t);
  const a = () => {
    const s = e.indexOf(t);
    s > -1 && (e.splice(s, 1), o());
  };
  return !n && ds() && ps(a), a;
}
function ze(e, ...t) {
  e.slice().forEach((n) => {
    n(...t);
  });
}
const $l = (e) => e(), zo = Symbol(), Wt = Symbol();
function sn(e, t) {
  e instanceof Map && t instanceof Map ? t.forEach((n, o) => e.set(o, n)) : e instanceof Set && t instanceof Set && t.forEach(e.add, e);
  for (const n in t) {
    if (!t.hasOwnProperty(n))
      continue;
    const o = t[n], a = e[n];
    Ge(a) && Ge(o) && e.hasOwnProperty(n) && !Ie(o) && !Lt(o) ? e[n] = sn(a, o) : e[n] = o;
  }
  return e;
}
const Vl = process.env.NODE_ENV !== "production" ? Symbol("pinia:skipHydration") : (
  /* istanbul ignore next */
  Symbol()
);
function Ul(e) {
  return !Ge(e) || !Object.prototype.hasOwnProperty.call(e, Vl);
}
const { assign: _e } = Object;
function Ko(e) {
  return !!(Ie(e) && e.effect);
}
function jo(e, t, n, o) {
  const { state: a, actions: s, getters: r } = t, l = n.state.value[e];
  let i;
  function u() {
    !l && (process.env.NODE_ENV === "production" || !o) && (n.state.value[e] = a ? a() : {});
    const g = process.env.NODE_ENV !== "production" && o ? (
      // use ref() to unwrap refs inside state TODO: check if this is still necessary
      In(B(a ? a() : {}).value)
    ) : In(n.state.value[e]);
    return _e(g, s, Object.keys(r || {}).reduce((_, w) => (process.env.NODE_ENV !== "production" && w in g && console.warn(`[🍍]: A getter cannot have the same name as another state property. Rename one of them. Found with "${w}" in store "${e}".`), _[w] = Le($(() => {
      Ue(n);
      const p = n._s.get(e);
      return r[w].call(p, p);
    })), _), {}));
  }
  return i = rn(e, u, t, n, o, !0), i;
}
function rn(e, t, n = {}, o, a, s) {
  let r;
  const l = _e({ actions: {} }, n);
  if (process.env.NODE_ENV !== "production" && !o._e.active)
    throw new Error("Pinia destroyed");
  const i = { deep: !0 };
  process.env.NODE_ENV !== "production" && (i.onTrigger = (M) => {
    u ? p = M : u == !1 && !T._hotUpdating && (Array.isArray(p) ? p.push(M) : console.error("🍍 debuggerEvents should be an array. This is most likely an internal Pinia bug."));
  });
  let u, g, _ = [], w = [], p;
  const f = o.state.value[e];
  !s && !f && (process.env.NODE_ENV === "production" || !a) && (o.state.value[e] = {});
  const h = B({});
  let m;
  function d(M) {
    let S;
    u = g = !1, process.env.NODE_ENV !== "production" && (p = []), typeof M == "function" ? (M(o.state.value[e]), S = {
      type: Ae.patchFunction,
      storeId: e,
      events: p
    }) : (sn(o.state.value[e], M), S = {
      type: Ae.patchObject,
      payload: M,
      storeId: e,
      events: p
    });
    const U = m = Symbol();
    Mt().then(() => {
      m === U && (u = !0);
    }), g = !0, ze(_, S, o.state.value[e]);
  }
  const c = s ? function() {
    const { state: S } = n, U = S ? S() : {};
    this.$patch((x) => {
      _e(x, U);
    });
  } : (
    /* istanbul ignore next */
    process.env.NODE_ENV !== "production" ? () => {
      throw new Error(`🍍: Store "${e}" is built using the setup syntax and does not implement $reset().`);
    } : qa
  );
  function y() {
    r.stop(), _ = [], w = [], o._s.delete(e);
  }
  const A = (M, S = "") => {
    if (zo in M)
      return M[Wt] = S, M;
    const U = function() {
      Ue(o);
      const x = Array.from(arguments), G = [], N = [];
      function H(X) {
        G.push(X);
      }
      function D(X) {
        N.push(X);
      }
      ze(w, {
        args: x,
        name: U[Wt],
        store: T,
        after: H,
        onError: D
      });
      let ne;
      try {
        ne = M.apply(this && this.$id === e ? this : T, x);
      } catch (X) {
        throw ze(N, X), X;
      }
      return ne instanceof Promise ? ne.then((X) => (ze(G, X), X)).catch((X) => (ze(N, X), Promise.reject(X))) : (ze(G, ne), ne);
    };
    return U[zo] = !0, U[Wt] = S, U;
  }, k = /* @__PURE__ */ Le({
    actions: {},
    getters: {},
    state: [],
    hotState: h
  }), R = {
    _p: o,
    // _s: scope,
    $id: e,
    $onAction: Wo.bind(null, w),
    $patch: d,
    $reset: c,
    $subscribe(M, S = {}) {
      const U = Wo(_, M, S.detached, () => x()), x = r.run(() => Y(() => o.state.value[e], (G) => {
        (S.flush === "sync" ? g : u) && M({
          storeId: e,
          type: Ae.direct,
          events: p
        }, G);
      }, _e({}, i, S)));
      return U;
    },
    $dispose: y
  }, T = mn(process.env.NODE_ENV !== "production" || process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && Me ? _e(
    {
      _hmrPayload: k,
      _customProperties: Le(/* @__PURE__ */ new Set())
      // devtools custom properties
    },
    R
    // must be added later
    // setupStore
  ) : R);
  o._s.set(e, T);
  const Z = (o._a && o._a.runWithContext || $l)(() => o._e.run(() => (r = Qo()).run(() => t({ action: A }))));
  for (const M in Z) {
    const S = Z[M];
    if (Ie(S) && !Ko(S) || Lt(S))
      process.env.NODE_ENV !== "production" && a ? h.value[M] = xe(Z, M) : s || (f && Ul(S) && (Ie(S) ? S.value = f[M] : sn(S, f[M])), o.state.value[e][M] = S), process.env.NODE_ENV !== "production" && k.state.push(M);
    else if (typeof S == "function") {
      const U = process.env.NODE_ENV !== "production" && a ? S : A(S, M);
      Z[M] = U, process.env.NODE_ENV !== "production" && (k.actions[M] = S), l.actions[M] = S;
    } else process.env.NODE_ENV !== "production" && Ko(S) && (k.getters[M] = s ? (
      // @ts-expect-error
      n.getters[M]
    ) : S, Me && (Z._getters || // @ts-expect-error: same
    (Z._getters = Le([]))).push(M));
  }
  if (_e(T, Z), _e(Ye(T), Z), Object.defineProperty(T, "$state", {
    get: () => process.env.NODE_ENV !== "production" && a ? h.value : o.state.value[e],
    set: (M) => {
      if (process.env.NODE_ENV !== "production" && a)
        throw new Error("cannot set hotState");
      d((S) => {
        _e(S, M);
      });
    }
  }), process.env.NODE_ENV !== "production" && (T._hotUpdate = Le((M) => {
    T._hotUpdating = !0, M._hmrPayload.state.forEach((S) => {
      if (S in T.$state) {
        const U = M.$state[S], x = T.$state[S];
        typeof U == "object" && Ge(U) && Ge(x) ? ja(U, x) : M.$state[S] = x;
      }
      T[S] = xe(M.$state, S);
    }), Object.keys(T.$state).forEach((S) => {
      S in M.$state || delete T[S];
    }), u = !1, g = !1, o.state.value[e] = xe(M._hmrPayload, "hotState"), g = !0, Mt().then(() => {
      u = !0;
    });
    for (const S in M._hmrPayload.actions) {
      const U = M[S];
      T[S] = //
      A(U, S);
    }
    for (const S in M._hmrPayload.getters) {
      const U = M._hmrPayload.getters[S], x = s ? (
        // special handling of options api
        $(() => (Ue(o), U.call(T, T)))
      ) : U;
      T[S] = //
      x;
    }
    Object.keys(T._hmrPayload.getters).forEach((S) => {
      S in M._hmrPayload.getters || delete T[S];
    }), Object.keys(T._hmrPayload.actions).forEach((S) => {
      S in M._hmrPayload.actions || delete T[S];
    }), T._hmrPayload = M._hmrPayload, T._getters = M._getters, T._hotUpdating = !1;
  })), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && Me) {
    const M = {
      writable: !0,
      configurable: !0,
      // avoid warning on devtools trying to display this property
      enumerable: !1
    };
    ["_p", "_hmrPayload", "_getters", "_customProperties"].forEach((S) => {
      Object.defineProperty(T, S, _e({ value: T[S] }, M));
    });
  }
  return o._p.forEach((M) => {
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && Me) {
      const S = r.run(() => M({
        store: T,
        app: o._a,
        pinia: o,
        options: l
      }));
      Object.keys(S || {}).forEach((U) => T._customProperties.add(U)), _e(T, S);
    } else
      _e(T, r.run(() => M({
        store: T,
        app: o._a,
        pinia: o,
        options: l
      })));
  }), process.env.NODE_ENV !== "production" && T.$state && typeof T.$state == "object" && typeof T.$state.constructor == "function" && !T.$state.constructor.toString().includes("[native code]") && console.warn(`[🍍]: The "state" must be a plain object. It cannot be
	state: () => new MyClass()
Found in store "${T.$id}".`), f && s && n.hydrate && n.hydrate(T.$state, f), u = !0, g = !0, T;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Mn(e, t, n) {
  let o;
  const a = typeof t == "function";
  o = a ? n : t;
  function s(r, l) {
    const i = is();
    if (r = // in test mode, ignore the argument provided as we can always retrieve a
    // pinia instance with getActivePinia()
    (process.env.NODE_ENV === "test" && st && st._testing ? null : r) || (i ? us(Ia, null) : null), r && Ue(r), process.env.NODE_ENV !== "production" && !st)
      throw new Error(`[🍍]: "getActivePinia()" was called but there was no active Pinia. Are you trying to use a store before calling "app.use(pinia)"?
See https://pinia.vuejs.org/core-concepts/outside-component-usage.html for help.
This will fail in production.`);
    r = st, r._s.has(e) || (a ? rn(e, t, o, r) : jo(e, o, r), process.env.NODE_ENV !== "production" && (s._pinia = r));
    const u = r._s.get(e);
    if (process.env.NODE_ENV !== "production" && l) {
      const g = "__hot:" + e, _ = a ? rn(g, t, o, r, !0) : jo(g, _e({}, o), r, !0);
      l._hotUpdate(_), delete r.state.value[g], r._s.delete(g);
    }
    if (process.env.NODE_ENV !== "production" && Me) {
      const g = cs();
      if (g && g.proxy && // avoid adding stores that are just built for hot module replacement
      !l) {
        const _ = g.proxy, w = "_pStores" in _ ? _._pStores : _._pStores = {};
        w[e] = u;
      }
    }
    return u;
  }
  return s.$id = e, s;
}
function ke(e) {
  const t = Ye(e), n = {};
  for (const o in t) {
    const a = t[o];
    a.effect ? n[o] = // ...
    $({
      get: () => e[o],
      set(s) {
        e[o] = s;
      }
    }) : (Ie(a) || Lt(a)) && (n[o] = // ---
    xe(e, o));
  }
  return n;
}
const Gl = (e, t, n) => {
  const o = e[t];
  return o ? typeof o == "function" ? o() : Promise.resolve(o) : new Promise((a, s) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(s.bind(null, /* @__PURE__ */ new Error("Unknown variable dynamic import: " + t + (t.split("/").length !== n ? ". Note that variables only represent file names one level deep." : ""))));
  });
}, Hl = ["aria-label", "innerHTML"], ee = /* @__PURE__ */ W({
  __name: "IconComponent",
  props: {
    name: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      default: ""
    },
    fill: {
      type: String,
      default: ""
    },
    stroke: {
      type: String,
      default: ""
    },
    strokeWidth: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: ""
    },
    height: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, n = B(null), o = $(() => {
      const s = {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: "1",
        flexShrink: "0"
      }, r = (u) => u && (/^\d+$/.test(u) ? `${u}px` : u), l = t.width || t.size, i = t.height || t.size;
      return l && (s.width = r(l)), i && (s.height = r(i)), s;
    });
    return Y(() => [t], async () => {
      if (t.name)
        try {
          let r = (await Gl(/* @__PURE__ */ Object.assign({ "../../assets/icons/arrow-down.svg": () => import("./arrow-down-BYAqwbmm.js"), "../../assets/icons/arrow-left.svg": () => import("./arrow-left-BRet2zIC.js"), "../../assets/icons/arrow-right.svg": () => import("./arrow-right-BXgs_TC_.js"), "../../assets/icons/arrow-up.svg": () => import("./arrow-up-D5RccNKS.js"), "../../assets/icons/avatar-alt.svg": () => import("./avatar-alt-BJCyDeeS.js"), "../../assets/icons/avatar.svg": () => import("./avatar-DdgJSgNK.js"), "../../assets/icons/basket.svg": () => import("./basket-CZ4S0aoh.js"), "../../assets/icons/calendar.svg": () => import("./calendar-BjZeWZDz.js"), "../../assets/icons/chevron-down.svg": () => import("./chevron-down-B7-8E3fh.js"), "../../assets/icons/chevron-left.svg": () => import("./chevron-left-B63Sd5Eu.js"), "../../assets/icons/chevron-right.svg": () => import("./chevron-right-DHF-71_A.js"), "../../assets/icons/chevron-up.svg": () => import("./chevron-up-DMr23L5x.js"), "../../assets/icons/clock-openinghours.svg": () => import("./clock-openinghours-BwjHDdu3.js"), "../../assets/icons/clock.svg": () => import("./clock-C8tilXt4.js"), "../../assets/icons/close-alt.svg": () => import("./close-alt-K0LfLWGo.js"), "../../assets/icons/close.svg": () => import("./close-DH6R0JOc.js"), "../../assets/icons/coop-card.svg": () => import("./coop-card-ChswYoaz.js"), "../../assets/icons/coop-location.svg": () => import("./coop-location-Cclq6clq.js"), "../../assets/icons/coop-logo.svg": () => import("./coop-logo-CFiMAh1u.js"), "../../assets/icons/coop.svg": () => import("./coop-idIqo7m8.js"), "../../assets/icons/current-location.svg": () => import("./current-location-CLsmfWJ7.js"), "../../assets/icons/directions.svg": () => import("./directions-Co1I2ec5.js"), "../../assets/icons/download.svg": () => import("./download-Cuw8dXvd.js"), "../../assets/icons/funeral-directors.svg": () => import("./funeral-directors-CL-Mg3rN.js"), "../../assets/icons/gift-tray.svg": () => import("./gift-tray-DBRKnT_w.js"), "../../assets/icons/hands-heart.svg": () => import("./hands-heart-CSNreQaS.js"), "../../assets/icons/handshake.svg": () => import("./handshake-DC-ar7kI.js"), "../../assets/icons/home.svg": () => import("./home-C-D6CE1b.js"), "../../assets/icons/information.svg": () => import("./information-DpZAwHPq.js"), "../../assets/icons/list.svg": () => import("./list-B4AHYwuu.js"), "../../assets/icons/location.svg": () => import("./location-B2WuMd84.js"), "../../assets/icons/mail.svg": () => import("./mail-BZV7R-ib.js"), "../../assets/icons/marker.svg": () => import("./marker-BS6tvp7N.js"), "../../assets/icons/menu.svg": () => import("./menu-DUbsyfge.js"), "../../assets/icons/message.svg": () => import("./message-C67CbtPr.js"), "../../assets/icons/minus.svg": () => import("./minus-jqGW-4zP.js"), "../../assets/icons/open-new.svg": () => import("./open-new-DG5aeBf9.js"), "../../assets/icons/pencil.svg": () => import("./pencil-BevzVUJw.js"), "../../assets/icons/people-talking.svg": () => import("./people-talking-D-J69YQN.js"), "../../assets/icons/phone.svg": () => import("./phone-XBUNBe_S.js"), "../../assets/icons/plus.svg": () => import("./plus-reBXnEdk.js"), "../../assets/icons/print.svg": () => import("./print-dWryu5XY.js"), "../../assets/icons/question.svg": () => import("./question-CZNWNyyc.js"), "../../assets/icons/save.svg": () => import("./save-CwW_yk_9.js"), "../../assets/icons/scooter.svg": () => import("./scooter-DfTfEtEQ.js"), "../../assets/icons/search.svg": () => import("./search-DFFWPVaB.js"), "../../assets/icons/settings.svg": () => import("./settings-CQZDfMsL.js"), "../../assets/icons/tick-alt-fill.svg": () => import("./tick-alt-fill-B4EjzEj9.js"), "../../assets/icons/tick-alt.svg": () => import("./tick-alt-EWk5nLZT.js"), "../../assets/icons/tick.svg": () => import("./tick-BW5o7gFh.js"), "../../assets/icons/van.svg": () => import("./van-BUV-fPao.js"), "../../assets/icons/warning.svg": () => import("./warning-RQhS6WkY.js"), "../../assets/icons/write.svg": () => import("./write-BYRuhbKJ.js") }), `../../assets/icons/${t.name}.svg`, 5)).default;
          const l = "display: block; width: 100%; height: 100%; overflow: visible;";
          let i = "";
          t.fill && (r = r.replace(/fill="[^"]*"/g, ""), i += `fill: ${t.fill}; `), t.stroke && (r = r.replace(/stroke="[^"]*"/g, ""), i += `stroke: ${t.stroke}; `), t.strokeWidth && (r = r.replace(/stroke-width="[^"]*"/g, ""), i += `stroke-width: ${t.strokeWidth}; `), r = r.replace(/\s*style="[^"]*"/g, ""), r = r.replace(/\s*preserveAspectRatio="[^"]*"/g, ""), r = r.replace(
            "<svg",
            `<svg preserveAspectRatio="xMidYMid meet" style="${l}${i}"`
          ), n.value = r;
        } catch (s) {
          console.error(`Failed to load icon: ${t.name}.svg`, s), n.value = null;
        }
    }, { immediate: !0, deep: !0 }), (s, r) => n.value ? (b(), v("span", {
      key: 0,
      style: ms(o.value),
      "aria-label": `${t.name} icon`,
      role: "img",
      innerHTML: n.value
    }, null, 12, Hl)) : P("", !0);
  }
}), Wl = ["data-cy"], zl = ["innerHTML"], Kl = { key: 0 }, jl = {
  key: 0,
  class: "fnc-accordion__content"
}, ql = /* @__PURE__ */ W({
  __name: "AccordionComponent",
  props: {
    label: {
      type: String,
      required: !0
    },
    collapsable: {
      type: Boolean,
      default: !1
    },
    startOpen: {
      type: Boolean,
      default: !1
    },
    selected: {
      type: Boolean,
      default: !1
    },
    currentSection: {
      type: String,
      default: ""
    }
  },
  emits: ["toggle"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = B(n.startOpen), s = () => {
      n.collapsable && (a.value = !a.value, o("toggle", a.value));
    };
    Y(
      () => n.currentSection,
      (l) => {
        l === n.label ? a.value = !0 : a.value = !1;
      }
    );
    const r = (l) => {
      (l.key === "Enter" || l.key === " ") && (l.preventDefault(), l.stopPropagation(), s());
    };
    return (l, i) => (b(), v("div", {
      class: q(["fnc-accordion", [{ "fnc-accordion--collapsable": e.collapsable }]]),
      "data-cy": e.label
    }, [
      C("button", {
        class: q(["fnc-accordion__header", {
          "fnc-accordion__header--selected": e.selected,
          "fnc-accordion__header--closed": !a.value
        }]),
        tabindex: "0",
        onClick: s,
        onKeydown: r
      }, [
        C("span", { innerHTML: e.label }, null, 8, zl),
        e.collapsable ? (b(), v("span", Kl, [
          V(ee, {
            name: a.value ? "chevron-up" : "chevron-down",
            size: "16px"
          }, null, 8, ["name"])
        ])) : P("", !0)
      ], 34),
      a.value || !e.collapsable ? (b(), v("div", jl, [
        ve(l.$slots, "default", {}, void 0, !0)
      ])) : P("", !0)
    ], 10, Wl));
  }
}), te = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, a] of t)
    n[o] = a;
  return n;
}, Ya = /* @__PURE__ */ te(ql, [["__scopeId", "data-v-6c56b6fa"]]), Yl = "data:image/svg+xml,%3csvg%20version='1.1'%20id='svg3409'%20inkscape:version='0.91%20r13725'%20sodipodi:docname='MasterCard%202016.svg'%20xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape'%20xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd'%20xmlns='http://www.w3.org/2000/svg'%20x='0px'%20y='0px'%20viewBox='0%200%20999.2%20776'%20enable-background='new%200%200%20999.2%20776'%20xml:space='preserve'%3e%3cpath%20id='XMLID_1775_'%20inkscape:connector-curvature='0'%20d='M181.1,774.3v-51.5c0-19.7-12-32.6-32.6-32.6%20c-10.3,0-21.5,3.4-29.2,14.6c-6-9.4-14.6-14.6-27.5-14.6c-8.6,0-17.2,2.6-24,12v-10.3h-18v82.4h18v-45.5c0-14.6,7.7-21.5,19.7-21.5%20s18,7.7,18,21.5v45.5h18v-45.5c0-14.6,8.6-21.5,19.7-21.5c12,0,18,7.7,18,21.5v45.5H181.1z%20M448.1,691.9h-29.2V667h-18v24.9h-16.3%20v16.3h16.3v37.8c0,18.9,7.7,30,28.3,30c7.7,0,16.3-2.6,22.3-6l-5.2-15.5c-5.2,3.4-11.2,4.3-15.5,4.3c-8.6,0-12-5.2-12-13.7v-36.9%20h29.2V691.9z%20M600.9,690.1c-10.3,0-17.2,5.2-21.5,12v-10.3h-18v82.4h18v-46.4c0-13.7,6-21.5,17.2-21.5c3.4,0,7.7,0.9,11.2,1.7%20l5.2-17.2C609.4,690.1,604.3,690.1,600.9,690.1L600.9,690.1z%20M370,698.7c-8.6-6-20.6-8.6-33.5-8.6c-20.6,0-34.3,10.3-34.3,26.6%20c0,13.7,10.3,21.5,28.3,24l8.6,0.9c9.4,1.7,14.6,4.3,14.6,8.6c0,6-6.9,10.3-18.9,10.3c-12,0-21.5-4.3-27.5-8.6l-8.6,13.7%20c9.4,6.9,22.3,10.3,35.2,10.3c24,0,37.8-11.2,37.8-26.6c0-14.6-11.2-22.3-28.3-24.9l-8.6-0.9c-7.7-0.9-13.7-2.6-13.7-7.7%20c0-6,6-9.4,15.5-9.4c10.3,0,20.6,4.3,25.8,6.9L370,698.7L370,698.7z%20M848.9,690.1c-10.3,0-17.2,5.2-21.5,12v-10.3h-18v82.4h18v-46.4%20c0-13.7,6-21.5,17.2-21.5c3.4,0,7.7,0.9,11.2,1.7L861,691C857.5,690.1,852.4,690.1,848.9,690.1L848.9,690.1z%20M618.9,733.1%20c0,24.9,17.2,42.9,43.8,42.9c12,0,20.6-2.6,29.2-9.4l-8.6-14.6c-6.9,5.2-13.7,7.7-21.5,7.7c-14.6,0-24.9-10.3-24.9-26.6%20c0-15.5,10.3-25.8,24.9-26.6c7.7,0,14.6,2.6,21.5,7.7l8.6-14.6c-8.6-6.9-17.2-9.4-29.2-9.4C636.1,690.1,618.9,708.2,618.9,733.1%20L618.9,733.1L618.9,733.1z%20M785.4,733.1v-41.2h-18v10.3c-6-7.7-14.6-12-25.8-12c-23.2,0-41.2,18-41.2,42.9c0,24.9,18,42.9,41.2,42.9%20c12,0,20.6-4.3,25.8-12v10.3h18V733.1L785.4,733.1z%20M719.3,733.1c0-14.6,9.4-26.6,24.9-26.6c14.6,0,24.9,11.2,24.9,26.6%20c0,14.6-10.3,26.6-24.9,26.6C728.8,758.8,719.3,747.6,719.3,733.1L719.3,733.1z%20M503.9,690.1c-24,0-41.2,17.2-41.2,42.9%20c0,25.8,17.2,42.9,42.1,42.9c12,0,24-3.4,33.5-11.2l-8.6-12.9c-6.9,5.2-15.5,8.6-24,8.6c-11.2,0-22.3-5.2-24.9-19.7h60.9%20c0-2.6,0-4.3,0-6.9C542.5,707.3,527,690.1,503.9,690.1L503.9,690.1L503.9,690.1z%20M503.9,705.6c11.2,0,18.9,6.9,20.6,19.7h-42.9%20C483.3,714.2,491,705.6,503.9,705.6L503.9,705.6z%20M951.1,733.1v-73.8h-18v42.9c-6-7.7-14.6-12-25.8-12c-23.2,0-41.2,18-41.2,42.9%20c0,24.9,18,42.9,41.2,42.9c12,0,20.6-4.3,25.8-12v10.3h18V733.1L951.1,733.1z%20M885,733.1c0-14.6,9.4-26.6,24.9-26.6%20c14.6,0,24.9,11.2,24.9,26.6c0,14.6-10.3,26.6-24.9,26.6C894.4,758.8,885,747.6,885,733.1L885,733.1z%20M282.4,733.1v-41.2h-18v10.3%20c-6-7.7-14.6-12-25.8-12c-23.2,0-41.2,18-41.2,42.9c0,24.9,18,42.9,41.2,42.9c12,0,20.6-4.3,25.8-12v10.3h18V733.1L282.4,733.1z%20M215.5,733.1c0-14.6,9.4-26.6,24.9-26.6c14.6,0,24.9,11.2,24.9,26.6c0,14.6-10.3,26.6-24.9,26.6%20C224.9,758.8,215.5,747.6,215.5,733.1z'/%3e%3cg%3e%3crect%20id='rect19'%20x='364'%20y='66.1'%20fill='%23FF5A00'%20width='270.4'%20height='485.8'/%3e%3cpath%20id='XMLID_330_'%20inkscape:connector-curvature='0'%20fill='%23EB001B'%20d='M382,309c0-98.7,46.4-186.3,117.6-242.9%20C447.2,24.9,381.1,0,309,0C138.2,0,0,138.2,0,309s138.2,309,309,309c72.1,0,138.2-24.9,190.6-66.1C428.3,496.1,382,407.7,382,309z'%20/%3e%3cpath%20id='path22'%20inkscape:connector-curvature='0'%20fill='%23F79E1B'%20d='M999.2,309c0,170.8-138.2,309-309,309%20c-72.1,0-138.2-24.9-190.6-66.1c72.1-56.7,117.6-144.2,117.6-242.9S570.8,122.7,499.6,66.1C551.9,24.9,618,0,690.1,0%20C861,0,999.2,139.1,999.2,309z'/%3e%3c/g%3e%3c/svg%3e", Zl = "data:image/svg+xml,%3csvg%20viewBox='0%200%20200%20120'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20%3e%3c!--%20Generator:%20Sketch%2056.3%20(81716)%20-%20https://sketch.com%20--%3e%3ctitle%3elarge/visa%3c/title%3e%3cdesc%3eCreated%20with%20Sketch.%3c/desc%3e%3cg%20id='Rounded'%20stroke='none'%20stroke-width='1'%20fill='none'%20fill-rule='evenodd'%3e%3cg%20id='Large'%20transform='translate(-32.000000,%20-28.000000)'%3e%3cg%20id='large/visa'%20transform='translate(32.000000,%2028.000000)'%3e%3crect%20id='Background'%20fill='%2325459A'%20x='0'%20y='0'%20width='200'%20height='120'%20rx='8'%3e%3c/rect%3e%3cg%20id='Logo'%20transform='translate(32.000000,%2040.000000)'%20fill='%23FFFFFF'%20fill-rule='nonzero'%3e%3cpath%20d='M68.2672516,27.2122001%20C68.1919404,21.6403198%2073.5588253,18.5307792%2077.601826,16.6821648%20C81.7558108,14.7851962%2083.151042,13.5689046%2083.1351871,11.8727915%20C83.1034772,9.27654823%2079.8215122,8.130928%2076.7496247,8.08629345%20C71.3906676,8.00818295%2068.2751783,9.44392782%2065.7978502,10.5300353%20L63.8675158,2.05318951%20C66.3527715,0.97824065%2070.9546576,0.0409150083%2075.7269836,0%20C86.9284726,0%2094.2574019,5.18876693%2094.2970395,13.2341454%20C94.3406403,23.4442997%2079.2467723,24.0096708%2079.3498288,28.5735539%20C79.3855023,29.9572251%2080.7926254,31.4338851%2083.8764037,31.8095591%20C85.4024382,31.9992559%2089.6158792,32.1443183%2094.3921687,30.0799701%20L96.2670112,38.2815696%20C93.6985165,39.1593824%2090.3967329,40%2086.2863494,40%20C75.7428385,40%2068.3267073,34.7405617%2068.2672516,27.2122001%20M114.282145,39.2932862%20C112.236863,39.2932862%20110.512642,38.1737028%20109.743679,36.4552724%20L93.7421172,0.602566485%20L104.93568,0.602566485%20L107.163294,6.37902176%20L120.842112,6.37902176%20L122.134286,0.602566485%20L132,0.602566485%20L123.390787,39.2932862%20L114.282145,39.2932862%20M115.847817,28.8413614%20L119.078253,14.3128138%20L110.231217,14.3128138%20L115.847817,28.8413614%20M54.6954535,39.2932862%20L45.8721999,0.602566485%20L56.538586,0.602566485%20L65.3578762,39.2932862%20L54.6954535,39.2932862%20M38.915861,39.2932862%20L27.8134648,12.958899%20L23.3225632,35.3505672%20C22.7953877,37.8501021%2020.7144316,39.2932862%2018.4035794,39.2932862%20L0.253678458,39.2932862%20L0,38.1699831%20C3.72590236,37.4111957%207.95916162,36.187465%2010.5236923,34.8781847%20C12.0933277,34.0784823%2012.5412287,33.3792076%2013.0565131,31.4785195%20L21.5626689,0.602566485%20L32.8355053,0.602566485%20L50.1173503,39.2932862%20L38.915861,39.2932862'%20id='Shape'%20transform='translate(66.000000,%2020.000000)%20scale(-1,%201)%20rotate(-180.000000)%20translate(-66.000000,%20-20.000000)%20'%3e%3c/path%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e", Xl = "data:image/svg+xml,%3csvg%20viewBox='0%200%2082%2052'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M74.6566%200H7.34348C7.06313%200%206.78228%200%206.50243%200.0016194C6.26587%200.00328787%206.02986%200.00588873%205.79385%200.0122682C5.27913%200.0260576%204.75999%200.0561392%204.2517%200.146629C3.73529%200.23869%203.25475%200.388853%202.78595%200.625285C2.32507%200.857448%201.90314%201.16111%201.53748%201.52346C1.17167%201.88582%200.865114%202.30308%200.630788%202.7601C0.392052%203.22447%200.240359%203.70063%200.148065%204.21255C0.0562216%204.71619%200.0256501%205.23032%200.0117788%205.73965C0.00543757%205.97343%200.00271779%206.20721%200.00117708%206.44095C-0.000457754%206.71875%208.71913e-05%206.99635%208.71913e-05%207.27464V44.7259C8.71913e-05%2045.0042%20-0.000457754%2045.2813%200.00117708%2045.5596C0.00271779%2045.7934%200.00543757%2046.0272%200.0117788%2046.2609C0.0256501%2046.7698%200.0562216%2047.284%200.148065%2047.7874C0.240359%2048.2996%200.392052%2048.7755%200.630788%2049.24C0.865114%2049.697%201.17167%2050.1148%201.53748%2050.4766C1.90314%2050.8395%202.32507%2051.1431%202.78595%2051.3747C3.25475%2051.6118%203.73529%2051.762%204.2517%2051.854C4.75999%2051.9439%205.27913%2051.9745%205.79385%2051.9883C6.02986%2051.9936%206.26587%2051.9968%206.50243%2051.9978C6.78228%2052%207.06313%2052%207.34348%2052H74.6566C74.9365%2052%2075.2173%2052%2075.4971%2051.9978C75.7331%2051.9968%2075.9691%2051.9936%2076.2062%2051.9883C76.7199%2051.9745%2077.2389%2051.9439%2077.7484%2051.854C78.2641%2051.762%2078.7448%2051.6118%2079.2136%2051.3747C79.675%2051.1431%2080.0957%2050.8395%2080.4621%2050.4766C80.8273%2050.1148%2081.1339%2049.697%2081.3688%2049.24C81.6081%2048.7755%2081.7596%2048.2996%2081.8515%2047.7874C81.9434%2047.284%2081.9732%2046.7698%2081.9871%2046.2609C81.9936%2046.0272%2081.9967%2045.7934%2081.9978%2045.5596C82%2045.2813%2082%2045.0042%2082%2044.7259V7.27464C82%206.99635%2082%206.71875%2081.9978%206.44095C81.9967%206.20721%2081.9936%205.97343%2081.9871%205.73965C81.9732%205.23032%2081.9434%204.71619%2081.8515%204.21255C81.7596%203.70063%2081.6081%203.22447%2081.3688%202.7601C81.1339%202.30308%2080.8273%201.88582%2080.4621%201.52346C80.0957%201.16111%2079.675%200.857448%2079.2136%200.625285C78.7448%200.388853%2078.2641%200.23869%2077.7484%200.146629C77.2389%200.0561392%2076.7199%200.0260576%2076.2062%200.0122682C75.9691%200.00588873%2075.7331%200.00328787%2075.4971%200.0016194C75.2173%200%2074.9365%200%2074.6566%200Z'%20fill='black'/%3e%3cpath%20d='M74.6566%201.7334L75.4846%201.73497C75.7089%201.73654%2075.9333%201.73894%2076.1588%201.74503C76.5512%201.75553%2077.0102%201.77658%2077.438%201.85255C77.8099%201.91889%2078.1218%202.01979%2078.4211%202.17073C78.7167%202.31947%2078.9874%202.51439%2079.2238%202.74822C79.4611%202.98363%2079.6581%203.25225%2079.8103%203.54821C79.9618%203.8424%2080.063%204.14989%2080.1296%204.52098C80.2061%204.94016%2080.2272%205.39604%2080.238%205.7871C80.244%206.00783%2080.247%206.22856%2080.2481%206.45454C80.2502%206.72783%2080.2502%207.00097%2080.2502%207.27479V44.726C80.2502%2044.9999%2080.2502%2045.2725%2080.248%2045.5516C80.247%2045.7723%2080.244%2045.9931%2080.2379%2046.2142C80.2272%2046.6046%2080.2061%2047.0603%2080.1287%2047.4844C80.063%2047.8504%2079.9619%2048.1579%2079.8095%2048.4536C79.6578%2048.7488%2079.461%2049.0172%2079.2248%2049.2511C78.987%2049.4866%2078.7172%2049.681%2078.4182%2049.8311C78.1211%2049.9813%2077.8097%2050.0821%2077.4415%2050.1477C77.005%2050.2248%2076.5268%2050.246%2076.1666%2050.2557C75.94%2050.2607%2075.7145%2050.2638%2075.4835%2050.2648C75.2082%2050.2669%2074.9319%2050.2669%2074.6566%2050.2669H7.34343C7.33976%2050.2669%207.33619%2050.2669%207.33248%2050.2669C7.0603%2050.2669%206.78758%2050.2669%206.51045%2050.2648C6.2845%2050.2638%206.05904%2050.2608%205.84106%2050.2559C5.47268%2050.246%204.99416%2050.2248%204.56123%2050.1482C4.18983%2050.0821%203.87846%2049.9813%203.57745%2049.8291C3.28126%2049.6803%203.0116%2049.4862%202.77376%2049.2502C2.53775%2049.0168%202.34162%2048.7493%202.18997%2048.4537C2.03818%2048.1583%201.93662%2047.8498%201.86985%2047.4795C1.79266%2047.0562%201.77145%2046.6023%201.76086%2046.2145C1.75481%2045.9925%201.75228%2045.7705%201.75085%2045.5497L1.74976%2044.8981L1.74981%2044.726V7.27479L1.74976%207.10274L1.7508%206.45248C1.75228%206.23043%201.75481%206.00842%201.76086%205.78656C1.77145%205.39835%201.79266%204.94433%201.87049%204.51749C1.93667%204.15048%202.03818%203.84201%202.19077%203.54516C2.34122%203.25176%202.5377%202.98392%202.77495%202.74896C3.01126%202.51478%203.2818%202.32011%203.57988%202.16995C3.87767%202.01974%204.18963%201.91889%204.56103%201.85269C4.98896%201.77653%205.44825%201.75553%205.8416%201.74498C6.06583%201.73894%206.29005%201.73654%206.51258%201.73502L7.34343%201.7334H74.6566Z'%20fill='white'/%3e%3cpath%20d='M22.3853%2017.4893C23.0875%2016.6194%2023.5639%2015.4514%2023.4382%2014.2578C22.4105%2014.3084%2021.1562%2014.9295%2020.4301%2015.8001C19.7781%2016.5456%2019.2011%2017.7625%2019.3515%2018.906C20.5052%2019.0051%2021.6579%2018.3348%2022.3853%2017.4893Z'%20fill='black'/%3e%3cpath%20d='M23.4251%2019.1297C21.7496%2019.0308%2020.325%2020.0716%2019.5249%2020.0716C18.7243%2020.0716%2017.499%2019.1795%2016.1738%2019.2035C14.4489%2019.2286%2012.8484%2020.1947%2011.9731%2021.7312C10.1727%2024.8049%2011.498%2029.3643%2013.2487%2031.8677C14.0989%2033.1062%2015.1236%2034.4698%2016.4737%2034.4209C17.7493%2034.3713%2018.2493%2033.6027%2019.7999%2033.6027C21.3494%2033.6027%2021.7998%2034.4209%2023.1501%2034.3961C24.5505%2034.3713%2025.4259%2033.157%2026.2761%2031.9172C27.2515%2030.5054%2027.6507%2029.1422%2027.6758%2029.0674C27.6507%2029.0426%2024.9756%2028.026%2024.9508%2024.9778C24.9255%2022.4256%2027.0511%2021.2116%2027.1511%2021.1363C25.9508%2019.3778%2024.0753%2019.1795%2023.4251%2019.1297Z'%20fill='black'/%3e%3cpath%20d='M38.0141%2015.6748C41.6558%2015.6748%2044.1916%2018.1614%2044.1916%2021.7816C44.1916%2025.4148%2041.6036%2027.9142%2037.9228%2027.9142H33.8907V34.2658H30.9775V15.6748H38.0141V15.6748ZM33.8907%2025.4921H37.2334C39.7697%2025.4921%2041.2132%2024.1394%2041.2132%2021.7945C41.2132%2019.4499%2039.7697%2018.1099%2037.2464%2018.1099H33.8907V25.4921Z'%20fill='black'/%3e%3cpath%20d='M44.9529%2030.414C44.9529%2028.0432%2046.7868%2026.5875%2050.0386%2026.4071L53.7842%2026.1881V25.1447C53.7842%2023.6372%2052.7566%2022.7354%2051.0401%2022.7354C49.4139%2022.7354%2048.3994%2023.5083%2048.1525%2024.7195H45.4993C45.6553%2022.2714%2047.7622%2020.4678%2051.144%2020.4678C54.4605%2020.4678%2056.5804%2022.2071%2056.5804%2024.9255V34.2661H53.8881V32.0372H53.8233C53.0301%2033.5447%2051.3%2034.4979%2049.5053%2034.4979C46.8259%2034.4979%2044.9529%2032.8489%2044.9529%2030.414ZM53.7842%2029.1901V28.1208L50.4154%2028.3268C48.7376%2028.4428%2047.7883%2029.1772%2047.7883%2030.3367C47.7883%2031.5218%2048.7767%2032.2949%2050.2855%2032.2949C52.2493%2032.2949%2053.7842%2030.955%2053.7842%2029.1901Z'%20fill='black'/%3e%3cpath%20d='M59.1223%2039.2515V36.9968C59.33%2037.0482%2059.7981%2037.0482%2060.0324%2037.0482C61.333%2037.0482%2062.0354%2036.5072%2062.4644%2035.1158C62.4644%2035.09%2062.7118%2034.2913%2062.7118%2034.2784L57.7695%2020.7119H60.8126L64.2727%2031.7404H64.3244L67.7845%2020.7119H70.7498L65.6249%2034.974C64.4549%2038.2595%2063.1021%2039.3159%2060.2667%2039.3159C60.0324%2039.3159%2059.33%2039.29%2059.1223%2039.2515Z'%20fill='black'/%3e%3c/svg%3e", Jl = "data:image/svg+xml,%3csvg%20id='Layer_1'%20data-name='Layer%201'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20752%20400'%3e%3cdefs%3e%3cstyle%3e.cls-1{fill:%23fff;}.cls-2{fill:%233d4144;}.cls-3{fill:%23517cbe;}.cls-4{fill:%2332a853;}.cls-5{fill:%23fabb0d;}.cls-6{fill:%23e84336;}%3c/style%3e%3c/defs%3e%3cpath%20id='Base'%20class='cls-1'%20d='M715.92,340.27h-352c-110,0-200,90-200,200h0c0,110,90,200,200,200h352c110,0,200-90,200-200h0C915.92,430.27,825.92,340.27,715.92,340.27Z'%20transform='translate(-163.92%20-340.27)'%20/%3e%3cpath%20id='Outline'%20class='cls-2'%20d='M715.92,356.47a181.43,181.43,0,0,1,71.3,14.5,185.43,185.43,0,0,1,98,98,182.55,182.55,0,0,1,0,142.6,185.43,185.43,0,0,1-98,98,181.43,181.43,0,0,1-71.3,14.5h-352a181.43,181.43,0,0,1-71.3-14.5,185.43,185.43,0,0,1-98-98,182.55,182.55,0,0,1,0-142.6,185.43,185.43,0,0,1,98-98,181.43,181.43,0,0,1,71.3-14.5h352m0-16.2h-352c-110,0-200,90-200,200h0c0,110,90,200,200,200h352c110,0,200-90,200-200h0c0-110-90-200-200-200Z'%20transform='translate(-163.92%20-340.27)'%20/%3e%3cg%20id='G_Pay_Lockup'%20data-name='G%20Pay%20Lockup'%3e%3cg%20id='Pay_Typeface'%20data-name='Pay%20Typeface'%3e%3cpath%20id='Letter_p'%20data-name='Letter%20p'%20class='cls-2'%20d='M516.52,550.47V611h-19.2V461.57h50.9c12.9,0,23.9,4.3,32.9,12.9q13.8,12.9,13.8,31.5a41.3,41.3,0,0,1-13.8,31.7c-8.9,8.5-19.9,12.7-32.9,12.7h-31.7Zm0-70.5v52.1h32.1a25.63,25.63,0,0,0,19-7.7,25.18,25.18,0,0,0,7.7-18.3,24.9,24.9,0,0,0-7.7-18.1c-5-5.3-11.3-7.9-19-7.9h-32.1Z'%20transform='translate(-163.92%20-340.27)'%20/%3e%3cpath%20id='Letter_a'%20data-name='Letter%20a'%20class='cls-2'%20d='M645.12,505.37q21.3,0,33.6,11.4T691,548v63h-18.3v-14.2h-.8c-7.9,11.7-18.5,17.5-31.7,17.5-11.3,0-20.7-3.3-28.3-10a31.93,31.93,0,0,1-11.4-25q0-15.9,12-25.2c8-6.3,18.7-9.4,32-9.4,11.4,0,20.8,2.1,28.1,6.3v-4.4c0-6.7-2.6-12.3-7.9-17a27.1,27.1,0,0,0-18.6-7c-10.7,0-19.2,4.5-25.4,13.6l-16.9-10.6Q617.77,505.32,645.12,505.37Zm-24.8,74.2a15.14,15.14,0,0,0,6.4,12.5,23.5,23.5,0,0,0,14.9,5q12.15,0,21.6-9c6.3-6,9.5-13,9.5-21.1-6-4.7-14.3-7.1-25-7.1-7.8,0-14.3,1.9-19.5,5.6C622.92,569.37,620.32,574.07,620.32,579.57Z'%20transform='translate(-163.92%20-340.27)'%20/%3e%3cpath%20id='Letter_y'%20data-name='Letter%20y'%20class='cls-2'%20d='M795.42,508.67l-64,147.2h-19.8l23.8-51.5-42.2-95.7h20.9l30.4,73.4h.4l29.6-73.4Z'%20transform='translate(-163.92%20-340.27)'%20/%3e%3c/g%3e%3cg%20id='G_Mark'%20data-name='G%20Mark'%3e%3cpath%20id='Blue_500'%20data-name='Blue%20500'%20class='cls-3'%20d='M440.15,538.27a101.06,101.06,0,0,0-1.6-18H358.07v33h46.35a39.7,39.7,0,0,1-17.2,26.58v21.41h27.59C430.92,586.35,440.15,564.31,440.15,538.27Z'%20transform='translate(-163.92%20-340.27)'%20/%3e%3cpath%20id='Green_500'%20data-name='Green%20500'%20class='cls-4'%20d='M387.23,579.85c-7.68,5.18-17.57,8.21-29.14,8.21-22.35,0-41.31-15.06-48.1-35.36H281.53v22.08A85.67,85.67,0,0,0,358.09,622c23.14,0,42.58-7.61,56.73-20.71Z'%20transform='translate(-163.92%20-340.27)'%20/%3e%3cpath%20id='Yellow_500'%20data-name='Yellow%20500'%20class='cls-5'%20d='M307.31,536.32A51.66,51.66,0,0,1,310,519.93V497.85H281.53a85.78,85.78,0,0,0,0,76.94L310,552.71A51.66,51.66,0,0,1,307.31,536.32Z'%20transform='translate(-163.92%20-340.27)'%20/%3e%3cpath%20id='Red_500'%20data-name='Red%20500'%20class='cls-6'%20d='M358.09,484.57A46.55,46.55,0,0,1,391,497.42L415.41,473c-14.85-13.83-34.21-22.32-57.32-22.32a85.69,85.69,0,0,0-76.56,47.18L310,519.93C316.78,499.63,335.74,484.57,358.09,484.57Z'%20transform='translate(-163.92%20-340.27)'%20/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
function zt(e) {
  return new Promise(function(t, n) {
    let o = !1, a = document.querySelector('script[src="' + e + '"]');
    if (!a)
      a = document.createElement("script"), a.type = "text/javascript", a.async = !0, a.src = e, o = !0;
    else if (a.hasAttribute("data-loaded")) {
      t(a);
      return;
    }
    a.addEventListener("error", n), a.addEventListener("abort", n), a.addEventListener("load", function() {
      a.setAttribute("data-loaded", !0), t(a);
    }), o && document.head.appendChild(a);
  });
}
var ie = /* @__PURE__ */ ((e) => (e.CARD = "cc", e.APPLEPAY = "APPLEPAY", e.GOOGLEPAY = "GOOGLEPAY", e))(ie || {});
const Tt = ["MASTERCARD", "VISA"], Kt = [
  "PAN_ONLY",
  "CRYPTOGRAM_3DS"
], ln = "Co-Op", Za = () => {
  const e = () => {
    try {
      return window.isSecureContext ? ApplePaySession ? ApplePaySession.canMakePayments() : (console.warn("Apple Pay is not available in this browser"), !1) : (console.warn("Apple Pay requires a secure context (HTTPS)"), !1);
    } catch {
      return !1;
    }
  }, t = (s) => {
    const r = document.querySelector(".coop-apple-pay-container"), l = document.createElement("apple-pay-button");
    l.setAttribute("buttonstyle", "black"), l.setAttribute("type", "pay"), l.setAttribute("locale", "en"), l.addEventListener("click", () => {
      s.click();
    }), r?.appendChild(l);
  }, n = (s) => {
    s.style.display = "none";
  };
  return {
    isApplePaySupported: e,
    setupApplePayButton: () => {
      const s = document.querySelector(".wpwl-apple-pay-button");
      n(s), t(s);
    },
    getApplePayConfiguration: (s, r) => ({
      requiredBillingContactFields: [],
      submitOnPaymentAuthorized: [],
      supportedNetworks: Tt,
      displayName: ln,
      total: { label: ln },
      onCancel: s,
      onPaymentAuthorized: r
    })
  };
}, Ql = () => {
  let e = null;
  const t = async () => {
    if (e = document.querySelector(".wpwl-form"), !e) return;
    const a = document.querySelector(".wpwl-group-billing");
    a && a.setAttribute("style", "display: none !important"), e.classList.add("coop-form"), e.setAttribute("data-testid", "payment-form"), e.querySelectorAll(".wpwl-group").forEach((l) => {
      l.classList.add("coop-form__row");
    }), e.querySelectorAll(".wpwl-label").forEach((l) => {
      l.classList.add("coop-form__label"), l.classList.remove("wpwl-label");
    }), n(), o();
  }, n = async () => {
    const a = e?.querySelector(".wpwl-label-cardNumber");
    a && (a.textContent = "Card number", a.classList.add("coop-form__label"), a.classList.add("coop-form__label__first"));
    const s = e?.querySelector(".wpwl-wrapper-expiry");
    if (s?.parentNode) {
      const _ = document.createElement("p");
      _.className = "coop-label__hint", _.textContent = "For example, 02/28.", s.parentNode.insertBefore(_, s);
    }
    const r = e?.querySelector(".wpwl-label-expiry");
    r && (r.textContent = "Expiry date", r.classList.add("coop-form__label"));
    const l = e?.querySelector(".wpwl-label-cardholderName");
    l && l.classList.add("coop-form__label");
    const i = e?.querySelector(".wpwl-wrapper-cvv"), u = document.createElement("p");
    u.className = "coop-label__hint", u.textContent = "The 3 or 4 digit number on the back of your card.", i?.parentNode?.insertBefore(u, i);
    const g = e?.querySelector(".wpwl-label-cvv");
    g && (g.textContent = "Security number (CVV)", g.classList.add("coop-form__label")), document.querySelectorAll(".wpwl-control").forEach((_) => {
      _.classList.add("sessioncamexclude");
    });
  }, o = () => {
    const a = e?.querySelector(
      ".wpwl-button"
    );
    if (a) {
      a.style.display = "none";
      const s = document.querySelector("#fnc-credit-card-button");
      s && s.addEventListener("click", () => {
        document.getElementById("payment-cc").checked && a.click();
      });
    }
  };
  return {
    setCreditCard: t
  };
}, Xa = () => {
  const e = async () => {
    let r = !1;
    try {
      const l = new google.payments.api.PaymentsClient({}), i = {
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [
          {
            type: "CARD",
            parameters: {
              allowedAuthMethods: Kt,
              allowedCardNetworks: Tt
            }
          }
        ]
      };
      (await l.isReadyToPay(i)).result && (r = !0);
    } catch (l) {
      return console.error(l), !1;
    }
    return r;
  }, t = (r) => {
    o(), n(r);
  }, n = (r) => {
    const l = document.querySelector(".coop-google-pay-container"), i = s(r);
    l.appendChild(i);
  }, o = () => {
    const r = document.querySelector(
      ".wpwl-form-virtualAccount-GOOGLEPAY"
    );
    r && (r.style.display = "none");
  }, a = (r, l, i, u) => ({
    gatewayMerchantId: i,
    merchantName: ln,
    merchantId: u,
    allowedAuthMethods: Kt,
    allowedCardNetworks: Tt,
    onCancel: r,
    onPaymentAuthorized: l
  }), s = (r) => new window.google.payments.api.PaymentsClient({}).createButton({
    onClick: async () => {
      r();
      const i = document.getElementById(
        "gpay-button-online-api-id"
      );
      i && i.click();
    },
    buttonColor: "black",
    buttonType: "buy",
    buttonSizeMode: "fill",
    allowedPaymentMethods: [
      {
        type: "CARD",
        parameters: {
          allowedAuthMethods: Kt,
          allowedCardNetworks: Tt
        }
      }
    ]
  });
  return {
    isGooglePaySupported: e,
    setupGooglePayButton: t,
    getGooglePayConfiguration: a
  };
}, ei = () => {
  const { setupGooglePayButton: e, getGooglePayConfiguration: t } = Xa(), { setupApplePayButton: n, getApplePayConfiguration: o } = Za(), { setCreditCard: a } = Ql(), s = B(void 0), r = (u) => ({
    country: "GB",
    city: u.town_city,
    postcode: u.postcode,
    street1: u.address_1,
    street2: u.address_2,
    state: u.county ?? u.town_city
  });
  return {
    setACIWidgetConfiguration: ({
      updatePaymentInProgress: u,
      onGooglePayCancel: g,
      onGooglePayAuthorized: _,
      onApplePayCancel: w,
      onApplePayAuthorized: p,
      gatewayMerchantId: f,
      googleMerchantId: h,
      billingAddress: m
    }) => {
      let d = {
        style: "plain",
        googlePay: t(
          g,
          _,
          f,
          h
        ),
        applePay: o(w, p),
        onReady: () => {
          a(), e(() => u(!0)), n();
        },
        onAfterSubmit: () => {
          u(!0);
        }
      };
      m && (s.value = m, d.billingAddress = r(m), d.mandatoryBillingFields = {
        country: !1,
        state: !1,
        city: !0,
        postcode: !0,
        street1: !0,
        street2: !1
      }), window.CYPRESS_TEST && (d = {
        ...d,
        paymentTarget: "_self",
        shopperResultTarget: "_self"
      }), window.wpwlOptions = d;
    },
    updateBillingAddress: (u) => (s.value = {
      address_1: u.address_1,
      address_2: u.address_2,
      town_city: u.town_city,
      county: u.county,
      postcode: u.postcode
    }, window.wpwlOptions && (window.wpwlOptions.billingAddress = r(s.value)), s.value),
    currentBillingAddress: s
  };
}, ti = ["type"], ot = /* @__PURE__ */ W({
  __name: "ButtonComponent",
  props: {
    label: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      default: "button"
    },
    category: {
      type: String,
      default: "primary"
    },
    color: {
      type: String,
      default: "teal"
    },
    size: {
      type: String,
      default: "large"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    iconSide: {
      type: String,
      default: "left"
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    fullWidthMobile: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t;
    return (o, a) => (b(), v("button", {
      class: q(["coop-btn fnc-btn", [
        `fnc-btn--${e.category} fnc-btn--${e.color} fnc-btn--${e.iconSide}`,
        {
          "coop-btn--loading": e.loading,
          "coop-btn--small": e.size === "small",
          "fnc-btn--full-width": e.fullWidth,
          "fnc-btn--full-width-mobile": e.fullWidthMobile
        }
      ]]),
      type: e.type,
      onClick: a[0] || (a[0] = (s) => n("click", s))
    }, [
      ve(o.$slots, "icon"),
      Ze(" " + L(e.label), 1)
    ], 10, ti));
  }
}), ni = {
  id: "fnc-google-pay-button",
  class: "coop-google-pay-container"
}, oi = {
  id: "fnc-apple-pay-button",
  class: "coop-apple-pay-container"
}, ai = /* @__PURE__ */ W({
  __name: "ACIPaymentButtons",
  props: {
    selectedPaymentType: {
      type: String,
      default: null
    },
    paymentLoading: {
      type: Boolean,
      required: !0
    }
  },
  emits: ["handleSubmit", "handleNoPaymentTypeSelected"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = () => {
      n.selectedPaymentType ? o("handleSubmit") : o("handleNoPaymentTypeSelected");
    };
    return (s, r) => (b(), v("div", null, [
      fe(V(ot, {
        id: "fnc-credit-card-button",
        disabled: e.paymentLoading,
        label: "Pay now",
        "full-width-mobile": "",
        onClick: a
      }, null, 8, ["disabled"]), [
        [rt, e.selectedPaymentType === O(ie).CARD || !e.selectedPaymentType]
      ]),
      fe(C("div", ni, null, 512), [
        [rt, e.selectedPaymentType === O(ie).GOOGLEPAY]
      ]),
      fe(C("div", oi, null, 512), [
        [rt, e.selectedPaymentType === O(ie).APPLEPAY]
      ])
    ]));
  }
}), si = /* @__PURE__ */ te(ai, [["__scopeId", "data-v-fdc21422"]]), Oe = "billingAddressForm", ri = (e) => {
  const t = {
    name: Oe,
    label: "Billing Address",
    steps: [
      {
        label: "Billing Address",
        name: "billing-address-step",
        fields: [
          {
            label: "Address line 1",
            name: "address_1",
            value: e.address_1 || "",
            type: "text",
            size: "30",
            error: {
              empty: "Please enter the first line of your billing address"
            }
          },
          {
            label: "Address line 2 (optional)",
            name: "address_2",
            value: e.address_2 || "",
            type: "text",
            size: "30",
            optional: !0
          },
          {
            label: "Town or city",
            name: "town_city",
            value: e.town_city || "",
            type: "text",
            size: "30",
            error: {
              empty: "Please enter your town or city"
            }
          },
          {
            label: "County",
            name: "county",
            value: e.county || "",
            type: "text",
            size: "30",
            optional: !0
          },
          {
            label: "County (optional)",
            name: "county",
            value: e.county || "",
            type: "text",
            size: "30",
            optional: !0
          },
          {
            label: "Postcode",
            name: "postcode",
            value: e.postcode || "",
            type: "text",
            size: "10",
            error: {
              empty: "Please enter your postcode"
            }
          }
        ]
      }
    ]
  };
  return vi(t), t;
}, li = {}, ii = {
  class: "coop-c-highlight",
  "data-cy": "highlight-box"
};
function ui(e, t) {
  return b(), v("div", ii, [
    ve(e.$slots, "default", {}, void 0, !0)
  ]);
}
const Ja = /* @__PURE__ */ te(li, [["render", ui], ["__scopeId", "data-v-55b382f9"]]), We = {
  formName: {
    type: String,
    required: !0
  },
  name: {
    type: String,
    required: !0
  },
  elementName: {
    type: String,
    default: ""
  },
  type: {
    type: String,
    default: "text"
  },
  hasError: {
    type: Boolean,
    default: !1
  }
}, ci = (e, t = !1) => t ? e.replace(/[^0-9 ]/g, "") : e.replace(/\D/g, ""), di = (e = [], t) => {
  if (e.length === 0)
    return "empty";
  const n = t.minSelected || 1;
  return e.length < n || t.maxSelected && e.length > t.maxSelected ? "range" : "";
}, pi = (e) => e.trim() === "" ? "empty" : "", mi = (e) => new RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$").test(e) ? "" : "invalid", fi = (e) => (e = e.replace(/\s/g, ""), new RegExp("^[0-9]{10,11}$").test(e) ? "" : "invalid"), hi = (e) => (e = e.replace(/\s/g, ""), new RegExp("^0[0-9]{9,10}$").test(e) ? "" : "invalid"), yi = (e, t) => {
  const n = _i(e);
  if (n !== "")
    return n;
  if (!new RegExp("^[0-9]{4}-[0-9]{2}-[0-9]{2}$").test(e))
    return "invalid";
  const o = new Date(e);
  if (o.setHours(0, 0, 0, 0), t.minDate) {
    const a = new Date(t.minDate);
    if (a.setHours(0, 0, 0, 0), o < a)
      return "range";
  }
  if (t.maxDate) {
    const a = new Date(t.maxDate);
    if (a.setHours(0, 0, 0, 0), o > a)
      return "range";
  }
  if (t.dateToday) {
    const a = /* @__PURE__ */ new Date();
    if (a.setHours(0, 0, 0, 0), o <= a)
      return "range";
  }
  return "";
}, un = (e) => e.trim() !== "" && Number(e) > 0 && Number(e) < 32, cn = (e) => e.trim() !== "" && Number(e) > 0 && Number(e) < 13, dn = (e) => e.trim() !== "" && e.length === 4, _i = (e) => {
  const t = [], n = e.match(/-/g);
  if (!n || n.length !== 2)
    return "invalid";
  const [o, a, s] = e.split("-").map((r) => parseInt(r));
  return un(s.toString()) || t.push("invalidDay"), cn(a.toString()) || t.push("invalidMonth"), dn(o.toString()) || t.push("invalidYear"), t.length === 1 ? t[0] : t.length > 1 ? "invalid" : s <= new Date(o, a, 0).getDate() ? "" : "invalid";
}, bi = (e, t) => {
  const n = /* @__PURE__ */ new Date("01/01/1970" + e);
  if (t.minTime) {
    const o = /* @__PURE__ */ new Date("01/01/1970" + t.minTime);
    if (n < o)
      return "range";
  }
  if (t.maxTime) {
    const o = /* @__PURE__ */ new Date("01/01/1970" + t.maxTime);
    if (n > o)
      return "range";
  }
  return "";
}, gi = (e) => (e = e.replace(/\s/g, ""), new RegExp(/^91(\d){10}$/).test(e) ? "" : "invalid"), be = mn([]), vi = (e) => {
  be.push({
    name: e.name,
    form: e,
    errors: [],
    hasError: !1,
    errorMessage: "",
    currentStep: 0
  });
}, wi = ["expanded", "accordion"], Ei = ["date-element", "membership-element"], de = () => {
  const e = (f) => be.find((h) => h.name === f), t = (f, h, m) => {
    const d = be.find((y) => y.name === f);
    let c = null;
    return d.form.steps.forEach((y) => {
      c || (c = n(y.fields, h, m));
    }), c;
  }, n = (f, h, m) => {
    const d = f.find((y) => y.name === h);
    if (d)
      return d;
    const c = f.find((y) => y.name === m && y.fields);
    return c ? n(c.fields, h, m) : null;
  }, o = (f, h, m, d, c) => {
    be.find((A) => A.name === f).form.steps.forEach((A) => {
      a(A.fields, h, m, d, c);
    });
  }, a = (f, h, m, d, c) => {
    const y = f.find((k) => k.name === h);
    y && (y[m] = d);
    const A = f.find((k) => k.name === c && k.fields);
    A && a(
      A.fields,
      h,
      m,
      d,
      c
    );
  }, s = (f, h, m, d = !1, c, y) => {
    be.find((k) => k.name === f).form.steps.forEach((k) => {
      r(f, k.fields, h, m, d, c, y);
    });
  }, r = (f, h, m, d, c = !1, y, A) => {
    let k;
    if (A ? k = h.find((T) => T.element === A) : k = h.find((T) => T.name === m), k)
      if (c) {
        const T = k.values?.findIndex((K) => K === d);
        T !== void 0 && T > -1 ? k.values?.splice(T, 1) : k.values?.push(d), l(f, k);
      } else
        k.value = d, l(f, k, d);
    const R = h.find((T) => T.name === y && T.fields);
    R && r(
      f,
      R.fields,
      m,
      d,
      c,
      y,
      A
    );
  }, l = (f, h, m = "", d = !1) => {
    const c = be.find((R) => R.name === f);
    if (h.optional === !0 && h.fields === void 0 || h.show === !1) return !0;
    let y = "";
    const A = i(h);
    if (h.element && y === "" && h.fields && (h.optional === !0 || h.value !== "") || A) {
      h.validate = !1;
      let R = !0;
      return h.fields?.forEach((T) => {
        l(f, T, T.value) || (h.validate = d ?? !0, R = !1);
      }), R;
    }
    if (!A) {
      if (h.type !== "checkbox" && (y = pi(m)), y === "")
        switch (h.validation?.type) {
          case "membership":
            y = gi(m);
            break;
          case "email":
            y = mi(m);
            break;
          case "phone":
            y = fi(m);
            break;
          case "domestic_phone":
            y = hi(m);
            break;
          case "date":
            y = yi(m, h.validation);
            break;
          case "time":
            y = bi(m, h.validation);
            break;
          case "checkbox":
            y = di(h.values, h.validation);
            break;
        }
      if (h.errorType = y, y !== "")
        c.errors.find((R) => R.name === h.name) || c.errors.push(h);
      else {
        const R = c.errors.findIndex((T) => T.name === h.name);
        R !== -1 && c.errors.splice(R, 1);
      }
    }
    return h.element && Ei.includes(h.element) && (h.validate = !0), y === "";
  }, i = (f) => f.element ? wi.includes(f.element) : !1, u = (f, h) => {
    const m = be.find((d) => d.name === f);
    return _(f), m.hasError = !1, m.form.steps[h].fields.forEach((d) => {
      l(f, d, d.value, !0) || (m.hasError = !0, m.errorMessage = "Check the form. You must:");
    }), m.hasError;
  }, g = (f) => {
    be.find((m) => m.name === f).form.steps.forEach((m) => {
      m.show === !1 && m.fields.forEach((d) => {
        d.errorType = "", d.value = "";
      });
    });
  }, _ = (f) => {
    const h = be.find((m) => m.name === f);
    h.errors.forEach((m) => {
      m.errorType = "";
    }), h.errors.length = 0, h.hasError = !1;
  };
  return {
    forms: be,
    getFormByName: e,
    getFieldByName: t,
    updateFormValue: s,
    updateFormProperty: o,
    validateStep: u,
    resetIgnoredSteps: g,
    resetErrors: _,
    resetForm: (f) => {
      be.find((m) => m.name === f).form.steps.forEach((m) => {
        m.fields.forEach((d) => {
          d.value = "", d.errorType = "";
        });
      });
    },
    findErrorMessage: (f, h = {}) => {
      const m = h ? h.custom : null;
      return m && m[f] ? m[f] : h && Object.keys(h).includes(f) ? h[f] : "Please enter a valid value";
    }
  };
}, Ci = { class: "fnc-options-wrapper" }, Si = ["id", "name", "value", "checked", "onChange"], Ai = ["for", "innerHTML"], ki = /* @__PURE__ */ W({
  __name: "CheckboxElement",
  props: {
    values: {
      type: Array,
      required: !0
    },
    options: {
      type: Array,
      default: () => []
    },
    ...We
  },
  setup(e) {
    const t = e, { updateFormValue: n } = de(), o = (a) => {
      n(t.formName, t.name, a, !0, t.elementName);
    };
    return (a, s) => (b(), v("div", Ci, [
      (b(!0), v(se, null, we(e.options, (r) => (b(), v("div", {
        key: r.value,
        class: "coop-form__choice"
      }, [
        C("input", {
          id: `${a.name}-${r.value}`,
          class: "sessioncamexclude coop-form__field coop-form__checkbox",
          type: "checkbox",
          name: a.name,
          value: r.value,
          checked: e.values.includes(r.value),
          onChange: (l) => o(r.value)
        }, null, 40, Si),
        C("label", {
          class: "coop-form__label",
          for: `${a.name}-${r.value}`,
          innerHTML: r.label
        }, null, 8, Ai)
      ]))), 128))
    ]));
  }
}), Ti = /* @__PURE__ */ te(ki, [["__scopeId", "data-v-b64687a9"]]), Oi = (e, t) => {
  switch (t) {
    case "membership":
      return Pi(e);
    default:
      return e.value;
  }
}, Pi = (e) => {
  const t = e.selectionStart || 0, n = e.value, o = t < n.length, a = Math.trunc((t - 1) / 4);
  let s = t + a;
  return o && (s = t), e.value.length >= 4 && (e.value = e.value.replace(/\s/g, "").replace(/(.{4})/g, "$1 ").trim()), e.setSelectionRange(s, s), e.value;
}, Mi = ["id", "type", "name", "readonly", "maxlength"], it = /* @__PURE__ */ W({
  __name: "InputElement",
  props: {
    onlyNumbers: {
      type: Boolean,
      default: !1
    },
    allowSpaces: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "30"
    },
    maxLength: {
      type: Number,
      default: 255
    },
    formatter: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    ...We
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, o = t, { updateFormValue: a } = de(), s = B(n.value), r = Ne("input"), l = () => {
      n.formName && a(n.formName, n.name, s.value, !1, n.elementName), o("update:modelValue", s.value);
    }, i = () => {
      n.formatter && r.value && (s.value = Oi(r.value, n.formatter)), n.onlyNumbers === !0 && (s.value = ci(s.value, n.allowSpaces)), o("update:modelValue", s.value);
    };
    return Y(
      () => n.value,
      () => {
        s.value = n.value;
      }
    ), Y(
      () => s.value,
      () => {
        i();
      }
    ), (u, g) => fe((b(), v("input", {
      id: u.name,
      ref: "input",
      "onUpdate:modelValue": g[0] || (g[0] = (_) => s.value = _),
      class: q(["sessioncamexclude coop-form__field coop-form__input", [`coop-form__field--width-${e.size || "30"}`, { "coop-form__invalid": u.hasError }]]),
      type: u.type,
      autocomplete: "on",
      name: u.name,
      readonly: e.readonly,
      maxlength: e.maxLength,
      onBlur: l
    }, null, 42, Mi)), [
      [fs, s.value]
    ]);
  }
}), Fi = {
  key: 0,
  class: "fnc-label"
}, Bi = ["for", "innerHTML"], Di = ["for", "innerHTML"], Ot = /* @__PURE__ */ W({
  __name: "LabelElement",
  props: {
    label: {
      type: String,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    isCompositeLabel: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => e.isCompositeLabel ? (b(), v("h1", Fi, [
      C("label", {
        for: e.name,
        class: "fnc-label__h2",
        innerHTML: e.label
      }, null, 8, Bi)
    ])) : (b(), v("label", {
      key: 1,
      for: e.name,
      class: "fnc-label coop-form__label",
      innerHTML: e.label
    }, null, 8, Di));
  }
}), Li = { class: "fnc-date-element" }, Ri = /* @__PURE__ */ W({
  __name: "DateElement",
  props: {
    value: {
      type: String,
      default: ""
    },
    validate: {
      type: Boolean,
      default: !1
    },
    ...We
  },
  setup(e) {
    const t = e, { updateFormValue: n, updateFormProperty: o } = de();
    ft(() => {
      if (t.value === "") return;
      const p = t.value.split("-");
      s.value = p[2], l.value = p[1], u.value = p[0];
    });
    const a = B(t.value), s = B(""), r = B(!1), l = B(""), i = B(!1), u = B(""), g = B(!1), _ = () => {
      a.value = `${u.value}-${l.value}-${s.value}`, s.value != "" && l.value != "" && u.value != "" && n(t.formName, t.name, a.value, !1);
    }, w = (p) => {
      switch (p) {
        case "day":
          s.value.length === 1 && (s.value = `0${s.value}`), r.value = !un(s.value);
          break;
        case "month":
          l.value.length === 1 && (l.value = `0${l.value}`), i.value = !cn(l.value);
          break;
        case "year":
          u.value.length > 4 && (u.value = u.value.slice(0, 4)), g.value = !dn(u.value);
          break;
      }
      _();
    };
    return Y(
      () => t.value,
      () => {
        a.value = t.value;
      }
    ), Y(
      () => [t.hasError, t.validate],
      () => {
        t.hasError || t.validate ? (r.value = !un(s.value), i.value = !cn(l.value), g.value = !dn(u.value), !r.value && !i.value && !g.value && (r.value = !0, i.value = !0, g.value = !0)) : (r.value = !1, i.value = !1, g.value = !1), o(t.formName, t.name, "validate", !1);
      }
    ), (p, f) => (b(), v("div", Li, [
      C("div", null, [
        V(Ot, {
          label: "Day",
          name: `${p.name}-day`
        }, null, 8, ["name"]),
        V(it, {
          class: q({ "coop-form__invalid": r.value }),
          name: `${p.name}-day`,
          "form-name": p.formName,
          value: s.value,
          "only-numbers": "",
          size: "2",
          "min-length": 1,
          "max-length": 2,
          inputmode: "numeric",
          onChange: f[0] || (f[0] = (h) => w("day")),
          "onUpdate:modelValue": f[1] || (f[1] = (h) => s.value = h)
        }, null, 8, ["class", "name", "form-name", "value"])
      ]),
      C("div", null, [
        V(Ot, {
          label: "Month",
          name: `${p.name}-month`
        }, null, 8, ["name"]),
        V(it, {
          class: q({ "coop-form__invalid": i.value }),
          name: `${p.name}-month`,
          "form-name": p.formName,
          value: l.value,
          "only-numbers": "",
          size: "2",
          "min-length": 1,
          "max-length": 2,
          inputmode: "numeric",
          onChange: f[2] || (f[2] = (h) => w("month")),
          "onUpdate:modelValue": f[3] || (f[3] = (h) => l.value = h)
        }, null, 8, ["class", "name", "form-name", "value"])
      ]),
      C("div", null, [
        V(Ot, {
          label: "Year",
          name: `${p.name}-year`
        }, null, 8, ["name"]),
        V(it, {
          class: q({ "coop-form__invalid": g.value }),
          name: `${p.name}-year`,
          "form-name": p.formName,
          value: u.value,
          "only-numbers": "",
          size: "4",
          "min-length": 4,
          "max-length": 4,
          inputmode: "numeric",
          onChange: f[4] || (f[4] = (h) => w("year")),
          "onUpdate:modelValue": f[5] || (f[5] = (h) => u.value = h)
        }, null, 8, ["class", "name", "form-name", "value"])
      ])
    ]));
  }
}), xi = /* @__PURE__ */ te(Ri, [["__scopeId", "data-v-14000a07"]]), Ii = {
  key: 0,
  class: "coop-form__error"
}, Ni = /* @__PURE__ */ W({
  __name: "ErrorElement",
  props: {
    error: {
      type: Object,
      default: () => ({})
    },
    errorType: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e, { findErrorMessage: n } = de(), o = $(() => n(t.errorType, t.error ?? {}));
    return (a, s) => e.errorType ? (b(), v("p", Ii, L(o.value), 1)) : P("", !0);
  }
}), $i = { class: "coop-form__hint" }, Vi = ["innerHTML"], Ui = /* @__PURE__ */ W({
  __name: "HintElement",
  props: {
    hint: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (b(), v("p", $i, [
      C("span", { innerHTML: e.hint }, null, 8, Vi)
    ]));
  }
}), Gi = { class: "fnc-form__legend" }, Hi = /* @__PURE__ */ W({
  __name: "LegendElement",
  props: {
    legend: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (b(), v("legend", Gi, L(e.legend), 1));
  }
}), Qa = /* @__PURE__ */ te(Hi, [["__scopeId", "data-v-d190e5af"]]), Wi = ["role"], zi = {
  key: 0,
  class: "coop-c-notification__heading"
}, Ki = ["innerHTML"], ji = /* @__PURE__ */ W({
  __name: "NotificationComponent",
  props: {
    type: {
      type: String,
      required: !0
    },
    heading: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = () => {
      switch (t.type) {
        case "success":
          return "status";
        case "alert":
        case "error":
          return "alert";
        default:
          return "status";
      }
    };
    return (o, a) => (b(), v("div", {
      class: q(["coop-c-notification", [e.type !== "" ? `coop-c-notification--${e.type}` : "", e.loading ? "coop-btn--loading" : ""]]),
      role: n()
    }, [
      e.heading ? (b(), v("h3", zi, L(e.heading), 1)) : P("", !0),
      C("div", {
        class: "coop-c-notification__p",
        innerHTML: e.message
      }, null, 8, Ki)
    ], 10, Wi));
  }
}), mt = /* @__PURE__ */ te(ji, [["__scopeId", "data-v-d013fdfd"]]), qi = { class: "fnc-form__membership" }, Yi = "<p>It looks like you have a membership number for a different Co-op society, such as Midcounties or Central England Co-op. These membership numbers cannot be used.</p>", Zi = /* @__PURE__ */ W({
  __name: "MembershipElement",
  props: {
    value: {
      type: String,
      default: ""
    },
    validate: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "30"
    },
    ...We
  },
  setup(e) {
    const t = e, { updateFormProperty: n } = de(), o = B(!1), a = B(t.value), s = (l) => {
      a.value = l;
    };
    Y(
      () => t.validate,
      () => {
        if (t.validate) {
          const l = a.value.replace(/\s/g, "");
          /^9[5678](\d){10}$/.test(l) ? o.value = !0 : o.value = !1, n(t.formName, t.name, "validate", !1);
        }
      }
    );
    const r = B(!1);
    return (l, i) => (b(), v(se, null, [
      C("div", qi, [
        C("div", {
          class: q(["fnc-form__membership__prefix", [
            {
              "fnc-form__membership__prefix--error": l.hasError && !r.value,
              "fnc-form__membership__prefix--focus": r.value
            }
          ]])
        }, [
          V(ee, {
            name: "coop-card",
            fill: "#00a1cc"
          }),
          i[2] || (i[2] = C("span", { class: "fnc-form__membership__prefix__text" }, "633174", -1))
        ], 2),
        V(it, {
          class: "fnc-form__membership__input",
          "form-name": l.formName,
          name: l.name,
          value: a.value,
          size: e.size,
          "max-length": 14,
          inputmode: "numeric",
          "has-error": l.hasError,
          formatter: "membership",
          "only-number": "",
          "allow-space": "",
          onFocus: i[0] || (i[0] = (u) => r.value = !0),
          onBlur: i[1] || (i[1] = (u) => r.value = !1),
          "onUpdate:modelValue": s
        }, null, 8, ["form-name", "name", "value", "size", "has-error"])
      ]),
      o.value ? (b(), z(mt, {
        key: 0,
        class: "coop-u-margin-t-32 coop-u-margin-b-0",
        type: "alert",
        message: Yi
      })) : P("", !0)
    ], 64));
  }
}), Xi = /* @__PURE__ */ te(Zi, [["__scopeId", "data-v-0716e754"]]), Ji = { class: "fnc-options-wrapper" }, Qi = ["id", "name", "value"], eu = ["for", "innerHTML"], tu = {
  key: 0,
  class: "fnc-boxed-radio__description"
}, nu = /* @__PURE__ */ W({
  __name: "RadioElement",
  props: {
    value: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    ...We
  },
  setup(e) {
    const t = e, { updateFormValue: n } = de(), o = B(t.value), a = () => {
      n(t.formName, t.name, o.value, !1, t.elementName);
    };
    return Y(
      () => t.value,
      () => {
        o.value = t.value;
      }
    ), (s, r) => (b(), v("div", Ji, [
      (b(!0), v(se, null, we(e.options, (l) => (b(), v("div", {
        key: l.value,
        class: q(["coop-form__choice", [{ "fnc-boxed-radio": s.type === "boxed-radio" }]])
      }, [
        fe(C("input", {
          id: `${s.name}-${l.value}`,
          "onUpdate:modelValue": r[0] || (r[0] = (i) => o.value = i),
          class: "sessioncamexclude coop-form__field coop-form__radio",
          type: "radio",
          name: s.name,
          value: l.value,
          onChange: a
        }, null, 40, Qi), [
          [ea, o.value]
        ]),
        C("label", {
          class: "coop-form__label",
          for: `${s.name}-${l.value}`,
          innerHTML: l.label
        }, null, 8, eu),
        l.description && s.type === "boxed-radio" ? (b(), v("p", tu, L(l.description), 1)) : P("", !0)
      ], 2))), 128))
    ]));
  }
}), ou = /* @__PURE__ */ te(nu, [["__scopeId", "data-v-0d0b29a9"]]), au = ["id", "name"], su = ["value", "innerHTML"], ru = /* @__PURE__ */ W({
  __name: "SelectElement",
  props: {
    value: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "30"
    },
    ...We
  },
  setup(e) {
    const t = e, { updateFormValue: n } = de(), o = B(t.value), a = () => {
      n(t.formName, t.name, o.value, !1, t.elementName);
    };
    return Y(
      () => t.value,
      () => {
        o.value = t.value;
      }
    ), (s, r) => fe((b(), v("select", {
      id: s.name,
      "onUpdate:modelValue": r[0] || (r[0] = (l) => o.value = l),
      class: q(["sessioncamexclude coop-form__field coop-form__select", [`coop-form__field--width-${e.size || "30"}`, { "coop-form__invalid": s.hasError }]]),
      name: s.name,
      onChange: a
    }, [
      r[1] || (r[1] = C("option", {
        value: "",
        disabled: ""
      }, " Please select ", -1)),
      (b(!0), v(se, null, we(e.options, (l) => (b(), v("option", {
        key: l.value,
        value: l.value,
        innerHTML: l.label
      }, null, 8, su))), 128))
    ], 42, au)), [
      [ta, o.value]
    ]);
  }
}), lu = ["id", "name", "maxlength"], iu = /* @__PURE__ */ W({
  __name: "TextAreaElement",
  props: {
    value: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "30"
    },
    maxLength: {
      type: Number,
      default: 255
    },
    ...We
  },
  setup(e) {
    const t = e, { updateFormValue: n } = de(), o = B(t.value), a = () => {
      n(t.formName, t.name, o.value, !1, t.elementName);
    };
    return (s, r) => fe((b(), v("textarea", {
      id: s.name,
      "onUpdate:modelValue": r[0] || (r[0] = (l) => o.value = l),
      name: s.name,
      class: q(["sessioncamexclude coop-form__field coop-form__input", [`coop-form__field--width-${e.size || "30"}`, { "coop-form__invalid": s.hasError }]]),
      rows: "4",
      maxlength: e.maxLength,
      onChange: a
    }, null, 42, lu)), [
      [fn, o.value]
    ]);
  }
}), uu = ["id"], Dt = /* @__PURE__ */ W({
  __name: "InputGroup",
  props: {
    formName: {
      type: String,
      required: !0
    },
    field: {
      type: Object,
      required: !0
    },
    elementName: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return (t, n) => e.field.type !== "hidden" ? (b(), v("fieldset", {
      key: 0,
      id: e.field.name,
      class: "coop-form__row"
    }, [
      e.field.legend ? (b(), z(Qa, {
        key: 0,
        class: q(e.field.customClass),
        legend: e.field.legend
      }, null, 8, ["class", "legend"])) : P("", !0),
      V(Ot, {
        class: q(e.field.customClass),
        label: e.field.label,
        name: e.field.name,
        "is-composite-label": e.field.isCompositeLabel
      }, null, 8, ["class", "label", "name", "is-composite-label"]),
      e.field.hint ? (b(), z(Ui, {
        key: 1,
        class: q(e.field.customClass),
        hint: e.field.hint
      }, null, 8, ["class", "hint"])) : P("", !0),
      e.field.errorType ? (b(), z(Ni, {
        key: 2,
        class: q(e.field.customClass),
        error: e.field.error,
        "error-type": e.field.errorType
      }, null, 8, ["class", "error", "error-type"])) : P("", !0),
      e.field.element === "membership-element" ? (b(), z(Xi, {
        key: 3,
        class: q(e.field.customClass),
        "form-name": e.formName,
        name: e.field.name,
        value: e.field.value,
        size: e.field.size,
        validate: e.field.validate || !1,
        "has-error": e.field.errorType !== "" && e.field.errorType !== void 0 && e.field.optional !== !0
      }, null, 8, ["class", "form-name", "name", "value", "size", "validate", "has-error"])) : e.field.element === "date-element" ? (b(), z(xi, {
        key: 4,
        class: q(e.field.customClass),
        "form-name": e.formName,
        name: e.field.name,
        value: e.field.value,
        validate: e.field.validate || !1,
        "has-error": e.field.errorType !== "" && e.field.errorType !== void 0 && e.field.optional !== !0
      }, null, 8, ["class", "form-name", "name", "value", "validate", "has-error"])) : e.field.type === "textarea" ? (b(), z(iu, {
        key: 5,
        class: q(e.field.customClass),
        "form-name": e.formName,
        name: e.field.name,
        value: e.field.value,
        size: e.field.size,
        "max-length": e.field.maxLength,
        "element-name": e.elementName,
        "has-error": e.field.errorType !== "" && e.field.errorType !== void 0 && e.field.optional !== !0
      }, null, 8, ["class", "form-name", "name", "value", "size", "max-length", "element-name", "has-error"])) : e.field.type === "select" ? (b(), z(ru, {
        key: 6,
        class: q(e.field.customClass),
        "form-name": e.formName,
        name: e.field.name,
        options: e.field?.options,
        value: e.field.value,
        validation: e.field.validation,
        size: e.field.size,
        "element-name": e.elementName,
        "has-error": e.field.errorType !== "" && e.field.errorType !== void 0 && e.field.optional !== !0
      }, null, 8, ["class", "form-name", "name", "options", "value", "validation", "size", "element-name", "has-error"])) : e.field.type === "radio" || e.field.type === "boxed-radio" ? (b(), z(ou, {
        key: 7,
        class: q(e.field.customClass),
        "form-name": e.formName,
        type: e.field.type,
        name: e.field.name,
        options: e.field?.options,
        value: e.field.value,
        "element-name": e.elementName
      }, null, 8, ["class", "form-name", "type", "name", "options", "value", "element-name"])) : e.field.type === "checkbox" ? (b(), z(Ti, {
        key: 8,
        class: q(e.field.customClass),
        "form-name": e.formName,
        name: e.field.name,
        options: e.field?.options,
        values: e.field.values || [],
        "element-name": e.elementName
      }, null, 8, ["class", "form-name", "name", "options", "values", "element-name"])) : (b(), z(it, {
        key: 9,
        class: q(e.field.customClass),
        "form-name": e.formName,
        name: e.field.name,
        type: e.field?.type,
        value: e.field.value,
        "only-numbers": e.field.onlyNumbers,
        "allow-spaces": e.field.allowSpaces,
        readonly: e.field.readonly,
        size: e.field.size,
        "max-length": e.field.maxLength,
        "element-name": e.elementName,
        "has-error": e.field.errorType !== "" && e.field.errorType !== void 0 && e.field.optional !== !0
      }, null, 8, ["class", "form-name", "name", "type", "value", "only-numbers", "allow-spaces", "readonly", "size", "max-length", "element-name", "has-error"]))
    ], 8, uu)) : P("", !0);
  }
}), cu = { class: "billing-address-section" }, du = { key: 0 }, pu = { key: 0 }, mu = { key: 1 }, fu = { key: 2 }, hu = { key: 3 }, yu = { key: 4 }, _u = { key: 1 }, bu = /* @__PURE__ */ W({
  __name: "BillingAddressForm",
  props: {
    billingAddress: {
      type: Object,
      required: !0
    }
  },
  emits: ["updateAddress"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = B(!1), { getFormByName: s, getFieldByName: r } = de();
    ft(() => {
      ri(n.billingAddress);
    });
    const l = $(() => {
      const p = r(Oe, "address_1"), f = r(Oe, "address_2"), h = r(Oe, "town_city"), m = r(Oe, "county"), d = r(Oe, "postcode");
      return {
        address_1: p?.value || "",
        address_2: f?.value || "",
        town_city: h?.value || "",
        county: m?.value || "",
        postcode: d?.value || ""
      };
    }), i = $(() => !!(l.value.address_1 || l.value.address_2 || l.value.town_city || l.value.county || l.value.postcode)), u = () => {
      a.value = !0;
    }, g = $(() => s(Oe).form.steps[0].fields), _ = () => {
      let p = !0;
      return g.value.forEach((f) => {
        !f.optional && (!f.value || f.value.trim() === "") ? (f.errorType = "empty", p = !1) : f.errorType = "";
      }), p;
    }, w = () => {
      _() && (o("updateAddress", { ...l.value }), a.value = !1);
    };
    return (p, f) => (b(), v("div", cu, [
      f[0] || (f[0] = C("div", { class: "billing-address-header" }, [
        C("h3", { class: "coop-form__label" }, "Billing address")
      ], -1)),
      !a.value && i.value ? (b(), v("div", du, [
        V(Ja, { "data-cy": "billing-address-highlight-box" }, {
          default: He(() => [
            l.value.address_1 ? (b(), v("span", pu, L(l.value.address_1), 1)) : P("", !0),
            l.value.address_2 ? (b(), v("span", mu, L(l.value.address_2), 1)) : P("", !0),
            l.value.town_city ? (b(), v("span", fu, L(l.value.town_city), 1)) : P("", !0),
            l.value.county ? (b(), v("span", hu, L(l.value.county), 1)) : P("", !0),
            l.value.postcode ? (b(), v("span", yu, L(l.value.postcode), 1)) : P("", !0),
            C("a", {
              href: "#",
              onClick: Pe(u, ["prevent"])
            }, "Change address")
          ]),
          _: 1
        })
      ])) : (b(), v("div", _u, [
        (b(!0), v(se, null, we(g.value, (h) => (b(), z(Dt, {
          key: h.name,
          "form-name": O(Oe),
          field: h
        }, null, 8, ["form-name", "field"]))), 128)),
        V(ot, {
          label: "Save",
          color: "teal",
          category: "secondary",
          onClick: w
        })
      ]))
    ]));
  }
}), gu = /* @__PURE__ */ te(bu, [["__scopeId", "data-v-da4a1920"]]), vu = {
  key: 0,
  id: "formValidation",
  class: "coop-c-message coop-c-message--error",
  tabindex: "-1",
  role: "alert"
}, wu = { class: "coop-c-message__message" }, Eu = { class: "payment-wrapper" }, Cu = { class: "payment-wrapper__options" }, Su = { class: "payment-accordion-head" }, Au = { class: "coop-form__choice coop-form__choice__nomargin" }, ku = ["id", "data-testid", "onchange", "value"], Tu = ["for"], Ou = { class: "credit-card-list-wrapper" }, Pu = { class: "payment-icons" }, Mu = {
  key: 0,
  src: Yl,
  alt: "Mastercard"
}, Fu = {
  key: 1,
  src: Zl,
  alt: "Visa"
}, Bu = {
  key: 2,
  src: Xl,
  alt: "Apple Pay"
}, Du = {
  key: 3,
  src: Jl,
  alt: "Google Pay"
}, Lu = { key: 0 }, Ru = ["action", "data-brands"], xu = /* @__PURE__ */ W({
  __name: "ACIWidget",
  props: {
    data: {
      type: Object,
      required: !0
    },
    paymentWidgetUrl: {
      type: String,
      required: !0
    }
  },
  emits: ["addressUpdated"],
  setup(e, { emit: t }) {
    const { setACIWidgetConfiguration: n, updateBillingAddress: o, currentBillingAddress: a } = ei(), { isGooglePaySupported: s } = Xa(), { isApplePaySupported: r } = Za(), l = e, i = ["VISA", "MASTER", "GOOGLEPAY", "APPLEPAY"].join(" "), u = B(!1), g = B(null), _ = B([]), w = B(!1), p = B(!1), f = l.data, h = async () => {
      try {
        await zt(l.paymentWidgetUrl + "/paymentWidgets.js?checkoutId=" + f.checkoutId), _.value = [ie.CARD], await zt("https://pay.google.com/gp/p/js/pay.js"), r() && await zt("https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js"), w.value = await s(), p.value = r(), w.value && _.value.push(ie.GOOGLEPAY), p.value && _.value.push(ie.APPLEPAY);
      } catch (x) {
        console.error("Failed to initialize payments:", x);
      }
    };
    ft(async () => {
      await h();
    });
    const m = () => {
      u.value = !1;
    }, d = async () => ({
      transactionState: "SUCCESS"
    }), c = () => {
      u.value = !1;
    }, y = async () => ({
      transactionState: "SUCCESS"
    }), A = (x) => {
      switch (x) {
        case ie.CARD:
          return "Credit or debit card";
        case ie.APPLEPAY:
          return "Apple Pay";
        case ie.GOOGLEPAY:
          return "Google Pay";
        default:
          return "";
      }
    }, k = t, R = (x, G) => {
      if (!document) return;
      const N = document.querySelector(x);
      N && G && (N.value = G);
    }, T = (x) => {
      const G = o(x);
      document && (R(".wpwl-control-city", x.town_city), R(".wpwl-control-postcode", x.postcode), R(".wpwl-control-street1", x.address_1), R(".wpwl-control-street2", x.address_2), R(".wpwl-control-stateText", x.county)), k("addressUpdated", G);
    }, K = async () => {
      u.value = !0, await Z() || (u.value = !1);
    }, Z = async () => (S.value = !1, U.value = "", g.value ? g.value === ie.CARD && (await new Promise((G) => setTimeout(G, 300)), document.querySelectorAll(".wpwl-has-error").length > 0) ? (S.value = !0, U.value = "Please check your card details and try again", !1) : !0 : (S.value = !0, U.value = "Please select a payment type", !1)), M = () => {
      S.value = !0, U.value = "Please select a payment type";
    };
    n({
      updatePaymentInProgress: K,
      onGooglePayCancel: m,
      onGooglePayAuthorized: d,
      onApplePayCancel: c,
      onApplePayAuthorized: y,
      gatewayMerchantId: l.data.gatewayMerchantId,
      googleMerchantId: l.data.googleMerchantId,
      billingAddress: l.data.billingAddress
    });
    const S = B(!1), U = B("");
    return (x, G) => (b(), v(se, null, [
      S.value ? (b(), v("div", vu, [
        G[1] || (G[1] = C("h2", { id: "validation-demo-box-heading" }, "There's a problem", -1)),
        C("p", wu, L(U.value), 1)
      ])) : P("", !0),
      C("div", Eu, [
        G[2] || (G[2] = C("h3", { class: "fnc-heading" }, "How would you like to pay?", -1)),
        C("div", Cu, [
          (b(!0), v(se, null, we(_.value, (N) => (b(), v("fieldset", {
            key: N,
            class: q(["payment-accordion", { selected: g.value === N }])
          }, [
            C("div", Su, [
              C("div", Au, [
                fe(C("input", {
                  id: `payment-${N}`,
                  "onUpdate:modelValue": G[0] || (G[0] = (H) => g.value = H),
                  "data-testid": N === O(ie).GOOGLEPAY ? "payment-GooglePay" : "",
                  type: "radio",
                  onchange: () => S.value = !1,
                  name: "payment-type",
                  value: N,
                  class: "sessioncamexclude coop-form__field coop-form__radio"
                }, null, 8, ku), [
                  [ea, g.value]
                ]),
                C("label", {
                  class: "coop-form__label",
                  for: `payment-${N}`
                }, L(A(N)), 9, Tu)
              ]),
              C("div", Ou, [
                C("div", Pu, [
                  N === O(ie).CARD ? (b(), v("img", Mu)) : P("", !0),
                  N === O(ie).CARD ? (b(), v("img", Fu)) : N === O(ie).APPLEPAY ? (b(), v("img", Bu)) : N === O(ie).GOOGLEPAY ? (b(), v("img", Du)) : P("", !0)
                ])
              ])
            ]),
            fe(C("div", null, [
              N === O(ie).CARD ? (b(), v("div", Lu, [
                C("form", {
                  action: O(f).redirectUrl,
                  "data-brands": O(i),
                  class: "paymentWidgets"
                }, null, 8, Ru),
                O(a) ? (b(), z(gu, {
                  key: 0,
                  "billing-address": O(a),
                  onUpdateAddress: T
                }, null, 8, ["billing-address"])) : P("", !0)
              ])) : P("", !0)
            ], 512), [
              [rt, g.value === N]
            ])
          ], 2))), 128))
        ]),
        V(si, {
          "selected-payment-type": g.value,
          "payment-loading": u.value,
          onHandleSubmit: K,
          onHandleNoPaymentTypeSelected: M
        }, null, 8, ["selected-payment-type", "payment-loading"])
      ])
    ], 64));
  }
}), Iu = { class: "fnc-finder__predictions" }, Nu = ["onClick"], $u = { class: "fnc-finder__prediction__main" }, Vu = { class: "fnc-finder__prediction__main--match" }, Uu = { class: "fnc-finder__prediction__secondary" }, Gu = /* @__PURE__ */ W({
  __name: "BranchFinderPredictions",
  props: {
    predictions: {
      type: Array,
      required: !0
    },
    highlightPrediction: {
      type: Number,
      default: -1
    }
  },
  emits: ["selectPrediction"],
  setup(e) {
    const t = (s) => {
      const r = s.structured_formatting.main_text, l = s.structured_formatting.main_text_matched_substrings[0];
      if (!l) return { before: r, match: "", after: "" };
      const i = r.slice(0, l.offset), u = r.slice(l.offset, l.offset + l.length), g = r.slice(l.offset + l.length);
      return { before: i, match: u, after: g };
    }, n = (s) => $(() => t(s).before), o = (s) => $(() => t(s).match), a = (s) => $(() => t(s).after);
    return (s, r) => (b(), v("div", Iu, [
      (b(!0), v(se, null, we(e.predictions, (l, i) => (b(), v("button", {
        key: l.place_id,
        class: q(["fnc-finder__prediction", { "fnc-finder__prediction--active": i === e.highlightPrediction }]),
        onClick: (u) => s.$emit("selectPrediction", l)
      }, [
        C("span", $u, [
          Ze(L(n(l)), 1),
          C("span", Vu, L(o(l)), 1),
          Ze(L(a(l)), 1)
        ]),
        C("span", Uu, L(l.structured_formatting.secondary_text), 1)
      ], 10, Nu))), 128))
    ]));
  }
}), Hu = /* @__PURE__ */ te(Gu, [["__scopeId", "data-v-23cb43a6"]]), Wu = ["href", "target"], Nt = /* @__PURE__ */ W({
  __name: "ButtonLinkComponent",
  props: {
    label: {
      type: String,
      required: !0
    },
    link: {
      type: String,
      default: ""
    },
    newTab: {
      type: Boolean,
      default: !1
    },
    round: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: "teal"
    }
  },
  setup(e) {
    return (t, n) => (b(), v("span", {
      class: q(["fnc-btn fnc-btn-link fnc-btn--primary", [e.round ? `fnc-btn--${e.color} coop-btn fnc-btn-link--round` : "coop-t-link"]])
    }, [
      e.link ? (b(), v("a", {
        key: 0,
        href: e.link,
        target: e.newTab ? "_blank" : ""
      }, [
        ve(t.$slots, "icon"),
        Ze(" " + L(e.label), 1)
      ], 8, Wu)) : (b(), v(se, { key: 1 }, [
        ve(t.$slots, "icon"),
        C("span", null, L(e.label), 1)
      ], 64))
    ], 2));
  }
}), zu = () => {
  const e = B("");
  return {
    errorMessage: e,
    updateErrorMessage: (o) => {
      e.value = o;
    },
    hideErrorMessage: () => {
      e.value = "";
    }
  };
}, es = [
  "https://www.coop.co.uk",
  "https://preprod.coop.co.uk",
  "https://qa.coop.co.uk",
  "https://development.coop.co.uk",
  "https://development.api.fnc-dev.digital.coop.co.uk",
  "https://qa.api.fnc-dev.digital.coop.co.uk",
  "https://preprod.api.funeral.coop.co.uk",
  "https://api.funeral.coop.co.uk"
], Ku = 100, ju = null, qu = null, Yu = /* @__PURE__ */ JSON.parse('[{"name":"Salford Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405521","branch_id":"45521","url":"/funeralcare/funeral-directors/manchester/M5-4AL/143-cross-lane","street_address":"143 Cross Lane","street_address2":"Salford","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M5 4AL","position":{"x":-2.280417,"y":53.481754,"srid":4326},"phone":"0161 736 1487","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":2510}},{"name":"B Littler Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"403660","branch_id":"43660","url":"/funeralcare/funeral-directors/manchester/M7-2LA/b-littler-funeralcare/278-lower-broughton-road","street_address":"278 Lower Broughton Road","street_address2":"Salford","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M7 2LA","position":{"x":-2.269696,"y":53.498488,"srid":4326},"phone":"0161 792 4108","email":null,"image":null,"website":"http://www.littlersfuneralservice.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":2667}},{"name":"Leech Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"401070","branch_id":"41070","url":"/funeralcare/funeral-directors/manchester/M14-4TH/leech-funeralcare/95-princess-road","street_address":"95 Princess Road","street_address2":"Moss Side","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M14 4TH","position":{"x":-2.244902,"y":53.456729,"srid":4326},"phone":"0161 226 5111","email":null,"image":null,"website":"http://www.leechsfuneralservice.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":2677}},{"name":"Laithwaites Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"404050","branch_id":"44050","url":"/funeralcare/funeral-directors/manchester/M6-7DE/laithwaites-funeralcare/15-eccles-old-road","street_address":"15 Eccles Old Road","street_address2":"Salford","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M6 7DE","position":{"x":-2.293957,"y":53.49184,"srid":4326},"phone":"0161 736 1414","email":null,"image":null,"website":"http://www.laithwaitefuneralservices.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":3622}},{"name":"Chorlton  Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"406001","branch_id":"46001","url":"/funeralcare/funeral-directors/manchester/M21-9BG/102-unit-c-manchester-road","street_address":"102 Unit C Manchester Road","street_address2":"Chorlton-Cum-Hardy","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M21 9BG","position":{"x":-2.27775,"y":53.446011,"srid":4326},"phone":"0161 881 2212","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":4514}},{"name":"Moston Funeralcare (inc. Lansdowne Funeral Home)","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"402490","branch_id":"42490","url":"/funeralcare/funeral-directors/manchester/M40-9DJ/157-kenyon-lane","street_address":"157 Kenyon Lane","street_address2":"Moston","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M40 9DJ","position":{"x":-2.193286,"y":53.510279,"srid":4326},"phone":"0161 683 4334","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 4pm","type":"hours","opens":"09:00","closes":"16:00"},{"name":"Tuesday","label":"9am to 4pm","type":"hours","opens":"09:00","closes":"16:00"},{"name":"Wednesday","label":"9am to 4pm","type":"hours","opens":"09:00","closes":"16:00"},{"name":"Thursday","label":"9am to 4pm","type":"hours","opens":"09:00","closes":"16:00"},{"name":"Friday","label":"9am to 4pm","type":"hours","opens":"09:00","closes":"16:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":4637}},{"name":"Co-op Funeralcare, Droylsden","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405481","branch_id":"45481","url":"/funeralcare/funeral-directors/manchester/M43-6QX/362-370-manchester-road","street_address":"362-370 Manchester Road","street_address2":"Droylsden","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M43 6QX","position":{"x":-2.162791,"y":53.480804,"srid":4326},"phone":"0161 371 1003","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":5298}},{"name":"C Taylor Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"401190","branch_id":"41190","url":"/funeralcare/funeral-directors/manchester/M18-7FB/c-taylor-funeralcare/973-hyde-road","street_address":"973 Hyde Road","street_address2":"Gorton","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M18 7FB","position":{"x":-2.168705,"y":53.460268,"srid":4326},"phone":"0161 223 0793","email":null,"image":null,"website":"http://www.taylorfuneralservices.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":5410}},{"name":"Charles Robb Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"401150","branch_id":"41150","url":"/funeralcare/funeral-directors/manchester/M19-2PA/charles-robb-funeralcare/22-errwood-road","street_address":"22 Errwood Road","street_address2":"Levenshulme","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M19 2PA","position":{"x":-2.193553,"y":53.440743,"srid":4326},"phone":"0161 224 1200","email":null,"image":null,"website":"http://www.charlesrobbfuneralservices.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":5517}},{"name":"Co-op Funeralcare, Failsworth","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405730","branch_id":"45730","url":"/funeralcare/funeral-directors/manchester/M35-0HB/292a-oldham-road","street_address":"292a Oldham Road","street_address2":"Failsworth","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M35 0HB","position":{"x":-2.165709,"y":53.506914,"srid":4326},"phone":"0161 682 6139","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":5874}},{"name":"Co-op Funeralcare, Blackley","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"401090","branch_id":"41090","url":"/funeralcare/funeral-directors/manchester/M9-6RA/11-victoria-avenue","street_address":"11 Victoria Avenue","street_address2":"Blackley","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M9 6RA","position":{"x":-2.209132,"y":53.532535,"srid":4326},"phone":"0161 795 3400","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":6173}},{"name":"Co-op Funeralcare, Prestwich","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"404020","branch_id":"44020","url":"/funeralcare/funeral-directors/bury/M25-1BD/438-bury-new-road","street_address":"438 Bury New Road","street_address2":"Prestwich","street_address3":"","town":"Bury","county":"Greater Manchester","postcode":"M25 1BD","position":{"x":-2.283831,"y":53.531805,"srid":4326},"phone":"0161 773 1071","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 10am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"10am to 3pm","type":"hours","opens":"10:00","closes":"15:00"},{"name":"Tuesday","label":"10am to 3pm","type":"hours","opens":"10:00","closes":"15:00"},{"name":"Wednesday","label":"10am to 3pm","type":"hours","opens":"10:00","closes":"15:00"},{"name":"Thursday","label":"10am to 3pm","type":"hours","opens":"10:00","closes":"15:00"},{"name":"Friday","label":"10am to 3pm","type":"hours","opens":"10:00","closes":"15:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":6302}},{"name":"Bridgford Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"403620","branch_id":"43620","url":"/funeralcare/funeral-directors/manchester/M27-4AF/bridgford-funeralcare/23-chorley-road","street_address":"23 Chorley Road","street_address2":"Swinton","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M27 4AF","position":{"x":-2.333136,"y":53.508621,"srid":4326},"phone":"0161 793 1228","email":null,"image":null,"website":"http://www.bridgfordfuneralservices.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":6757}},{"name":"Eccles Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405491","branch_id":"45491","url":"/funeralcare/funeral-directors/manchester/M30-0LZ/204-church-street","street_address":"204 Church Street","street_address2":"Eccles","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M30 0LZ","position":{"x":-2.344428,"y":53.483248,"srid":4326},"phone":"0161 789 3083","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 10am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"10am to 4:30pm","type":"hours","opens":"10:00","closes":"16:30"},{"name":"Tuesday","label":"10am to 4:30pm","type":"hours","opens":"10:00","closes":"16:30"},{"name":"Wednesday","label":"10am to 4:30pm","type":"hours","opens":"10:00","closes":"16:30"},{"name":"Thursday","label":"10am to 4:30pm","type":"hours","opens":"10:00","closes":"16:30"},{"name":"Friday","label":"10am to 4:30pm","type":"hours","opens":"10:00","closes":"16:30"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":6761}},{"name":"R. A. Fairhurst & Sons","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"401220","branch_id":"41220","url":"/funeralcare/funeral-directors/stockport/SK5-6AB/r-a-fairhurst-and-sons/9-lingard-street","street_address":"9 Lingard Street","street_address2":"Reddish","street_address3":"","town":"Stockport","county":"Greater Manchester","postcode":"SK5 6AB","position":{"x":-2.15884,"y":53.438336,"srid":4326},"phone":"0161 432 1700","email":null,"image":null,"website":"http://www.fairhurstfuneraldirectors.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":7295}},{"name":"The Heatons Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405532","branch_id":"45532","url":"/funeralcare/funeral-directors/stockport/SK4-5DH/manchester-road","street_address":"Manchester Road","street_address2":"Heaton Chapel","street_address3":"","town":"Stockport","county":"Greater Manchester","postcode":"SK4 5DH","position":{"x":-2.175626,"y":53.428662,"srid":4326},"phone":"0161 432 0818","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":7306}},{"name":"J R Barlow Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"401030","branch_id":"41030","url":"/funeralcare/funeral-directors/manchester/M27-6BY/j-r-barlow-funeralcare/238-station-road","street_address":"238 Station Road","street_address2":"Pendlebury","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M27 6BY","position":{"x":-2.333709,"y":53.518494,"srid":4326},"phone":"0161 794 2142","email":null,"image":null,"website":"http://www.barlowfuneralservices.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":7357}},{"name":"Urmston Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"406007","branch_id":"46007","url":"/funeralcare/funeral-directors/manchester/M41-0TS/urmston-funeralcare/12-crofts-bank-road","street_address":"12 Crofts Bank Road","street_address2":"Urmston","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M41 0TS","position":{"x":-2.35483,"y":53.45295,"srid":4326},"phone":"0161 748 2316","email":null,"image":null,"website":"http://www.coop.co.uk/funeralcare","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Tuesday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Wednesday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Thursday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Friday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":8065}},{"name":"R E Jones Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"406680","branch_id":"46680","url":"/funeralcare/funeral-directors/sale/M33-6NP/r-e-jones-funeralcare/17-ashton-lane","street_address":"17 Ashton Lane","street_address2":"","street_address3":"","town":"Sale","county":"Greater Manchester","postcode":"M33 6NP","position":{"x":-2.327691,"y":53.426045,"srid":4326},"phone":"0161 973 1536","email":null,"image":null,"website":"http://www.rejonesfuneraldirectors.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9:30am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9:30am to 4pm","type":"hours","opens":"09:30","closes":"16:00"},{"name":"Tuesday","label":"9:30am to 4pm","type":"hours","opens":"09:30","closes":"16:00"},{"name":"Wednesday","label":"9:30am to 4pm","type":"hours","opens":"09:30","closes":"16:00"},{"name":"Thursday","label":"9:30am to 4pm","type":"hours","opens":"09:30","closes":"16:00"},{"name":"Friday","label":"9:30am to 4pm","type":"hours","opens":"09:30","closes":"16:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":8304}},{"name":"Middleton Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"402410","branch_id":"42410","url":"/funeralcare/funeral-directors/manchester/M24-2LH/140-oldham-road","street_address":"140 Oldham Road","street_address2":"Middleton","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M24 2LH","position":{"x":-2.190635,"y":53.549522,"srid":4326},"phone":"0161 643 2690","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Tuesday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Wednesday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Thursday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Friday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":8391}},{"name":"Co-op Funeralcare, Sale","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405473","branch_id":"45473","url":"/funeralcare/funeral-directors/sale/M33-3NE/172-marsland-road","street_address":"172 Marsland Road","street_address2":"","street_address3":"","town":"Sale","county":"Greater Manchester","postcode":"M33 3NE","position":{"x":-2.319163,"y":53.417859,"srid":4326},"phone":"0161 905 1735","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Tuesday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Wednesday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Thursday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Friday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":8649}},{"name":"Dowse Catterall Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"401040","branch_id":"41040","url":"/funeralcare/funeral-directors/manchester/M34-3LJ/dowse-catterall-funeralcare/30-ashworth-street","street_address":"30 Ashworth Street","street_address2":"Denton","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M34 3LJ","position":{"x":-2.115356,"y":53.457585,"srid":4326},"phone":"0161 336 6023","email":null,"image":null,"website":"http://www.dowsecatterallfuneralservice.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":8833}},{"name":"Cheadle Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405823","branch_id":"45823","url":"/funeralcare/funeral-directors/cheadle/SK8-1AA/75-high-street","street_address":"75 High Street","street_address2":"","street_address3":"","town":"Cheadle","county":"Greater Manchester","postcode":"SK8 1AA","position":{"x":-2.216773,"y":53.393919,"srid":4326},"phone":"0161 491 5300","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 10am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"10am to 2pm","type":"hours","opens":"10:00","closes":"14:00"},{"name":"Tuesday","label":"10am to 2pm","type":"hours","opens":"10:00","closes":"14:00"},{"name":"Wednesday","label":"10am to 2pm","type":"hours","opens":"10:00","closes":"14:00"},{"name":"Thursday","label":"10am to 2pm","type":"hours","opens":"10:00","closes":"14:00"},{"name":"Friday","label":"10am to 2pm","type":"hours","opens":"10:00","closes":"14:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":9812}},{"name":"Co-op Funeralcare, Chadderton","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"402450","branch_id":"42450","url":"/funeralcare/funeral-directors/oldham/OL9-9JX/437-middleton-road","street_address":"437 Middleton Road","street_address2":"Chadderton","street_address3":"","town":"Oldham","county":"Greater Manchester","postcode":"OL9 9JX","position":{"x":-2.137227,"y":53.54398,"srid":4326},"phone":"0161 624 2361","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":9916}},{"name":"Baguley Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405451","branch_id":"45451","url":"/funeralcare/funeral-directors/manchester/M23-1WA/206-208-hall-lane","street_address":"206-208 Hall Lane","street_address2":"Baguley","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M23 1WA","position":{"x":-2.279352,"y":53.394033,"srid":4326},"phone":"0161 998 4662","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Tuesday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Wednesday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Thursday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Friday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":9952}},{"name":"Co-op Funeralcare, Oldham","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405511","branch_id":"45511","url":"/funeralcare/funeral-directors/oldham/OL8-1DF/belgrade-house","street_address":"Belgrade House","street_address2":"John Street","street_address3":"","town":"Oldham","county":"Greater Manchester","postcode":"OL8 1DF","position":{"x":-2.119997,"y":53.540269,"srid":4326},"phone":"0161 624 2807","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":10486}},{"name":"Ashton-under-Lyne Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405482","branch_id":"45482","url":"/funeralcare/funeral-directors/ashton-under-lyne/OL6-6QW/50-stamford-square","street_address":"50 Stamford Square","street_address2":"","street_address3":"","town":"Ashton-Under-Lyne","county":"Greater Manchester","postcode":"OL6 6QW","position":{"x":-2.078122,"y":53.486877,"srid":4326},"phone":"0161 330 2010","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 10am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"10am to 3pm","type":"hours","opens":"10:00","closes":"15:00"},{"name":"Tuesday","label":"10am to 3pm","type":"hours","opens":"10:00","closes":"15:00"},{"name":"Wednesday","label":"10am to 3pm","type":"hours","opens":"10:00","closes":"15:00"},{"name":"Thursday","label":"10am to 3pm","type":"hours","opens":"10:00","closes":"15:00"},{"name":"Friday","label":"10am to 3pm","type":"hours","opens":"10:00","closes":"15:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":10937}},{"name":"Co-op Funeralcare, Radcliffe","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405561","branch_id":"45561","url":"/funeralcare/funeral-directors/manchester/M26-4EA/1014-ainsworth-road","street_address":"10/14 Ainsworth Road","street_address2":"Radcliffe","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M26 4EA","position":{"x":-2.333074,"y":53.564174,"srid":4326},"phone":"0161 724 4151","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 10am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"10am to 3pm","type":"hours","opens":"10:00","closes":"15:00"},{"name":"Tuesday","label":"10am to 3pm","type":"hours","opens":"10:00","closes":"15:00"},{"name":"Wednesday","label":"10am to 3pm","type":"hours","opens":"10:00","closes":"15:00"},{"name":"Thursday","label":"10am to 3pm","type":"hours","opens":"10:00","closes":"15:00"},{"name":"Friday","label":"10am to 3pm","type":"hours","opens":"10:00","closes":"15:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":11049}},{"name":"Co-op Funeralcare, Wythenshawe","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405472","branch_id":"45472","url":"/funeralcare/funeral-directors/manchester/M22-5HZ/2-swan-walk","street_address":"2 Swan Walk","street_address2":"Wythenshawe","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M22 5HZ","position":{"x":-2.262347,"y":53.378394,"srid":4326},"phone":"0161 498 0304","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 10am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"10am to 2pm","type":"hours","opens":"10:00","closes":"14:00"},{"name":"Tuesday","label":"10am to 2pm","type":"hours","opens":"10:00","closes":"14:00"},{"name":"Wednesday","label":"10am to 2pm","type":"hours","opens":"10:00","closes":"14:00"},{"name":"Thursday","label":"10am to 2pm","type":"hours","opens":"10:00","closes":"14:00"},{"name":"Friday","label":"10am to 2pm","type":"hours","opens":"10:00","closes":"14:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":11463}},{"name":"Co-op Funeralcare, Altrincham","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405618","branch_id":"45618","url":"/funeralcare/funeral-directors/altrincham/WA14-5LD/186-manchester-road","street_address":"186 Manchester Road","street_address2":"","street_address3":"","town":"Altrincham","county":"Greater Manchester","postcode":"WA14 5LD","position":{"x":-2.352324,"y":53.40035,"srid":4326},"phone":"0161 928 2410","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9:30am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9:30am to 4:30pm","type":"hours","opens":"09:30","closes":"16:30"},{"name":"Tuesday","label":"9:30am to 4:30pm","type":"hours","opens":"09:30","closes":"16:30"},{"name":"Wednesday","label":"9:30am to 4:30pm","type":"hours","opens":"09:30","closes":"16:30"},{"name":"Thursday","label":"9:30am to 4:30pm","type":"hours","opens":"09:30","closes":"16:30"},{"name":"Friday","label":"9:30am to 4:30pm","type":"hours","opens":"09:30","closes":"16:30"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":11537}},{"name":"Bredbury Funeralcare (Inc. J & T Rhodes Funeral Services)","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"401130","branch_id":"41130","url":"/funeralcare/funeral-directors/stockport/SK6-2NA/85-higher-bents-lane","street_address":"85 Higher Bents Lane","street_address2":"Bredbury","street_address3":"","town":"Stockport","county":"Greater Manchester","postcode":"SK6 2NA","position":{"x":-2.10525,"y":53.416739,"srid":4326},"phone":"0161 430 2094","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":11574}},{"name":"Walkden Funeralcare (inc. Cheethams Funeral Service)","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"402340","branch_id":"42340","url":"/funeralcare/funeral-directors/manchester/M28-3FJ/294-bolton-road","street_address":"294 Bolton Road","street_address2":"Walkden","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M28 3FJ","position":{"x":-2.40036,"y":53.531218,"srid":4326},"phone":"0161 790 2924","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":11872}},{"name":"Davenport Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"409966","branch_id":"49966","url":"/funeralcare/funeral-directors/stockport/SK3-8TE/214-bramhall-lane","street_address":"214 Bramhall Lane","street_address2":"Davenport","street_address3":"","town":"Stockport","county":"Greater Manchester","postcode":"SK3 8TE","position":{"x":-2.152712,"y":53.385254,"srid":4326},"phone":"01614 561 709","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":12189}},{"name":"Ben Lloyd Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"401240","branch_id":"41240","url":"/funeralcare/funeral-directors/cheadle-hulme/SK8-7AA/ben-lloyd-funeralcare/51-station-road","street_address":"51 Station Road","street_address2":"","street_address3":"","town":"Cheadle Hulme","county":"Greater Manchester","postcode":"SK8 7AA","position":{"x":-2.187033,"y":53.374428,"srid":4326},"phone":"0161 485 3135","email":null,"image":null,"website":"http://www.benlloydfuneraldirectors.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":12393}},{"name":"Buckleys Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"402320","branch_id":"42320","url":"/funeralcare/funeral-directors/oldham/OL2-6QF/136-rochdale-road","street_address":"136 Rochdale Road","street_address2":"Royton","street_address3":"","town":"Oldham","county":"Greater Manchester","postcode":"OL2 6QF","position":{"x":-2.124063,"y":53.568275,"srid":4326},"phone":"0161 624 2003","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Tuesday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Wednesday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Thursday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Friday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":12513}},{"name":"Farnworth Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405501","branch_id":"45501","url":"/funeralcare/funeral-directors/bolton/BL4-9HP/175-177-albert-road","street_address":"175-177 Albert Road","street_address2":"Farnworth","street_address3":"","town":"Bolton","county":"Greater Manchester","postcode":"BL4 9HP","position":{"x":-2.399606,"y":53.544901,"srid":4326},"phone":"01204 573 280","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":12620}},{"name":"Bury Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405461","branch_id":"45461","url":"/funeralcare/funeral-directors/bury/BL9-0EX/22-silver-street","street_address":"22 Silver Street","street_address2":"","street_address3":"","town":"Bury","county":"Greater Manchester","postcode":"BL9 0EX","position":{"x":-2.298798,"y":53.592737,"srid":4326},"phone":"0161 764 4177","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":13002}},{"name":"B Johnson Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"402390","branch_id":"42390","url":"/funeralcare/funeral-directors/manchester/M44-5XH/b-johnson-funeralcare/169-liverpool-road","street_address":"169 Liverpool Road","street_address2":"Cadishead","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M44 5XH","position":{"x":-2.437935,"y":53.425082,"srid":4326},"phone":"0161 775 2173","email":null,"image":null,"website":"http://www.johnsonfuneralservices.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 4pm","type":"hours","opens":"09:00","closes":"16:00"},{"name":"Tuesday","label":"9am to 4pm","type":"hours","opens":"09:00","closes":"16:00"},{"name":"Wednesday","label":"9am to 4pm","type":"hours","opens":"09:00","closes":"16:00"},{"name":"Thursday","label":"9am to 4pm","type":"hours","opens":"09:00","closes":"16:00"},{"name":"Friday","label":"9am to 4pm","type":"hours","opens":"09:00","closes":"16:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":14373}},{"name":"Handforth Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405797","branch_id":"45797","url":"/funeralcare/funeral-directors/handforth/SK9-3ER/117-wilmslow-road","street_address":"117 Wilmslow Road","street_address2":"","street_address3":"","town":"Handforth","county":"Cheshire","postcode":"SK9 3ER","position":{"x":-2.215493,"y":53.348897,"srid":4326},"phone":"01625 532 878","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":14780}},{"name":"Hardman & McManus Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"402370","branch_id":"42370","url":"/funeralcare/funeral-directors/bolton/BL2-6HP/hardman-and-mcmanus-funeralcare/687-bury-road","street_address":"687 Bury Road","street_address2":"","street_address3":"","town":"Bolton","county":"Greater Manchester","postcode":"BL2 6HP","position":{"x":-2.39017,"y":53.581342,"srid":4326},"phone":"01204 526 464","email":null,"image":null,"website":"http://www.HardmanAndMcmanus.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":14861}},{"name":"Cutgate Funeralcare (Inc. Owen Devaney & Son)","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405886","branch_id":"45886","url":"/funeralcare/funeral-directors/rochdale/OL11-5AQ/9-10-cutgate-precinct","street_address":"9 &10 Cutgate Precinct","street_address2":"Edenfield Rd","street_address3":"","town":"Rochdale","county":"Greater Manchester","postcode":"OL11 5AQ","position":{"x":-2.189978,"y":53.61395,"srid":4326},"phone":"01706 643215","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":15223}},{"name":"Rochdale Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405752","branch_id":"45752","url":"/funeralcare/funeral-directors/rochdale/OL11-4JG/95-manchester-road","street_address":"95 Manchester Road","street_address2":"","street_address3":"","town":"Rochdale","county":"Greater Manchester","postcode":"OL11 4JG","position":{"x":-2.164574,"y":53.61056,"srid":4326},"phone":"01706 653 622","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":15339}},{"name":"Abbey Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"401280","branch_id":"41280","url":"/funeralcare/funeral-directors/manchester/M29-8JE/abbey-funeralcare/40-elliott-street","street_address":"40 Elliott Street","street_address2":"Tyldesley","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M29 8JE","position":{"x":-2.4747,"y":53.5131,"srid":4326},"phone":"01942 891 331","email":null,"image":null,"website":"http://www.abbeyfuneralservices.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":15810}},{"name":"Co-op Funeralcare, Poynton","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"401241","branch_id":"41241","url":"/funeralcare/funeral-directors/poynton/SK12-1RE/68-park-lane","street_address":"68 Park Lane","street_address2":"","street_address3":"","town":"Poynton","county":"Cheshire","postcode":"SK12 1RE","position":{"x":-2.119117,"y":53.348656,"srid":4326},"phone":"01625 872 717","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 2pm","type":"hours","opens":"09:00","closes":"14:00"},{"name":"Tuesday","label":"9am to 2pm","type":"hours","opens":"09:00","closes":"14:00"},{"name":"Wednesday","label":"9am to 2pm","type":"hours","opens":"09:00","closes":"14:00"},{"name":"Thursday","label":"9am to 2pm","type":"hours","opens":"09:00","closes":"14:00"},{"name":"Friday","label":"9am to 2pm","type":"hours","opens":"09:00","closes":"14:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":16834}},{"name":"Co-op Funeralcare, High Lane","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405207","branch_id":"45207","url":"/funeralcare/funeral-directors/stockport/SK6-8BH/48-50-buxton-road","street_address":"48-50 Buxton Road","street_address2":"High Lane","street_address3":"","town":"Stockport","county":"Greater Manchester","postcode":"SK6 8BH","position":{"x":-2.074844,"y":53.364641,"srid":4326},"phone":"01663 766 806","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":17065}},{"name":"Relphs Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"403720","branch_id":"43720","url":"/funeralcare/funeral-directors/bolton/BL1-8DW/relphs-funeralcare/arden-house","street_address":"Arden House","street_address2":"116/122 Blackburn Road","street_address3":"","town":"Bolton","county":"Greater Manchester","postcode":"BL1 8DW","position":{"x":-2.430642,"y":53.590322,"srid":4326},"phone":"01204 523 488","email":null,"image":null,"website":"http://www.relphsfuneralservice.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":17431}},{"name":"Shaws Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"404110","branch_id":"44110","url":"/funeralcare/funeral-directors/bolton/BL1-4BD/shaws-funeralcare/the-old-parsonage","street_address":"The Old Parsonage","street_address2":"20 Park Street","street_address3":"","town":"Bolton","county":"Greater Manchester","postcode":"BL1 4BD","position":{"x":-2.443954,"y":53.581891,"srid":4326},"phone":"01204 526 218","email":null,"image":null,"website":"http://www.ShawandSonFuneralDirectors.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":17455}},{"name":"Abbey Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"401290","branch_id":"41290","url":"/funeralcare/funeral-directors/manchester/M46-0DF/abbey-funeralcare/139-market-street","street_address":"139 Market Street","street_address2":"Atherton","street_address3":"","town":"Manchester","county":"Greater Manchester","postcode":"M46 0DF","position":{"x":-2.496949,"y":53.523568,"srid":4326},"phone":"01942 886 776","email":null,"image":null,"website":"http://www.abbeyfuneralservices.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":17528}},{"name":"Abbey Funeralcare (inc. inc. L. Heyes)","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"406740","branch_id":"46740","url":"/funeralcare/funeral-directors/leigh/WN7-2DB/abbey-funeralcare-inc-inc-l-heyes/94-chapel-street","street_address":"94 Chapel Street","street_address2":"","street_address3":"","town":"Leigh","county":"Greater Manchester","postcode":"WN7 2DB","position":{"x":-2.507157,"y":53.494607,"srid":4326},"phone":"01942 261 936","email":null,"image":null,"website":"http://www.abbeyfuneralservices.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":17619}},{"name":"Holcombe Brook Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405850","branch_id":"45850","url":"/funeralcare/funeral-directors/bury/BL0-9SH/unit-2-holcombe-brook","street_address":"Unit 2, Holcombe Brook","street_address2":"Longsight Road","street_address3":"","town":"Bury","county":"Greater Manchester","postcode":"BL0 9SH","position":{"x":-2.334709,"y":53.632415,"srid":4326},"phone":"01204 887209","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":17941}},{"name":"Bolton Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405441","branch_id":"45441","url":"/funeralcare/funeral-directors/bolton/BL1-8NZ/crompton-way","street_address":"Crompton Way","street_address2":"","street_address3":"","town":"Bolton","county":"Greater Manchester","postcode":"BL1 8NZ","position":{"x":-2.429588,"y":53.600711,"srid":4326},"phone":"01204 307 151","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":18210}},{"name":"Pennington Funeralcare (Inc. Paul Dainton)","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"406660","branch_id":"46660","url":"/funeralcare/funeral-directors/leigh/WN7-4HW/church-view-76-st-helens-road","street_address":"Church View, 76 St Helens Road","street_address2":"Pennington","street_address3":"","town":"Leigh","county":"Greater Manchester","postcode":"WN7 4HW","position":{"x":-2.522027,"y":53.491199,"srid":4326},"phone":"01942 269 555","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":18576}},{"name":"Kilpatricks Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"402420","branch_id":"42420","url":"/funeralcare/funeral-directors/littleborough/OL16-2SQ/kilpatricks-funeralcare/634-halifax-road","street_address":"634 Halifax Road","street_address2":"","street_address3":"","town":"Littleborough","county":"Greater Manchester","postcode":"OL16 2SQ","position":{"x":-2.122153,"y":53.637177,"srid":4326},"phone":"01706 374 461","email":null,"image":null,"website":"http://www.kilpatricksfuneralservice.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Tuesday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Wednesday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Thursday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Friday","label":"9am to 4:30pm","type":"hours","opens":"09:00","closes":"16:30"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":19145}},{"name":"Glossop Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"401050","branch_id":"41050","url":"/funeralcare/funeral-directors/glossop/SK13-7DD/16-howard-street","street_address":"16 Howard Street","street_address2":"","street_address3":"","town":"Glossop","county":"Derbyshire","postcode":"SK13 7DD","position":{"x":-1.949283,"y":53.444805,"srid":4326},"phone":"01457 852 059","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":19882}},{"name":"Cheshires Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"406662","branch_id":"46662","url":"/funeralcare/funeral-directors/warrington/WA2-7SQ/cheshires-funeralcare/cheshire-funeral-services","street_address":"Cheshire Funeral Services","street_address2":"57 Gorsey Lane","street_address3":"","town":"Warrington","county":"Cheshire","postcode":"WA2 7SQ","position":{"x":-2.57565,"y":53.399525,"srid":4326},"phone":"01925 571 048","email":null,"image":null,"website":"http://www.cheshirefuneralservices.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":23896}},{"name":"Co-op Funeralcare, Broken Cross","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405676","branch_id":"45676","url":"/funeralcare/funeral-directors/macclesfield/SK11-8TZ/124-broken-cross","street_address":"124 Broken Cross","street_address2":"","street_address3":"","town":"Macclesfield","county":"Cheshire","postcode":"SK11 8TZ","position":{"x":-2.160369,"y":53.259328,"srid":4326},"phone":"01625 425284","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":25235}},{"name":"Stockton Heath Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405611","branch_id":"45611","url":"/funeralcare/funeral-directors/stockton-heath/WA4-6SG/63-london-road","street_address":"63 London Road","street_address2":"","street_address3":"","town":"Stockton Heath","county":"Cheshire","postcode":"WA4 6SG","position":{"x":-2.581488,"y":53.371434,"srid":4326},"phone":"01925 262 000","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":25592}},{"name":"Co-op Funeralcare, Warrington","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405421","branch_id":"45421","url":"/funeralcare/funeral-directors/warrington/WA2-7LW/bewsey-road","street_address":"Bewsey Road","street_address2":"","street_address3":"","town":"Warrington","county":"Cheshire","postcode":"WA2 7LW","position":{"x":-2.598806,"y":53.393101,"srid":4326},"phone":"01925 445 555","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":25592}},{"name":"Co-op Funeralcare, Newton-Le-Willows","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405381","branch_id":"45381","url":"/funeralcare/funeral-directors/newton-le-willows/WA12-9UA/earls-house","street_address":"Earls House","street_address2":"238 Crow Lane East","street_address3":"","town":"Newton-Le-Willows","county":"Merseyside","postcode":"WA12 9UA","position":{"x":-2.633769,"y":53.456443,"srid":4326},"phone":"01925 226 257","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":26105}},{"name":"Co-op Funeralcare, Macclesfield","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"404877","branch_id":"44877","url":"/funeralcare/funeral-directors/macclesfield/SK11-8BR/25-high-street","street_address":"25 High Street","street_address2":"","street_address3":"","town":"Macclesfield","county":"Cheshire","postcode":"SK11 8BR","position":{"x":-2.123237,"y":53.253096,"srid":4326},"phone":"01625 422583","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":26544}},{"name":"Co-op Funeralcare Wigan","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"404060","branch_id":"44060","url":"/funeralcare/funeral-directors/wigan/WN6-7BP/co-op-funeralcare-wigan/linley-house","street_address":"Linley House","street_address2":"177 Gidlow Lane","street_address3":"","town":"Wigan","county":"Greater Manchester","postcode":"WN6 7BP","position":{"x":-2.643049,"y":53.55247,"srid":4326},"phone":"01942 825 554","email":null,"image":null,"website":"http://www.mcguirefuneralservice.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":27724}},{"name":"Warburtons Funeralcare","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"409944","branch_id":"49944","url":"/funeralcare/funeral-directors/todmorden/OL14-8AL/warburtons-funeralcare/the-old-school-chapel","street_address":"The Old School Chapel","street_address2":"Broadstone Street","street_address3":"","town":"Todmorden","county":"West Yorkshire","postcode":"OL14 8AL","position":{"x":-2.084897,"y":53.717374,"srid":4326},"phone":"01706 813 329","email":null,"image":null,"website":"http://www.warburtonfuneraldirectors.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":28319}},{"name":"Co-op Funeralcare, Darwen","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"404871","branch_id":"44871","url":"/funeralcare/funeral-directors/darwen/BB3-1PX/234-duckworth-street","street_address":"234 Duckworth Street","street_address2":"","street_address3":"","town":"Darwen","county":"Lancashire","postcode":"BB3 1PX","position":{"x":-2.46948,"y":53.69738,"srid":4326},"phone":"01254 701 145","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":28395}},{"name":"Co-op Funeralcare, Pemberton","location_type":"Funerals","society":"The Co-operative Group","public":true,"hubnumber":null,"anacode":null,"cedar":"405651","branch_id":"45651","url":"/funeralcare/funeral-directors/wigan/WN5-8AX/788-790-ormskirk-road","street_address":"788-790 Ormskirk Road","street_address2":"Pemberton","street_address3":"","town":"Wigan","county":"Greater Manchester","postcode":"WN5 8AX","position":{"x":-2.682681,"y":53.53624,"srid":4326},"phone":"01942 213 374","email":null,"image":null,"website":"http://www.co-operativefuneralcare.co.uk","facilities":[],"open_status":"Closed","open_status_label":"Opening tomorrow at 9am","opening_hours":[{"name":"Sunday","label":"By appointment","type":"by_appointment","opens":null,"closes":null},{"name":"Monday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Tuesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Wednesday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Thursday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Friday","label":"9am to 5pm","type":"hours","opens":"09:00","closes":"17:00"},{"name":"Saturday","label":"By appointment","type":"by_appointment","opens":null,"closes":null}],"distance":{"m":29830}}]'), Zu = {
  count: Ku,
  next: ju,
  previous: qu,
  results: Yu
}, Xu = async (e, t, n, o = !1) => {
  if (o)
    return Zu;
  const { finderConfig: a } = ke(he());
  if (!a.value.apiUrl)
    throw new Error(
      "Branch finder API URL is not configured. Provide finderConfig.apiUrl before searching."
    );
  const s = new URLSearchParams({
    location: `${e.toString()},${t.toString()}`,
    distance: a.value.searchRadius.toString(),
    min_results: a.value.minResults.toString(),
    page_size: a.value.resultsPerPage.toString(),
    page: n.toString(),
    format: "json"
  });
  if (!es.some((r) => a.value.apiUrl.startsWith(r)))
    return null;
  try {
    const r = await fetch(`${a.value.apiUrl}?${s}`, {
      method: "GET"
    });
    if (!r.ok)
      throw new Error(`HTTP error! status: ${r.status}`);
    return await r.json();
  } catch (r) {
    throw new Error(`Failed to fetch funeral homes: ${r}`);
  }
}, Ju = (e) => ({
  name: e.name,
  cedar: e.cedar,
  distanceInMeters: e.distance.m,
  distanceInMiles: (e.distance.m / 1609.344).toFixed(1),
  openStatusLabel: e.open_status_label,
  schedule: e.opening_hours,
  phone: e.phone,
  postcode: e.postcode,
  streetAddress: e.street_address,
  streetAddress2: e.street_address2,
  streetAddress3: e.street_address3,
  town: e.town,
  url: e.url,
  latitude: e.position.y,
  longitude: e.position.x
}), he = /* @__PURE__ */ Mn("branchFinder", () => {
  const e = B({
    apiUrl: "https://development.api.fnc-dev.digital.coop.co.uk/branches",
    searchRadius: 1e4,
    minResults: 12,
    resultsPerPage: 12,
    maxPages: 2,
    minCharsForAutocomplete: 4,
    minCharsForAutocompleteOnSubmit: 3,
    minCharsForSearch: 4,
    showPhoneNumber: !0,
    showOpenStatus: !1,
    goToBranchPage: !1,
    resultsDirection: "row",
    CBSNumber: "0808 303 2076"
  }), t = B({
    count: 0,
    currentPage: 1,
    totalPages: 0
  }), n = B(""), o = B([]), a = B(null), s = B(null), r = B(null), l = (d) => {
    e.value = { ...e.value, ...d };
  }, i = async (d, c = !1) => {
    try {
      const y = await Xu(
        d.lat,
        d.lng,
        t.value.currentPage,
        c
      );
      if (!y)
        return null;
      const A = y.results.map((k) => Ju(k));
      return t.value.count = y.count, t.value.totalPages = Math.ceil(y.count / e.value.resultsPerPage), g(A), A;
    } catch {
      return null;
    }
  }, u = (d) => {
    n.value = d;
  }, g = (d) => {
    if (t.value.currentPage > 1) {
      o.value = [...o.value, ...d];
      return;
    }
    o.value = [...d];
  }, _ = (d) => {
    a.value = d;
  }, w = (d, c = null) => {
    s.value = d, r.value = d ? c ?? "address" : null;
  }, p = () => {
    a.value = null;
  }, f = () => {
    o.value = [];
  }, h = () => {
    t.value = {
      count: 0,
      currentPage: 1,
      totalPages: 0
    };
  };
  return {
    finderConfig: e,
    pagination: t,
    searchTerm: n,
    branches: o,
    selectedBranch: a,
    placeCoordinates: s,
    placeCoordinatesSource: r,
    setFinderConfig: l,
    updateSearch: u,
    updateBranches: g,
    updateSelectedBranch: _,
    updatePlaceCoordinates: w,
    fetchHomes: i,
    clearSelectedBranch: p,
    clearBranches: f,
    resetPagination: h,
    resetSearch: () => {
      n.value = "", o.value = [], a.value = null, s.value = null, r.value = null, h();
    }
  };
}), Qu = () => {
  const { updateSearch: e } = he(), t = B([]), n = B(null), o = B(-1);
  return {
    predictions: t,
    selectedPrediction: n,
    highlightPrediction: o,
    updatePredictions: (r) => {
      t.value = r;
    },
    selectPrediction: (r) => {
      e(r?.description ?? ""), n.value = r ? { ...r } : null, o.value = -1;
    }
  };
};
var J = /* @__PURE__ */ ((e) => (e.SHORT_SEARCH_TERM = "Please enter at least 4 characters", e.NO_TERM = "Enter a town or postcode or use your current location", e.NO_LOCATION = "Unable to find your location", e.NO_BROWSER_SUPPORT = "Your browser doesn't support find my location", e.BAD_ADDRESS = "We cannot find any funeral homes near this location", e.GENERAL_ERROR = "An error occurred while searching for locations", e.NO_PERMISSIONS = "We cannot access your current location", e))(J || {});
const ec = async (e) => {
  if (!navigator.geolocation)
    throw new Error(J.NO_BROWSER_SUPPORT);
  if ((await navigator.permissions.query({ name: "geolocation" })).state === "denied")
    throw new Error(J.NO_PERMISSIONS);
  const n = await new Promise((r, l) => {
    navigator.geolocation.getCurrentPosition(r, l);
  }), o = {
    lat: n.coords.latitude,
    lng: n.coords.longitude
  }, s = (await e.geocoder.geocode({ location: o })).results;
  if (!s || s.length === 0)
    throw new Error(J.NO_LOCATION);
  return s[0];
}, tc = async (e, t) => {
  const n = t.trim();
  if (!n)
    throw new Error(J.NO_TERM);
  const o = new google.maps.LatLngBounds({ lat: 48, lng: -10 }, { lat: 61, lng: 3 }), a = await e.geocoder.geocode({
    address: n,
    bounds: o,
    componentRestrictions: { country: "GB" }
  }), [s] = a.results;
  if (!s)
    throw new Error(J.BAD_ADDRESS);
  if (!s.geometry?.location)
    throw new Error(J.GENERAL_ERROR);
  return s;
}, Pt = (e) => e.toLowerCase().replace(/[^a-z0-9\s-]/g, "").trim().replace(/\s+/g, "-"), nc = (e) => {
  const t = Number.isInteger(e) ? 0 : 2;
  return {
    minimumFractionDigits: t,
    maximumFractionDigits: t
  };
}, oc = (e, t = !0) => {
  const o = e.toLocaleString(
    "en-GB",
    nc(e)
  );
  return `${t ? "£" : ""}${o}`;
}, ac = (e) => e.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), sc = async (e) => {
  const t = e.trim().toLowerCase(), o = new TextEncoder().encode(t), a = await crypto.subtle.digest("SHA-256", o);
  return Array.from(new Uint8Array(a)).map((l) => l.toString(16).padStart(2, "0")).join("");
}, pn = (e) => {
  if (!e) return "";
  const [t, n] = e.split(":").map(Number), o = /* @__PURE__ */ new Date();
  return o.setHours(t, n, 0, 0), o.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: n === 0 ? void 0 : "2-digit",
    hour12: !0
  }).toLowerCase().replace(/\s+/g, "");
}, T0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addCommaToNumber: ac,
  createSlug: Pt,
  formatPrice: oc,
  formatTime: pn,
  toSha256: sc
}, Symbol.toStringTag, { value: "Module" })), Fn = (e) => {
  const t = $(() => e.value.url || ""), n = $(() => {
    const s = Pt(e.value.streetAddress), r = Pt(e.value.postcode), l = Pt(e.value.town);
    return `https://www.google.com/maps/dir/?api=1&destination=${s},${l},${r}`;
  }), o = $(() => !e.value || !e.value.streetAddress || !e.value.town || !e.value.postcode ? "" : `${e.value.streetAddress}, ${e.value.town}, ${e.value.postcode}`), a = $(() => {
    const s = /* @__PURE__ */ new Date(), r = s.getDay(), l = e.value.schedule[r];
    if (l.type === "by_appointment")
      return {
        status: "closed",
        label: "Available 24 hours a day."
      };
    const [i, u] = l.opens ? l.opens.split(":").map(Number) : [0, 0], [g, _] = l.closes ? l.closes.split(":").map(Number) : [0, 0], w = new Date(s);
    w.setHours(i, u, 0, 0);
    const p = new Date(s);
    return p.setHours(g, _, 0, 0), s < w ? {
      status: "closed",
      label: "Available 24 hours a day."
    } : s >= w && s < p ? (p.getTime() - s.getTime()) / 6e4 <= 60 ? {
      status: "closing-soon",
      label: `Open now, closing at ${pn(l.closes)}. Available 24 hours a day.`
    } : {
      status: "open",
      label: `Open until ${pn(l.closes)}`
    } : {
      status: "closed",
      label: "Available 24 hours a day."
    };
  });
  return {
    createURLBranchPage: t,
    createDirectionsGoogleURL: n,
    getFullAddress: o,
    getStatus: a
  };
}, $t = (e) => {
  const t = B(window.innerWidth < e), n = () => {
    t.value = window.innerWidth < e;
  };
  return et(() => {
    window.addEventListener("resize", n);
  }), hn(() => {
    window.removeEventListener("resize", n);
  }), t;
};
var rc = /* @__PURE__ */ ((e) => (e[e.SUNDAY = 0] = "SUNDAY", e[e.MONDAY = 1] = "MONDAY", e[e.TUESDAY = 2] = "TUESDAY", e[e.WEDNESDAY = 3] = "WEDNESDAY", e[e.THURSDAY = 4] = "THURSDAY", e[e.FRIDAY = 5] = "FRIDAY", e[e.SATURDAY = 6] = "SATURDAY", e))(rc || {}), yt = /* @__PURE__ */ ((e) => (e[e.XXLARGE = 1440] = "XXLARGE", e[e.XLARGE = 1300] = "XLARGE", e[e.LARGE = 1024] = "LARGE", e[e.MEDIUM = 768] = "MEDIUM", e[e.SMALL = 600] = "SMALL", e[e.XSMALL = 414] = "XSMALL", e[e.XXSMALL = 320] = "XXSMALL", e))(yt || {});
const lc = {
  key: 0,
  class: "fnc-info-window"
}, ic = { class: "fnc-info-window__title" }, uc = { key: 0 }, cc = { class: "fnc-info-window__links" }, dc = ["href"], pc = ["href"], mc = ["href"], fc = /* @__PURE__ */ W({
  __name: "GoogleInfoWindow",
  props: {
    home: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: ""
    }
  },
  emits: ["trackingMapEvent"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = xe(n, "home"), s = he(), { createDirectionsGoogleURL: r, createURLBranchPage: l, getFullAddress: i } = Fn(a), { selectedBranch: u } = ke(s), { clearSelectedBranch: g } = s, _ = $t(yt.XLARGE), w = B(!1);
    let p;
    et(() => {
      p = (h) => {
        h.key === "Escape" && _ && f();
      }, window.addEventListener("keydown", p);
    }), hn(() => {
      window.removeEventListener("keydown", p);
    });
    const f = () => {
      w.value = !0, g(), o("trackingMapEvent", "close_info_window");
    };
    return Y(
      () => u.value,
      () => {
        w.value = !1;
      },
      { deep: !0 }
    ), (h, m) => w.value ? P("", !0) : (b(), v("div", lc, [
      C("div", {
        class: "fnc-info-window__close-button",
        "aria-label": "Close info window",
        role: "button",
        tabindex: "0",
        onClick: f,
        onKeydown: $e(f, ["escape"])
      }, [
        V(ee, {
          name: "close",
          size: "12px",
          fill: "#282828",
          stroke: "#282828",
          "stroke-width": "2"
        })
      ], 32),
      C("p", ic, L(e.home.name || e.title), 1),
      O(i) ? (b(), v("p", uc, L(O(i)), 1)) : P("", !0),
      C("div", cc, [
        O(l) ? (b(), v("a", {
          key: 0,
          class: "fnc-info-window__link",
          href: O(l),
          target: "_blank",
          rel: "noopener noreferrer",
          onClick: m[0] || (m[0] = (d) => o("trackingMapEvent", "view_funeral_home_details"))
        }, [
          V(ee, {
            name: "information",
            size: "16px",
            fill: "#00729A"
          }),
          m[3] || (m[3] = C("span", null, "View funeral home details", -1))
        ], 8, dc)) : P("", !0),
        e.home.phone ? (b(), v("a", {
          key: 1,
          class: "fnc-info-window__link",
          href: `tel:${e.home.phone}`,
          onClick: m[1] || (m[1] = (d) => o("trackingMapEvent", "call"))
        }, [
          V(ee, {
            name: "phone",
            size: "16px",
            fill: "#00729A"
          }),
          C("span", null, "Call " + L(e.home.phone), 1)
        ], 8, pc)) : P("", !0),
        O(r) ? (b(), v("a", {
          key: 2,
          class: "fnc-info-window__link",
          href: O(r),
          target: "_blank",
          rel: "noopener noreferrer",
          onClick: m[2] || (m[2] = (d) => o("trackingMapEvent", "get_directions"))
        }, [
          V(ee, {
            name: "directions",
            size: "20px",
            fill: "#00729A"
          }),
          m[4] || (m[4] = C("span", null, "Get directions", -1))
        ], 8, mc)) : P("", !0)
      ])
    ]));
  }
}), Bn = /* @__PURE__ */ te(fc, [["__scopeId", "data-v-b704c6e8"]]), hc = {
  key: 0,
  class: "marker-title"
}, yc = /* @__PURE__ */ W({
  __name: "GoogleMarker",
  props: {
    title: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "coop-location"
    },
    isSelected: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => (b(), v("div", {
      class: q({ "is-selected": e.isSelected })
    }, [
      V(ee, {
        name: e.icon,
        class: "google-marker"
      }, null, 8, ["name"]),
      e.title ? (b(), v("span", hc, L(e.title), 1)) : P("", !0)
    ], 2));
  }
}), _c = /* @__PURE__ */ te(yc, [["__scopeId", "data-v-e6f0b450"]]), Vt = /* @__PURE__ */ Mn("googleMapAPI", () => {
  const e = B(!1), t = B(null);
  return { isScriptLoaded: e, googleMapsApiKey: t, setIsScriptLoaded: (a) => {
    e.value = a;
  }, setGoogleMapsApiKey: (a) => {
    t.value = a;
  } };
}), Dn = (e, t = {}, n = {}) => {
  const o = document.createElement("div"), a = Object.fromEntries(
    Object.entries(n).map(([r, l]) => [
      "on" + r.charAt(0).toUpperCase() + r.slice(1),
      l
    ])
  );
  return hs(e, { ...t, ...a }).mount(o), o;
}, ts = async (e) => {
  await new Promise((t, n) => {
    let o = document.querySelector('script[src="' + e + '"]'), a = !1;
    if (o || (o = document.createElement("script"), o.type = "text/javascript", o.async = !0, o.defer = !0, o.src = e, a = !0), o && o.hasAttribute("data-loaded")) {
      t(o);
      return;
    }
    o.addEventListener("error", n), o.addEventListener("abort", n), o.addEventListener("load", () => {
      o.setAttribute("data-loaded", "true"), t(o);
    }), a && document.head.appendChild(o);
  });
}, bc = (e, t, n) => {
  let o = !1, a = !1;
  return t && (o = e.scrollHeight > e.clientHeight), n && (a = e.scrollWidth > e.clientWidth), t && o || n && a;
}, O0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  checkIfHasOverflow: bc,
  handleScript: ts,
  mountVueComponent: Dn
}, Symbol.toStringTag, { value: "Module" })), ns = async (e) => {
  const { isScriptLoaded: t, setIsScriptLoaded: n } = Vt();
  if (t) return;
  const o = `https://maps.googleapis.com/maps/api/js?key=${e}`;
  await ts(o), n(!0);
}, os = (e, t = !1, n) => Dn(_c, {
  title: e,
  icon: n ?? (e ? "marker" : "coop-location"),
  isSelected: t
}), gc = (e, t = {}) => {
  const n = e.home ? { home: e.home } : { title: e.title };
  return Dn(Bn, n, t);
}, vc = async (e, t, n) => {
  const o = {
    placeId: e,
    sessionToken: n
  };
  return await new Promise((s, r) => {
    t.details.getDetails(o, (l, i) => {
      i === google.maps.places.PlacesServiceStatus.OK && l ? s(l) : r(new Error(J.GENERAL_ERROR));
    });
  });
}, wc = async (e, t) => {
  await ns(e);
  const { AutocompleteSessionToken: n, AutocompleteService: o, PlacesService: a } = await google.maps.importLibrary("places"), { Geocoder: s } = await google.maps.importLibrary(
    "geocoding"
  );
  return {
    sessionToken: new n(),
    prediction: new o(),
    details: new a(t),
    geocoder: new s()
  };
}, qo = async (e, t, n = "", o) => {
  const { finderConfig: a } = ke(he()), s = o ?? a.value.minCharsForAutocomplete, r = {
    input: e,
    sessionToken: n,
    componentRestrictions: { country: "GB" },
    types: ["locality", "sublocality", "neighborhood", "postal_town", "postal_code"],
    fields: ["place_id", "structured_formatting", "description"]
  };
  if (!t)
    throw new Error(J.GENERAL_ERROR);
  return e.length < s ? [] : await new Promise(
    (i, u) => {
      t.prediction.getPlacePredictions(r, (g, _) => {
        _ === google.maps.places.PlacesServiceStatus.OK && g ? i(g) : u(new Error(J.BAD_ADDRESS));
      });
    }
  );
}, Ec = async (e, t, n) => {
  const { updatePlaceCoordinates: o } = he(), a = await vc(
    e,
    t,
    n
  );
  if (!a || !a.geometry)
    throw new Error(J.GENERAL_ERROR);
  if (a.geometry && a.geometry.location)
    o(a.geometry.location.toJSON(), "address");
  else
    throw new Error(J.GENERAL_ERROR);
}, Cc = { class: "fnc-finder__wrapper" }, Sc = { key: 0 }, Ac = {
  key: 1,
  class: "coop-form__error"
}, kc = {
  role: "status",
  class: "fnc-finder__wrapper__accessibility-text"
}, Tc = { class: "fnc-finder__inner" }, Oc = ["innerHTML"], Pc = { class: "fnc-finder__form" }, Mc = ["placeholder", "aria-label"], Fc = ["aria-label"], Bc = ["aria-label"], Dc = ["disabled"], Lc = /* @__PURE__ */ W({
  __name: "BranchFinderInput",
  props: {
    title: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: "Enter a location"
    },
    placeholder: {
      type: String,
      default: ""
    },
    searchLabel: {
      type: String,
      default: "Find a funeral home"
    },
    resetLabel: {
      type: String,
      default: "Clear search"
    },
    location: {
      type: String,
      default: ""
    },
    getDummy: {
      type: Boolean,
      default: !1
    },
    showCurrentLocation: {
      type: Boolean,
      default: !0
    },
    showResetButton: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["trackingSearchEvent"],
  setup(e, { expose: t, emit: n }) {
    const o = e, a = n, {
      predictions: s,
      highlightPrediction: r,
      selectedPrediction: l,
      updatePredictions: i,
      selectPrediction: u
    } = Qu(), { errorMessage: g, updateErrorMessage: _, hideErrorMessage: w } = zu(), { searchTerm: p, pagination: f, placeCoordinates: h, finderConfig: m } = ke(he()), {
      updateSearch: d,
      resetSearch: c,
      updatePlaceCoordinates: y,
      fetchHomes: A,
      clearBranches: k,
      resetPagination: R
    } = he(), { googleMapsApiKey: T } = ke(Vt());
    let K, Z;
    const M = B(""), S = B(!1), U = Ne("autocomplete-input"), x = B(!1);
    let G = null;
    ft(() => {
      o.location && o.location.trim() !== "" && d(o.location);
    }), et(async () => {
      if (!T.value) throw new Error("Google Maps API key is required");
      G = (async () => {
        U.value && (K = await wc(
          T.value,
          U.value
        ), Z = K.sessionToken, U.value && U.value.addEventListener("input", () => {
          qo(U.value.value, K, Z).then((I) => {
            i(I);
          }).catch(() => {
            i([]);
          });
        }));
      })();
    });
    const N = async (I) => {
      w();
      const j = p.value.trim();
      if (!j) {
        _(J.NO_TERM);
        return;
      }
      if (j !== p.value && (p.value = j), j.length < m.value.minCharsForAutocompleteOnSubmit) {
        _(J.SHORT_SEARCH_TERM);
        return;
      }
      if (j.length < m.value.minCharsForSearch) {
        await ne({
          minCharsOverride: m.value.minCharsForAutocompleteOnSubmit,
          autoSelectFirst: !0
        }) || _(J.BAD_ADDRESS);
        return;
      }
      !I && !s.value.length && await ne({ autoSelectFirst: !1 }), a("trackingSearchEvent", { type: "user", search: j });
      const oe = I ?? s.value[0];
      if (oe) {
        R(), k(), x.value = !1, r.value = -1, u(oe);
        return;
      }
      R(), k(), l.value = null, r.value = -1, i([]), x.value = !1, y(null), await ye({ manual: !0 });
    }, H = (I) => {
      a("trackingSearchEvent", { type: "autocomplete", search: I }), R(), k(), i([]), x.value = !1, r.value = -1, u(I);
    }, D = () => {
      M.value = "", S.value = !1, u(null), i([]), w(), c(), x.value = !1;
    }, ne = async (I = {}) => {
      G && (await G, G = null);
      const { minCharsOverride: j, autoSelectFirst: oe = !0 } = I;
      let Ce = [];
      try {
        Ce = await qo(
          p.value.trim(),
          K,
          Z,
          j
        ), i(Ce);
      } catch {
        Ce = [], i([]);
      }
      return oe && Ce.length ? (u(Ce[0]), i([]), !0) : Ce.length > 0;
    }, X = async (I) => {
      if (!K)
        return _(J.GENERAL_ERROR), !1;
      if (l.value?.place_id)
        try {
          return await Ec(
            l.value.place_id,
            K,
            Z || ""
          ), !0;
        } catch (j) {
          const oe = j instanceof Error ? j.message : J.GENERAL_ERROR;
          return _(oe), !1;
        }
      if (I)
        try {
          const j = await tc(K, p.value);
          if (!j.geometry?.location)
            throw new Error(J.GENERAL_ERROR);
          return y(j.geometry.location.toJSON(), "address"), !0;
        } catch (j) {
          const oe = j instanceof Error ? j.message : J.BAD_ADDRESS;
          return _(oe), !1;
        }
      return _(J.BAD_ADDRESS), !1;
    }, ye = async (I = {}) => {
      const { manual: j = !1 } = I;
      if (G && (await G, G = null), w(), S.value = !0, x.value = !1, !p.value.trim()) {
        _(J.NO_TERM), S.value = !1;
        return;
      }
      if (!K) {
        _(J.GENERAL_ERROR), S.value = !1;
        return;
      }
      if (M.value = "Searching", !h.value && (R(), k(), !await X(j) || !h.value)) {
        S.value = !1;
        return;
      }
      const Ce = await A(
        h.value,
        o.getDummy
      );
      if (!Ce) {
        _(J.GENERAL_ERROR), S.value = !1;
        return;
      }
      if (!Ce.length) {
        _(J.BAD_ADDRESS), S.value = !1;
        return;
      }
      M.value = "Search complete", S.value = !1;
    }, Ee = async () => {
      if (S.value)
        return;
      G && (await G, G = null);
      let I;
      if (S.value = !0, !K) {
        _(J.GENERAL_ERROR), S.value = !1;
        return;
      }
      try {
        I = await ec(K);
      } catch (j) {
        const oe = j instanceof Error ? j.message : J.GENERAL_ERROR;
        _(oe), S.value = !1;
        return;
      }
      p.value = I.formatted_address || "", y(I.geometry.location.toJSON(), "currentLocation"), a("trackingSearchEvent", { type: "currentLocation", search: "" }), R(), k(), ye(), x.value = !1;
    }, pe = (I) => {
      I.key === "ArrowDown" && s.value.length ? (I.preventDefault(), r.value = (r.value + 1) % s.value.length) : I.key === "ArrowUp" && s.value.length ? (I.preventDefault(), r.value = (r.value - 1 + s.value.length) % s.value.length) : I.key === "Enter" ? r.value >= 0 && s.value.length ? (I.preventDefault(), H(s.value[r.value])) : N(s.value[0]) : I.key === "Escape" && (i([]), r.value = -1);
    };
    return Y(
      () => l.value,
      (I) => {
        if (y(null), !I?.place_id) {
          S.value = !1;
          return;
        }
        ye();
      }
    ), Y(
      () => g.value,
      (I) => {
        I !== "" && (S.value = !1, M.value = "", k());
      }
    ), Y(
      () => f.value.currentPage,
      (I, j) => {
        I && I > 1 && j !== I && ye();
      },
      { deep: !0, immediate: !0 }
    ), Y(
      () => p.value,
      (I) => {
        I === "" ? D() : I.length < m.value.minCharsForAutocomplete && (x.value = !1);
      }
    ), Y(
      () => s.value,
      (I) => {
        x.value = I.length > 0;
      }
    ), t({
      reset: D,
      search: ye,
      handleSearchFromSearchTerm: ne
    }), (I, j) => (b(), v("section", Cc, [
      e.title ? (b(), v("h3", Sc, L(e.title), 1)) : P("", !0),
      O(g) ? (b(), v("p", Ac, L(O(g)), 1)) : P("", !0),
      C("p", kc, L(M.value), 1),
      C("div", Tc, [
        e.label ? (b(), v("label", {
          key: 0,
          for: "searchLocation",
          innerHTML: e.label
        }, null, 8, Oc)) : P("", !0),
        C("div", Pc, [
          fe(C("input", {
            id: "searchLocation",
            ref: "autocomplete-input",
            "onUpdate:modelValue": j[0] || (j[0] = (oe) => Ie(p) ? p.value = oe : null),
            class: "coop-form__input fnc-finder__form__input",
            placeholder: e.placeholder,
            "aria-label": e.placeholder,
            type: "text",
            name: "searchLocation",
            autocomplete: "off",
            onKeydown: pe
          }, null, 40, Mc), [
            [fn, O(p)]
          ]),
          x.value ? (b(), z(Hu, {
            key: 0,
            predictions: O(s),
            "highlight-prediction": O(r),
            onSelectPrediction: H
          }, null, 8, ["predictions", "highlight-prediction"])) : P("", !0),
          e.showResetButton && O(p) ? (b(), v("button", {
            key: 1,
            type: "button",
            class: "fnc-finder__form__reset",
            "aria-controls": "searchLocation",
            "aria-label": e.resetLabel,
            onClick: D
          }, [
            V(ee, {
              name: "close",
              size: "20px",
              fill: "#C4C4C4",
              stroke: "#C4C4C4",
              "stroke-width": "1"
            })
          ], 8, Fc)) : P("", !0),
          C("button", {
            type: "button",
            class: q(["coop-btn coop-btn--primary fnc-finder__form__button", {
              "fnc-finder__form__button--loading": S.value
            }]),
            "aria-label": e.searchLabel,
            onClick: j[1] || (j[1] = (oe) => N(O(s)[0]))
          }, [
            V(ee, {
              name: "search",
              size: "28px",
              fill: "#FFFFFF",
              stroke: "#FFFFFF",
              "stroke-width": "1"
            }),
            j[3] || (j[3] = C("span", { class: "coop-u-visuallyhidden" }, "Search", -1))
          ], 10, Bc)
        ]),
        e.showCurrentLocation ? (b(), v("button", {
          key: 1,
          class: "fnc-finder__form__user-location",
          type: "button",
          disabled: S.value,
          onClick: j[2] || (j[2] = (oe) => Ee())
        }, [
          V(ee, {
            name: "current-location",
            fill: "currentColor"
          }),
          V(Nt, {
            class: "fnc-finder__form__user-location__button",
            label: "Use my current location"
          })
        ], 8, Dc)) : P("", !0)
      ])
    ]));
  }
}), as = /* @__PURE__ */ te(Lc, [["__scopeId", "data-v-de8ab8a8"]]), le = [];
for (let e = 0; e < 256; ++e)
  le.push((e + 256).toString(16).slice(1));
function Rc(e, t = 0) {
  return (le[e[t + 0]] + le[e[t + 1]] + le[e[t + 2]] + le[e[t + 3]] + "-" + le[e[t + 4]] + le[e[t + 5]] + "-" + le[e[t + 6]] + le[e[t + 7]] + "-" + le[e[t + 8]] + le[e[t + 9]] + "-" + le[e[t + 10]] + le[e[t + 11]] + le[e[t + 12]] + le[e[t + 13]] + le[e[t + 14]] + le[e[t + 15]]).toLowerCase();
}
let jt;
const xc = new Uint8Array(16);
function Ic() {
  if (!jt) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    jt = crypto.getRandomValues.bind(crypto);
  }
  return jt(xc);
}
const Nc = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Yo = { randomUUID: Nc };
function ss(e, t, n) {
  if (Yo.randomUUID && !e)
    return Yo.randomUUID();
  e = e || {};
  const o = e.random ?? e.rng?.() ?? Ic();
  if (o.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, Rc(o);
}
const $c = async (e, t, n, o, a, s) => {
  await ns(a);
  const { Map: r, InfoWindow: l } = await google.maps.importLibrary("maps"), { AdvancedMarkerElement: i } = await google.maps.importLibrary(
    "marker"
  ), { LatLngBounds: u } = await google.maps.importLibrary("core"), g = new r(e, {
    center: { lat: t, lng: n },
    zoom: o,
    mapId: ss()
  });
  return s && g.setOptions(s), {
    map: g,
    window: new l(),
    marker: i,
    bounds: new u()
  };
}, Vc = (e, t, n, o, a, s) => {
  const r = a.window, l = {
    title: e.title || "",
    position: t,
    gmpClickable: o,
    map: a.map
  };
  if (e.variant === "current-location") {
    const u = document.createElement("div");
    u.style.width = "18px", u.style.height = "18px", u.style.borderRadius = "50%", u.style.backgroundColor = "#4285F4", u.style.border = "3px solid #FFFFFF", u.style.boxShadow = "0 2px 6px rgba(0,0,0,0.3)", l.content = u, l.gmpClickable = !1;
  } else if (e.variant === "search-address") {
    const u = new google.maps.marker.PinElement({
      background: "#EA4335",
      borderColor: "#C5221F",
      glyphColor: "#FFFFFF"
    });
    l.content = u.element, l.gmpClickable = !1;
  } else
    l.content = os(
      n ? n.toString() : null,
      !1,
      e.icon
    );
  const i = new a.marker(l);
  return o && (i.addListener("click", () => {
    rs(i, e, r), s(!0);
  }), r.addListener("closeclick", () => {
    s(!1);
  })), {
    marker: i,
    infoWindow: r
  };
}, rs = (e, t, n, o = {}) => {
  n.close();
  const a = gc(t, o);
  n.setContent(a), n.open(e.map, e);
}, gt = (e, t, n, o) => {
  const a = os(t !== null ? t.toString() : null, n, o);
  return e.content = a, e;
}, Uc = {
  ref: "map-ref",
  class: "fnc-google-map"
}, qt = 15, Gc = /* @__PURE__ */ W({
  __name: "GoogleMapComponent",
  props: {
    markers: {
      type: Array,
      default: () => []
    },
    selectedMarker: {
      type: String,
      default: ""
    },
    hoveredMarker: {
      type: String,
      default: ""
    },
    lat: {
      type: Number,
      default: 53.48802
    },
    lng: {
      type: Number,
      default: -2.23748
    },
    zoom: {
      type: Number,
      default: 7
    },
    fitBounds: {
      type: Boolean,
      default: !0
    },
    mapsOptions: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["markerSelected", "trackingMapEvent"],
  setup(e, { emit: t }) {
    const n = e, o = t, { googleMapsApiKey: a } = ke(Vt()), s = $t(yt.XLARGE), r = Ne("map-ref");
    let l = null;
    const i = B([]);
    et(async () => {
      if (!a.value) throw new Error("Google Maps API key is required");
      l = await $c(
        r.value,
        n.lat,
        n.lng,
        n.zoom,
        a.value,
        n.mapsOptions
      ), l.map.setOptions({ maxZoom: qt }), n.markers.length > 0 && w(n.markers), window.addEventListener("keydown", u), window.addEventListener("resize", g);
    }), hn(() => {
      window.removeEventListener("keydown", u), window.removeEventListener("resize", g);
    });
    const u = (m) => {
      m.key === "Escape" && !s && (i.value.find((d) => d.id === n.selectedMarker)?.infoWindow.close(), o("trackingMapEvent", "close_info_window"));
    }, g = () => {
      r && google.maps.event.trigger(r, "resize");
    }, _ = () => {
      i.value.forEach(({ marker: m }) => m.map = null), i.value = [], l && (l.bounds = new google.maps.LatLngBounds(), l.map.setCenter({ lat: n.lat, lng: n.lng }), l.map.setZoom(n.zoom));
    }, w = (m) => {
      if (!l) return;
      _();
      let d = 1;
      if (m.forEach((c) => {
        const y = c.numbered ? d++ : null, A = Vc(
          c,
          { lat: c.lat, lng: c.lng },
          y,
          c.clickable ?? !0,
          l,
          (k) => {
            k ? (p(c.id), o("trackingMapEvent", "select_marker")) : (o("markerSelected", c.id, !1), o("trackingMapEvent", "close_info_window"));
          }
        );
        i.value.push({
          id: c.id,
          number: y,
          marker: A.marker,
          infoWindow: A.infoWindow,
          data: c
        }), l?.bounds.extend({
          lat: c.lat,
          lng: c.lng
        });
      }), n.fitBounds && m.length > 0 && (l?.map.fitBounds(l.bounds), f()), n.hoveredMarker && h(
        i.value.find((c) => c.id === n.hoveredMarker),
        !0
      ), n.selectedMarker) {
        const c = i.value.find(
          (y) => y.id === n.selectedMarker
        );
        c && gt(c.marker, c.number, !0, c.data.icon);
      }
    }, p = (m) => {
      const d = n.selectedMarker === m;
      o("markerSelected", m, !d);
    }, f = () => {
      if (!l) return;
      const m = l.map.getZoom();
      typeof m == "number" && m > qt && l.map.setZoom(qt);
    }, h = (m, d) => {
      m && m.number !== null && m.id !== n.selectedMarker && gt(m.marker, m.number, d, m.data.icon);
    };
    return Y(
      () => n.markers,
      (m) => {
        l && w(m);
      },
      { immediate: !0 }
    ), Y(
      () => n.selectedMarker,
      (m, d) => {
        const c = i.value.find((k) => k.id === m), y = i.value.find((k) => k.id === d), A = c?.data;
        c && A && (s.value || rs(c.marker, A, c.infoWindow, {
          trackingMapEvent: (k) => o("trackingMapEvent", k)
        }), gt(c.marker, c.number, !0, A.icon), l && (l.map.panTo({ lat: A.lat, lng: A.lng }), f())), y && (gt(y.marker, y.number, !1, y.data.icon), c || y.infoWindow.close()), n.hoveredMarker && h(
          i.value.find((k) => k.id === n.hoveredMarker),
          !0
        );
      },
      { immediate: !0 }
    ), Y(
      () => n.hoveredMarker,
      (m, d) => {
        const c = i.value.find((A) => A.id === m), y = i.value.find((A) => A.id === d);
        d !== m && (h(y, !1), h(c, !0));
      }
    ), (m, d) => (b(), v("div", Uc, null, 512));
  }
}), Ln = /* @__PURE__ */ te(Gc, [["__scopeId", "data-v-0e2a363f"]]), Hc = ["aria-pressed", "aria-label"], Wc = { class: "fnc-branch-card__title" }, zc = { class: "fnc-branch-card__distance" }, Kc = { class: "fnc-branch-card__ctas" }, jc = ["href", "aria-label"], qc = ["href", "aria-label"], Yc = /* @__PURE__ */ W({
  __name: "BranchFinderCard",
  props: {
    data: {
      type: Object,
      required: !0
    },
    number: {
      type: Number,
      required: !0
    }
  },
  emits: ["trackingCardEvent"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = xe(n, "data"), { getFullAddress: s, createURLBranchPage: r, createDirectionsGoogleURL: l, getStatus: i } = Fn(a), { updateSelectedBranch: u, clearSelectedBranch: g } = he(), { selectedBranch: _ } = ke(he()), w = $(() => _.value?.cedar === n.data.cedar), p = $(() => `tel:${(n.data.phone ?? "").replace(/\s+/g, "")}`), f = $t(yt.XLARGE), h = (d) => {
      if (_.value?.cedar === d.cedar) {
        g(), o("trackingCardEvent", "deselect_card");
        return;
      }
      u(d), o("trackingCardEvent", "select_card");
    }, m = {
      id: n.data.cedar,
      title: n.data.name,
      lat: n.data.latitude,
      lng: n.data.longitude,
      numbered: !1,
      home: n.data
    };
    return (d, c) => (b(), v("article", {
      class: q(["fnc-branch-card", { "fnc-branch-card--selected": w.value }]),
      role: "button",
      "aria-pressed": w.value,
      "aria-label": `${w.value ? "Deselect" : "Select"} ${e.data.name}`,
      tabindex: "0",
      onClick: c[3] || (c[3] = (y) => h(e.data)),
      onKeydown: [
        c[4] || (c[4] = $e(Pe((y) => h(e.data), ["prevent"]), ["enter"])),
        c[5] || (c[5] = $e(Pe((y) => h(e.data), ["prevent"]), ["space"]))
      ]
    }, [
      C("div", Wc, [
        C("span", null, L(e.number), 1),
        C("p", null, L(e.data.name), 1)
      ]),
      C("p", null, L(O(s)), 1),
      C("div", zc, L(e.data.distanceInMiles) + " miles", 1),
      C("div", {
        class: q(["fnc-branch-card__status", `fnc-branch-card__status--${O(i).status}`])
      }, L(O(i).label), 3),
      C("div", Kc, [
        C("a", {
          class: "coop-btn fnc-btn fnc-btn--primary fnc-btn--teal fnc-btn--full-width-mobile",
          href: p.value,
          "aria-label": e.data.phone ? `Call ${e.data.name} on ${e.data.phone}` : `Call ${e.data.name}`,
          onClick: c[0] || (c[0] = Pe((y) => o("trackingCardEvent", "call"), ["stop"]))
        }, [
          V(ee, {
            name: "phone",
            size: "16",
            color: "#ffffff"
          }),
          C("span", null, L(e.data.phone), 1)
        ], 8, jc),
        C("a", {
          class: "coop-btn fnc-btn fnc-btn--primary fnc-btn--blue-coop fnc-btn--full-width-mobile",
          href: O(r),
          "aria-label": `View details for ${e.data.name}`,
          onClick: c[1] || (c[1] = Pe((y) => o("trackingCardEvent", "view_funeral_home_details"), ["stop"]))
        }, " Funeral home details ", 8, qc)
      ]),
      O(f) && w.value ? (b(), v(se, { key: 0 }, [
        V(Ln, {
          class: "fnc-branch-card__map",
          markers: [m],
          "selected-marker": e.data.cedar,
          lat: e.data.latitude,
          lng: e.data.longitude,
          zoom: 15,
          "fit-bounds": !1
        }, null, 8, ["markers", "selected-marker", "lat", "lng"]),
        V(Nt, {
          class: "fnc-branch-card__directions",
          label: "Get directions",
          link: O(l),
          "new-tab": "",
          rel: "noopener noreferrer",
          onClick: c[2] || (c[2] = Pe((y) => o("trackingCardEvent", "get_directions"), ["stop"]))
        }, {
          icon: He(() => [
            V(ee, {
              name: "directions",
              size: "16",
              fill: "#00729a"
            })
          ]),
          _: 1
        }, 8, ["link"])
      ], 64)) : P("", !0)
    ], 42, Hc));
  }
}), Zc = /* @__PURE__ */ te(Yc, [["__scopeId", "data-v-7819472b"]]), Xc = ["aria-labelledby", "aria-describedby"], Jc = ["id", "checked"], Qc = ["for"], ed = {
  key: 0,
  class: "fnc-branch-card__radio"
}, td = ["id"], nd = ["href"], od = ["id"], ad = { class: "fnc-branch-card__rows" }, sd = ["id"], rd = ["id"], ld = ["id"], id = ["id"], ud = /* @__PURE__ */ W({
  __name: "BranchCardComponent",
  props: {
    clickable: {
      type: Boolean,
      default: !1
    },
    selected: {
      type: Boolean,
      default: !1
    },
    home: {
      type: Object,
      required: !0
    },
    distance: {
      type: String,
      default: ""
    },
    goToBranchPage: {
      type: Boolean,
      default: !1
    },
    showPhoneNumber: {
      type: Boolean,
      default: !0
    },
    showSchedule: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["selectCedar"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = xe(n, "home"), { getFullAddress: s, createURLBranchPage: r } = Fn(a), l = (i) => {
      n.clickable && o("selectCedar", i);
    };
    return (i, u) => (b(), v("button", {
      class: q(["fnc-branch-card", [
        {
          "fnc-branch-card--selected": e.selected
        }
      ]]),
      tabindex: "0",
      for: "funeralHomeRadio",
      "aria-labelledby": `labelledby-${e.home.cedar}`,
      "aria-describedby": `distance-${e.home.cedar} adress-${e.home.cedar} phone-${e.home.cedar}`,
      onClick: u[0] || (u[0] = (g) => l(e.home)),
      onKeypress: u[1] || (u[1] = $e(Pe((g) => l(e.home), ["prevent"]), ["space"]))
    }, [
      e.clickable ? (b(), v("input", {
        key: 0,
        id: `funeralHomeRadio-${e.home.cedar}`,
        type: "radio",
        name: "funeralHomeRadio",
        checked: e.selected
      }, null, 8, Jc)) : P("", !0),
      C("label", {
        for: `funeralHomeRadio-${e.home.cedar}`,
        class: "fnc-branch-card__wrapper"
      }, [
        e.clickable ? (b(), v("span", ed)) : P("", !0),
        C("div", {
          id: `labelledby-${e.home.cedar}`,
          class: "fnc-branch-card__name"
        }, [
          e.goToBranchPage ? (b(), v("a", {
            key: 0,
            href: O(r)
          }, L(e.home.name), 9, nd)) : (b(), v(se, { key: 1 }, [
            Ze(L(e.home.name), 1)
          ], 64))
        ], 8, td),
        e.home.distanceInMiles ? (b(), v("div", {
          key: 1,
          id: `distance-${e.home.cedar}`,
          class: "fnc-branch-card__distance"
        }, [
          C("div", null, [
            V(ee, {
              name: "location",
              fill: "#5a6885",
              size: "16px"
            }),
            C("span", null, L(e.distance) + " mi ", 1)
          ])
        ], 8, od)) : P("", !0)
      ], 8, Qc),
      C("div", ad, [
        C("div", {
          id: `adress-${e.home.cedar}`,
          class: "fnc-branch-card__row"
        }, [
          V(ee, {
            name: "location",
            fill: "#5a6885",
            size: "20px"
          }),
          C("span", null, L(O(s)), 1)
        ], 8, sd),
        e.showPhoneNumber && e.clickable ? (b(), v("div", {
          key: 0,
          id: `phone-${e.home.cedar}`,
          class: "fnc-branch-card__row"
        }, [
          V(ee, {
            name: "phone",
            fill: "#5a6885",
            size: "20px"
          }),
          C("span", null, L(e.home.phone), 1)
        ], 8, rd)) : e.showPhoneNumber && !e.clickable ? (b(), v("a", {
          key: 1,
          id: `phone-${e.home.cedar}`,
          class: "fnc-branch-card__row",
          href: "tel:{{ home.phone }}"
        }, [
          V(ee, {
            name: "phone",
            fill: "#5a6885",
            size: "20px"
          }),
          C("span", null, L(e.home.phone), 1)
        ], 8, ld)) : P("", !0),
        e.showSchedule ? (b(), v("div", {
          key: 2,
          id: `schedule-${e.home.cedar}`,
          class: "fnc-branch-card__row"
        }, [
          V(ee, {
            name: "clock-openinghours",
            fill: "#5a6885",
            size: "20px"
          }),
          C("span", null, L(e.home.openStatusLabel), 1)
        ], 8, id)) : P("", !0)
      ])
    ], 42, Xc));
  }
}), ls = /* @__PURE__ */ te(ud, [["__scopeId", "data-v-3aba9d79"]]), cd = {
  key: 0,
  ref: "branch-results",
  class: "fnc-finder__results"
}, dd = ["aria-checked", "data-cedar"], pd = { key: 0 }, Rn = /* @__PURE__ */ W({
  __name: "BranchFinderList",
  props: {
    isBranchFinderCard: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["trackingCardEvent", "cardHovered"],
  setup(e, { emit: t }) {
    const n = t, { finderConfig: o, pagination: a, branches: s, selectedBranch: r } = ke(he()), { updateSelectedBranch: l, clearSelectedBranch: i } = he(), u = Ne("branch-results"), g = B(r.value?.cedar || ""), _ = B(!1), w = B(s.value.length), p = B(""), f = (y) => {
      if (g.value === y.cedar) {
        g.value = "", i();
        return;
      }
      g.value = y.cedar, l(y);
    }, h = (y) => {
      p.value = y?.cedar || "", n("cardHovered", p.value);
    }, m = $(
      () => a.value.totalPages > 1 && a.value.currentPage < a.value.totalPages && o.value.maxPages > a.value.currentPage
    ), d = () => {
      w.value = s.value.length, _.value = !0, a.value.currentPage += 1, n("trackingCardEvent", "show_more");
    };
    Y(
      () => s.value,
      (y) => {
        y.length === 0 && (g.value = "");
      }
    ), Y(
      () => r.value,
      (y) => {
        y ? (g.value = y.cedar, u.value && Mt(() => {
          if (u.value) {
            const A = u.value.querySelector(
              `[data-cedar="${y.cedar}"]`
            );
            A && A.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "nearest"
            });
          }
        })) : g.value = "";
      }
    ), Y(
      () => s.value,
      () => {
        s.value.find((y) => y.cedar === p.value) || h(null);
      }
    ), Y(
      () => s.value.length,
      (y, A) => {
        _.value && u.value && y > A ? c(A) : y < w.value && (_.value = !1), w.value = y;
      }
    );
    const c = (y) => {
      Mt(() => {
        const A = u.value?.querySelector(
          ".fnc-finder__results__container"
        );
        A && A.children.item(y)?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" }), _.value = !1;
      });
    };
    return (y, A) => O(s).length > 0 ? (b(), v("div", cd, [
      C("div", {
        class: q(["fnc-finder__results__container", [`fnc-finder__results__container--${O(o).resultsDirection}`]])
      }, [
        (b(!0), v(se, null, we(O(s), (k, R) => (b(), v("div", {
          key: k.cedar,
          role: "radio",
          "aria-checked": k.cedar === g.value,
          "data-cedar": k.cedar,
          class: "fnc-finder__results__item"
        }, [
          e.isBranchFinderCard ? (b(), z(Zc, {
            key: 0,
            data: k,
            number: R + 1,
            onTrackingCardEvent: A[0] || (A[0] = (T) => n("trackingCardEvent", T)),
            onMouseenter: (T) => h(k),
            onMouseleave: A[1] || (A[1] = (T) => h(null)),
            onFocusin: (T) => h(k),
            onFocusout: A[2] || (A[2] = (T) => h(null))
          }, null, 8, ["data", "number", "onMouseenter", "onFocusin"])) : (b(), z(ls, {
            key: 1,
            clickable: "",
            home: k,
            distance: k.distanceInMiles,
            "go-to-branch-page": O(o).goToBranchPage,
            "show-phone-number": O(o).showPhoneNumber,
            "show-schedule": O(o).showOpenStatus,
            selected: k.cedar === g.value,
            onSelectCedar: f,
            onMouseenter: (T) => h(k),
            onMouseleave: A[3] || (A[3] = (T) => h(null)),
            onFocusin: (T) => h(k),
            onFocusout: A[4] || (A[4] = (T) => h(null))
          }, null, 8, ["home", "distance", "go-to-branch-page", "show-phone-number", "show-schedule", "selected", "onMouseenter", "onFocusin"]))
        ], 8, dd))), 128))
      ], 2),
      m.value ? (b(), v("div", pd, [
        V(ot, {
          class: "fnc-finder__results__show-more",
          type: "button",
          "data-cy": "show-more-homes",
          tabindex: "0",
          label: "Show more",
          category: "secondary",
          color: "teal",
          "icon-side": "right",
          "full-width-mobile": "",
          onClick: d,
          onKeypress: $e(d, ["enter"])
        }, {
          icon: He(() => [
            V(ee, {
              name: "plus",
              size: "20",
              stroke: "#00838F",
              "stroke-width": "2"
            })
          ]),
          _: 1
        })
      ])) : P("", !0)
    ], 512)) : P("", !0);
  }
}), md = { class: "fnc-branch-finder" }, fd = /* @__PURE__ */ W({
  __name: "BranchFinder.ce",
  props: {
    title: {
      type: String,
      default: "Find your local funeral director"
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Enter town or postcode"
    },
    searchLabel: {
      type: String,
      default: "Find a funeral home"
    },
    resetLabel: {
      type: String,
      default: "Clear search"
    },
    mapsApiKey: {
      type: String,
      default: ""
    },
    apiUrl: {
      type: String,
      default: ""
    },
    searchRadius: {
      type: Number,
      default: void 0
    },
    resultsPerPage: {
      type: Number,
      default: void 0
    },
    minResults: {
      type: Number,
      default: void 0
    },
    maxPages: {
      type: Number,
      default: void 0
    },
    minCharsForSearch: {
      type: Number,
      default: void 0
    },
    showPhoneNumber: {
      type: Boolean,
      default: void 0
    },
    showOpenStatus: {
      type: Boolean,
      default: void 0
    },
    goToBranchPage: {
      type: Boolean,
      default: void 0
    },
    resultsDirection: {
      type: String,
      default: ""
    },
    showResults: {
      type: Boolean,
      default: !1
    },
    useBranchFinderCard: {
      type: Boolean,
      default: !1
    },
    getDummyData: {
      type: Boolean,
      default: !1
    },
    redirectOnSearch: {
      type: Boolean,
      default: !1
    },
    redirectBaseUrl: {
      type: String,
      default: ""
    },
    showCurrentLocation: {
      type: [Boolean, String],
      default: !0
    },
    showResetButton: {
      type: [Boolean, String],
      default: !0
    }
  },
  emits: ["trackingSearch", "trackingCardEvent"],
  setup(e, { emit: t }) {
    const n = Ka();
    Ue(n);
    const o = (c, y = !0) => typeof c == "string" ? c === "" ? y : c.toLowerCase() !== "false" : c === void 0 ? y : !!c, a = e, s = t, r = he(), l = Vt(), { searchTerm: i } = ke(r), u = $(() => {
      const c = typeof window < "u" ? `${window.location.origin}/search/` : "/search/", y = a.redirectBaseUrl || c;
      return y.endsWith("/") ? y : `${y}/`;
    }), g = (c) => `${u.value}${encodeURI(c).replace(/%20/g, "+")}`, _ = $(() => {
      const c = {};
      return a.apiUrl && (c.apiUrl = a.apiUrl), a.searchRadius !== void 0 && (c.searchRadius = Number(a.searchRadius)), a.resultsPerPage !== void 0 && (c.resultsPerPage = Number(a.resultsPerPage)), a.minResults !== void 0 && (c.minResults = Number(a.minResults)), a.maxPages !== void 0 && (c.maxPages = Number(a.maxPages)), a.minCharsForSearch !== void 0 && (c.minCharsForSearch = Number(a.minCharsForSearch)), a.showPhoneNumber !== void 0 && (c.showPhoneNumber = a.showPhoneNumber), a.showOpenStatus !== void 0 && (c.showOpenStatus = a.showOpenStatus), a.goToBranchPage !== void 0 && (c.goToBranchPage = a.goToBranchPage), a.resultsDirection && (c.resultsDirection = a.resultsDirection), c;
    });
    Y(
      _,
      (c) => {
        Object.keys(c).length && r.setFinderConfig(c);
      },
      { immediate: !0, deep: !0 }
    );
    const w = $(() => {
      if (a.mapsApiKey) return a.mapsApiKey;
      if (typeof window < "u") {
        const c = window;
        if (typeof c.mapsApi == "string")
          return c.mapsApi;
      }
      return "";
    }), { setGoogleMapsApiKey: p } = l;
    Y(
      w,
      (c) => {
        c && p(c);
      },
      { immediate: !0 }
    );
    const f = (c) => {
      if (s("trackingSearch", c), !a.redirectOnSearch || typeof window > "u")
        return;
      const y = c;
      if (y?.type === "user" || y?.type === "currentLocation") {
        const A = y.search || i.value || "";
        A && (window.location.href = g(A));
      }
    }, h = $(() => o(a.showCurrentLocation)), m = $(() => o(a.showResetButton)), d = (c) => {
      s("trackingCardEvent", c);
    };
    return (c, y) => (b(), v("div", md, [
      V(as, {
        title: e.title,
        label: e.label,
        placeholder: e.placeholder,
        "search-label": e.searchLabel,
        "reset-label": e.resetLabel,
        "get-dummy": e.getDummyData,
        "show-current-location": h.value,
        "show-reset-button": m.value,
        onTrackingSearchEvent: f
      }, null, 8, ["title", "label", "placeholder", "search-label", "reset-label", "get-dummy", "show-current-location", "show-reset-button"]),
      e.showResults ? (b(), z(Rn, {
        key: 0,
        "is-branch-finder-card": e.useBranchFinderCard,
        onTrackingCardEvent: d
      }, null, 8, ["is-branch-finder-card"])) : P("", !0)
    ]));
  }
}), hd = ".fnc-branch-finder[data-v-ab9dc63d]{display:block}", yd = /* @__PURE__ */ te(fd, [["styles", [hd]], ["__scopeId", "data-v-ab9dc63d"]]), _d = { class: "fnc-branch-results coop-l-grid" }, bd = { class: "fnc-branch-results__component coop-l-grid__item col-xl-5" }, gd = { class: "fnc-branch-results__intro" }, vd = { class: "fnc-branch-results__results__header" }, wd = ["disabled"], Ed = {
  key: 0,
  class: "fnc-branch-results__map coop-l-grid__item col-xl-7"
}, Cd = /* @__PURE__ */ W({
  __name: "BranchFinderResults",
  emits: ["trackingCardEvent", "trackingMapEvent", "trackingToggleEvent"],
  setup(e, { emit: t }) {
    const n = t, o = he(), {
      branches: a,
      pagination: s,
      selectedBranch: r,
      finderConfig: l,
      placeCoordinates: i,
      placeCoordinatesSource: u
    } = ke(o), { updateSelectedBranch: g, clearSelectedBranch: _ } = o, w = $t(yt.XLARGE), p = B(!1), f = B(""), h = Ne("resultsContainer"), m = Ne("mapContainer"), d = $(() => {
      const N = a.value.map((H) => ({
        id: H.cedar,
        title: H.name,
        lat: H.latitude,
        lng: H.longitude,
        home: H,
        numbered: !0,
        clickable: !0
      }));
      if (i.value) {
        const H = u.value === "currentLocation" ? "current-location" : "search-address", D = u.value === "currentLocation" ? "Current location" : "Search location";
        N.unshift({
          id: "search-location",
          title: D,
          lat: i.value.lat,
          lng: i.value.lng,
          numbered: !1,
          clickable: !1,
          variant: H
        });
      }
      return N;
    }), c = $(() => !p.value || !w.value), y = $(() => p.value || !w.value), A = $(
      () => p.value && !!r.value && w.value
    ), k = $(() => p.value ? "View as list" : "View on map"), R = $(() => p.value ? "list" : "location"), T = $(() => {
      const N = l.value.resultsPerPage, H = l.value.maxPages, D = N * H;
      return s.value.count > D ? D : s.value.count;
    }), K = $(
      () => s.value.totalPages > 1 && s.value.currentPage < s.value.totalPages && l.value.maxPages > s.value.currentPage
    ), Z = $(
      () => p.value && w.value && K.value
    ), M = (N) => {
      if (!r.value)
        return;
      const H = N.target;
      if (!(H instanceof Node))
        return;
      const D = h.value?.contains(H) ?? !1, ne = m.value?.contains(H) ?? !1;
      D || ne || _();
    };
    et(() => {
      document.addEventListener("pointerdown", M);
    }), ys(() => {
      document.removeEventListener("pointerdown", M);
    });
    const S = () => {
      !a.value.length && !i.value || (p.value = !p.value, n("trackingToggleEvent", p.value ? "view_map" : "view_list"));
    }, U = (N, H) => {
      if (!N) {
        _();
        return;
      }
      const D = r.value?.cedar;
      if (H) {
        if (D === N) {
          _();
          return;
        }
        const ne = a.value.find((X) => X.cedar === N);
        ne && g(ne);
      } else
        _();
    }, x = (N) => {
      f.value = N;
    }, G = () => {
      s.value.currentPage += 1, n("trackingMapEvent", "show_more");
    };
    return Y(
      () => a.value.length,
      (N) => {
        N === 0 && !i.value && (p.value = !1);
      }
    ), (N, H) => (b(), v("div", _d, [
      C("div", bd, [
        C("div", gd, [
          ve(N.$slots, "default", {}, void 0, !0)
        ]),
        C("div", {
          ref_key: "resultsContainer",
          ref: h,
          class: "fnc-branch-results__results"
        }, [
          C("div", vd, [
            C("p", null, "Showing " + L(O(a).length) + " results of " + L(T.value), 1),
            C("button", {
              class: "fnc-branch-results__results__toggle fnc-btn coop-t-link",
              type: "button",
              disabled: !O(a).length,
              onClick: S
            }, [
              V(ee, {
                name: R.value,
                size: "16px",
                fill: "#00729a"
              }, null, 8, ["name"]),
              Ze(" " + L(k.value), 1)
            ], 8, wd)
          ]),
          c.value ? (b(), z(Rn, {
            key: 0,
            "is-branch-finder-card": "",
            onCardHovered: x,
            onTrackingCardEvent: H[0] || (H[0] = (D) => n("trackingCardEvent", D))
          })) : P("", !0)
        ], 512)
      ]),
      y.value ? (b(), v("div", Ed, [
        C("div", {
          ref_key: "mapContainer",
          ref: m,
          class: "fnc-branch-results__map__container"
        }, [
          V(Ln, {
            class: "fnc-branch-results__map__component",
            markers: d.value,
            "selected-marker": O(r)?.cedar || "",
            "hovered-marker": f.value,
            onMarkerSelected: U,
            onTrackingMapEvent: H[1] || (H[1] = (D) => n("trackingMapEvent", D))
          }, null, 8, ["markers", "selected-marker", "hovered-marker"]),
          A.value ? (b(), z(Bn, {
            key: 0,
            class: "fnc-branch-results__map__info-window",
            home: O(r),
            onTrackingMapEvent: H[2] || (H[2] = (D) => n("trackingMapEvent", D))
          }, null, 8, ["home"])) : P("", !0)
        ], 512),
        Z.value ? (b(), z(ot, {
          key: 0,
          class: "fnc-finder__results__show-more fnc-branch-results__map__show-more",
          type: "button",
          "data-cy": "show-more-homes-map",
          tabindex: "0",
          label: "Show more",
          category: "secondary",
          color: "teal",
          "icon-side": "right",
          "full-width-mobile": "",
          onClick: G,
          onKeypress: $e(G, ["enter"])
        }, {
          icon: He(() => [
            V(ee, {
              name: "plus",
              size: "20",
              stroke: "#00838F",
              "stroke-width": "2"
            })
          ]),
          _: 1
        })) : P("", !0)
      ])) : P("", !0)
    ]));
  }
}), Sd = /* @__PURE__ */ te(Cd, [["__scopeId", "data-v-95b4e7f9"]]), Ad = /* @__PURE__ */ W({
  __name: "ButtonIconComponent",
  props: {
    category: {
      type: String,
      default: "primary"
    },
    color: {
      type: String,
      default: "teal"
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t, o = () => {
      n("click");
    };
    return (a, s) => (b(), v("button", {
      class: q(["coop-btn fnc-btn fnc-btn-icon", [`fnc-btn--${e.category} fnc-btn--${e.color}`]]),
      type: "button",
      onClick: o
    }, [
      ve(a.$slots, "icon")
    ], 2));
  }
}), kd = async (e) => {
  const { apiUrl: t, apiKey: n } = _t();
  if (!e)
    throw new Error("Parameters missing");
  try {
    return await fetch(`${t.value}/qas/get-address`, {
      method: "POST",
      headers: {
        "x-api-key": n.value
      },
      body: JSON.stringify({ moniker: e })
    }).then((a) => a.json()).catch((a) => {
      throw new Error(a);
    });
  } catch (o) {
    throw new Error(`Failed to get address: ${o}`);
  }
}, Td = async (e) => {
  const { apiUrl: t, apiKey: n } = _t();
  if (!e)
    throw new Error("Parameters missing");
  if (!es.includes(t.value))
    throw new Error("URL not allowed");
  try {
    const o = await fetch(`${t.value}/qas/search`, {
      method: "POST",
      headers: {
        "x-api-key": n.value
      },
      body: JSON.stringify({ query: e })
    }).then((a) => a.json()).catch((a) => {
      throw new Error(a);
    });
    if (o.length > 0 && o[0].Moniker === null)
      throw new Error("Postcode not found");
    return o;
  } catch (o) {
    throw new Error(`Failed to search addresses: ${o}`);
  }
}, Ke = mn([]), Od = "<p>Postcode not found. Try again or enter address manually.</p>", Pd = "<p>Sorry, something went wrong. Try again or enter manually.</p>", Md = "<Select address", Fd = (e) => {
  Ke.push({
    name: e,
    postCode: "",
    addresses: [],
    selectedMoniker: "",
    selectedAddress: {
      house_number_name: "",
      address_1: "",
      address_2: "",
      town_city: "",
      county: "",
      postcode: ""
    },
    showPostCodeAlert: !1,
    showAddressAlert: !1,
    enterAddressManual: !1,
    loadingSearchAddresses: !1,
    loadingGetAddress: !1
  });
}, Zo = B(""), Xo = B(""), _t = () => {
  const e = (d) => {
    const c = s(d);
    c && (c.selectedMoniker = "", c.showPostCodeAlert = !1, c.enterAddressManual = !1, c.addresses.length = 0, c.selectedAddress.house_number_name = "", c.selectedAddress.address_1 = "", c.selectedAddress.address_2 = "", c.selectedAddress.town_city = "", c.selectedAddress.county = "", c.selectedAddress.postcode = "", c.showAddressAlert = !1);
  }, t = (d) => {
    Zo.value = d;
  }, n = (d) => {
    Xo.value = d;
  }, o = (d, c, y) => {
    const A = a(d);
    A >= 0 && (Ke[A][c] = y);
  }, a = (d) => Ke.findIndex((c) => c.name === d), s = (d) => Ke.find((c) => c.name === d), r = (d) => {
    const c = a(d);
    return c >= 0 ? Ke[c] : null;
  }, l = async (d) => {
    e(d);
    const c = r(d);
    if (c) {
      c.loadingSearchAddresses = !0;
      try {
        const y = await Td(c.postCode);
        y.length > 0 ? c.addresses.push(...y) : c.showPostCodeAlert = !0;
      } catch (y) {
        console.warn("Error fetching addresses:", y), c.showPostCodeAlert = !0;
      }
      c.loadingSearchAddresses = !1;
    }
  }, i = async (d) => {
    const c = s(d);
    if (c) {
      c.loadingGetAddress = !0;
      try {
        const y = await kd(c.selectedMoniker);
        y ? (c.postCode = y.postcode ?? "", c.selectedAddress.house_number_name = y.house_number_name ?? "", c.selectedAddress.address_1 = y.address_1 ?? "", c.selectedAddress.address_2 = y.address_2 ?? "", c.selectedAddress.town_city = y.town_city ?? "", c.selectedAddress.county = y.county ?? "", c.selectedAddress.postcode = y.postcode ?? "") : c.showAddressAlert = !0;
      } catch (y) {
        console.error("Error fetching address:", y), c.showAddressAlert = !0;
      }
      c.loadingGetAddress = !1;
    }
  }, u = (d) => {
    const c = s(d);
    return c ? (c.enterAddressManual = !0, !0) : !1;
  }, g = (d) => {
    const c = s(d);
    return c && c.selectedAddress.address_1 !== "";
  }, _ = async (d, c) => {
    const y = s(d);
    if (!y) return;
    [
      "postcode",
      "address_1",
      "address_2",
      "town_city",
      "county",
      "house_number_name"
    ].forEach((k) => {
      const R = y.selectedAddress[k] || "";
      c(k, R);
    });
  }, w = (d, c) => d.fields?.find((y) => y.name.includes(c))?.value ?? "", p = (d) => $(() => ({
    houseNumber: w(d, "house_number_name"),
    address1: w(d, "address_1"),
    address2: w(d, "address_2"),
    townCity: w(d, "town_city"),
    county: w(d, "county"),
    postcode: w(d, "postcode")
  })), f = (d) => !!d.fields?.some((c) => c.value !== ""), h = (d) => !!d.fields?.some((c) => c.name.includes("address_1") && c.value !== "");
  return {
    findAddressComponents: Ke,
    apiUrl: Zo,
    apiKey: Xo,
    postCodeAlert: Od,
    addressAlert: Pd,
    selectAddressLabel: Md,
    updateApiUrl: t,
    updateApiKey: n,
    createFindAddressComponent: Fd,
    findIndexComponent: a,
    findComponentByName: s,
    getComponentByName: r,
    updateComponent: o,
    handleSearch: l,
    handleGet: i,
    showAddressManual: u,
    hasAddressData: g,
    processAddressSelection: _,
    getAddressFields: p,
    hasPrefilledFields: f,
    hasFilledAddress: h,
    useAddressConditions: (d, c) => {
      const y = $(() => r(d())), A = $(() => c()), k = $(
        () => !!y.value && y.value.showPostCodeAlert && !y.value.enterAddressManual
      ), R = $(
        () => !!y.value && y.value.showAddressAlert && !y.value.enterAddressManual
      ), T = $(
        () => !!y.value && y.value.addresses.length > 0
      ), K = $(
        () => !!y.value && !y.value.enterAddressManual && h(A.value)
      ), Z = $(
        () => !!y.value && !y.value.enterAddressManual
      ), M = $(
        () => !!y.value && y.value.enterAddressManual
      );
      return {
        shouldShowPostCodeAlert: k,
        shouldShowAddressAlert: R,
        shouldShowAddressSelection: T,
        shouldShowHighlightBox: K,
        shouldShowManualEntryButton: Z,
        enterManualAddress: M
      };
    }
  };
}, Bd = { class: "coop-form__row" }, Dd = ["innerHTML"], Ld = ["value"], Rd = /* @__PURE__ */ W({
  __name: "AddressSelection",
  props: {
    name: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e, { findAddressComponents: n, findIndexComponent: o, handleGet: a } = _t(), s = o(t.name), r = n[s] ?? void 0, l = B(r?.selectedMoniker);
    Y(l, () => {
      r && (r.selectedMoniker = l.value ?? ""), a(t.name);
    });
    const i = $(() => `Select address (${r?.addresses?.length} found)`);
    return (u, g) => (b(), v(se, null, [
      C("fieldset", Bd, [
        C("label", {
          for: "find-address-post-code-select",
          class: "coop-form__label",
          innerHTML: i.value
        }, null, 8, Dd),
        fe(C("select", {
          id: "find-address-post-code-select",
          "onUpdate:modelValue": g[0] || (g[0] = (_) => l.value = _),
          class: "sessioncamexclude coop-form__field coop-form__select coop-form__field--width-30",
          name: "find-address-post-code-select"
        }, [
          g[1] || (g[1] = C("option", {
            value: "",
            selected: ""
          }, " Please select ... ", -1)),
          (b(!0), v(se, null, we(O(r)?.addresses, (_) => (b(), v("option", {
            key: _.Moniker,
            value: _.Moniker
          }, L(_.PartialAddress), 9, Ld))), 128))
        ], 512), [
          [ta, l.value]
        ])
      ]),
      O(r) && O(r).loadingGetAddress ? (b(), z(mt, {
        key: 0,
        type: "neutral",
        loading: "",
        message: "<p>Loading address ...</p>"
      })) : P("", !0)
    ], 64));
  }
}), xd = { class: "coop-form__row" }, Id = ["innerHTML"], Nd = {
  key: 1,
  class: "coop-form__error"
}, $d = { class: "fnc-find-address__post-code" }, Vd = /* @__PURE__ */ W({
  __name: "PostCodeForm",
  props: {
    name: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    value: {
      type: String,
      default: ""
    },
    legend: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, { findAddressComponents: n, findIndexComponent: o, updateComponent: a, handleSearch: s } = _t(), r = o(t.name), l = n[r] ?? void 0, i = B(t.value ?? "");
    Y(
      () => i.value,
      (g) => {
        a(t.name, "postCode", g);
      }
    );
    const u = () => {
      s(t.name);
    };
    return (g, _) => (b(), v("fieldset", xd, [
      e.legend ? (b(), z(Qa, {
        key: 0,
        legend: e.legend
      }, null, 8, ["legend"])) : P("", !0),
      C("label", {
        for: "find-address-post-code-search",
        class: "coop-form__label",
        innerHTML: e.label
      }, null, 8, Id),
      e.error ? (b(), v("p", Nd, L(e.error), 1)) : P("", !0),
      C("div", $d, [
        fe(C("input", {
          id: "find-address-post-code-search",
          "onUpdate:modelValue": _[0] || (_[0] = (w) => i.value = w),
          class: "sessioncamexclude coop-form__field coop-form__input coop-form__field--width-10",
          type: "text",
          autocomplete: "on",
          name: "find-address-post-code-search",
          onKeyup: $e(u, ["enter"])
        }, null, 544), [
          [fn, i.value]
        ]),
        V(ot, {
          label: "Find address",
          color: "teal",
          loading: O(l) && O(l).loadingSearchAddresses,
          "data-cy": "find-address-post-code-search-button",
          category: "secondary",
          onClick: u
        }, null, 8, ["loading"])
      ])
    ]));
  }
}), Ud = /* @__PURE__ */ te(Vd, [["__scopeId", "data-v-fc8ddb61"]]), Gd = { key: 0 }, Hd = { key: 1 }, Wd = { key: 2 }, zd = { key: 3 }, Kd = { key: 4 }, jd = { key: 5 }, qd = /* @__PURE__ */ W({
  __name: "FindAddressComponent",
  props: {
    formName: {
      type: String,
      required: !0
    },
    data: {
      type: Object,
      required: !0
    },
    apiUrl: {
      type: String,
      required: !0
    },
    apiKey: {
      type: String,
      required: !0
    }
  },
  emits: ["updateValue", "updateProperty"],
  setup(e, { emit: t }) {
    const {
      createFindAddressComponent: n,
      updateApiKey: o,
      updateApiUrl: a,
      showAddressManual: s,
      processAddressSelection: r,
      getComponentByName: l,
      postCodeAlert: i,
      addressAlert: u,
      selectAddressLabel: g,
      getAddressFields: _,
      useAddressConditions: w
    } = _t(), p = e, f = t;
    ft(() => {
      n(p.data.name), a(p.apiUrl), o(p.apiKey);
    });
    const {
      shouldShowPostCodeAlert: h,
      shouldShowAddressAlert: m,
      shouldShowAddressSelection: d,
      shouldShowHighlightBox: c,
      shouldShowManualEntryButton: y,
      enterManualAddress: A
    } = w(
      () => p.data.name,
      () => p.data
    ), k = _(p.data), R = () => {
      s(p.data.name) && f("updateProperty", {
        name: p.data.name,
        property: "optional",
        value: !0
      });
    };
    Y(
      p.data,
      () => {
        if (p.data.validate) {
          const K = l(p.data.name);
          K && (K.enterAddressManual = !0);
        }
      },
      { deep: !0 }
    ), Y(
      () => l(p.data.name)?.postCode,
      (K, Z) => {
        Z !== void 0 && f("updateValue", {
          name: p.data.name,
          value: K
        });
      },
      { deep: !0 }
    ), Y(
      () => l(p.data.name)?.selectedAddress,
      (K, Z) => {
        Z !== void 0 && r(p.data.name, T);
      },
      { deep: !0 }
    );
    const T = (K, Z) => {
      p.data.fields?.some((S) => S.name.includes(K)) && f("updateValue", {
        element: K,
        value: Z,
        elementName: p.data.name
      });
    };
    return (K, Z) => (b(), v("div", null, [
      V(Ud, {
        name: p.data.name,
        label: e.data.label,
        legend: e.data.legend,
        value: p.data.value,
        error: e.data.errorType === "empty" ? e.data.error?.empty : ""
      }, null, 8, ["name", "label", "legend", "value", "error"]),
      O(h) ? (b(), z(mt, {
        key: 0,
        type: "alert",
        message: O(i),
        "data-cy": "find-address-post-code-alert"
      }, null, 8, ["message"])) : P("", !0),
      O(m) ? (b(), z(mt, {
        key: 1,
        type: "alert",
        message: O(u)
      }, null, 8, ["message"])) : P("", !0),
      O(d) ? (b(), z(Rd, {
        key: 2,
        name: e.data.name,
        label: O(g)
      }, null, 8, ["name", "label"])) : P("", !0),
      O(c) ? (b(), z(Ja, {
        key: 3,
        "data-cy": "address-highlight-box"
      }, {
        default: He(() => [
          O(k).houseNumber ? (b(), v("span", Gd, L(O(k).houseNumber), 1)) : P("", !0),
          O(k).address1 ? (b(), v("span", Hd, L(O(k).address1), 1)) : P("", !0),
          O(k).address2 ? (b(), v("span", Wd, L(O(k).address2), 1)) : P("", !0),
          O(k).townCity ? (b(), v("span", zd, L(O(k).townCity), 1)) : P("", !0),
          O(k).county ? (b(), v("span", Kd, L(O(k).county), 1)) : P("", !0),
          O(k).postcode ? (b(), v("span", jd, L(O(k).postcode), 1)) : P("", !0)
        ]),
        _: 1
      })) : P("", !0),
      O(y) ? (b(), z(Nt, {
        key: 4,
        label: "Enter address manually",
        "data-cy": "find-address-manual",
        onClick: R
      })) : P("", !0),
      O(A) ? ve(K.$slots, "default", { key: 5 }) : P("", !0)
    ]));
  }
}), Yd = {
  key: 0,
  id: "formValidation",
  class: "coop-c-message coop-c-message--error",
  tabindex: "-1",
  role: "alert"
}, Zd = { class: "coop-c-message__message" }, Xd = {
  key: 0,
  class: "coop-c-message__list"
}, Jd = ["href"], Qd = /* @__PURE__ */ W({
  __name: "FormValidation",
  props: {
    formName: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e, { forms: n, findErrorMessage: o } = de(), a = n.find((s) => s.name === t.formName);
    return (s, r) => O(a).hasError && O(a).errors.length > 0 ? (b(), v("div", Yd, [
      r[0] || (r[0] = C("h2", { id: "validation-demo-box-heading" }, "There's a problem", -1)),
      C("p", Zd, L(O(a).errorMessage), 1),
      O(a).errors ? (b(), v("ul", Xd, [
        (b(!0), v(se, null, we(O(a).errors.filter((l) => l.errorType), (l) => (b(), v("li", {
          key: l.name
        }, [
          l.errorType ? (b(), v("a", {
            key: 0,
            href: `#${l.name}`,
            class: "coop-c-message__link"
          }, L(O(o)(l.errorType, l.error ?? {})), 9, Jd)) : P("", !0)
        ]))), 128))
      ])) : P("", !0)
    ])) : P("", !0);
  }
}), e0 = {}, t0 = { class: "lds-ring" };
function n0(e, t) {
  return b(), v("div", t0, [...t[0] || (t[0] = [
    C("div", null, null, -1),
    C("div", null, null, -1),
    C("div", null, null, -1),
    C("div", null, null, -1)
  ])]);
}
const xn = /* @__PURE__ */ te(e0, [["render", n0], ["__scopeId", "data-v-c1ad4048"]]), Jo = (e) => {
  const { getFormByName: t, updateFormProperty: n } = de(), o = t(e);
  o.form.steps.forEach((a) => {
    a.fields.forEach((s) => {
      if (s.condition)
        for (let r = 0; r < s.condition.length; r++) {
          const l = s.condition[r];
          let i = !0;
          if (l.forEach((u) => {
            o.form.steps.forEach((g) => {
              const _ = g.fields.find((w) => w.name === u.fieldName);
              if (_) {
                const w = u.operator, p = u.value, f = _.value;
                switch (w) {
                  case "==":
                    _.type === "checkbox" ? _.values?.includes(p) || (i = !1) : f !== p && (i = !1);
                    break;
                  case "!=":
                    _.type === "checkbox" ? _.values?.includes(p) && (i = !1) : f === p && (i = !1);
                    break;
                  case ">":
                    if (_.type === "date") {
                      const h = new Date(f), m = new Date(p);
                      h <= m && (i = !1);
                    } else
                      f <= p && (i = !1);
                    break;
                  case "<":
                    if (_.type === "date") {
                      const h = new Date(f), m = new Date(p);
                      h >= m && (i = !1);
                    } else
                      f >= p && (i = !1);
                    break;
                  case "error":
                    _.errorType !== "" && _.errorType !== void 0 ? i = !0 : i = !1;
                    break;
                }
              }
            });
          }), i !== s.show && n(e, s.name, "show", i), i === !0)
            break;
        }
    });
  });
}, o0 = { class: "fnc-form__step" }, a0 = {
  key: 0,
  class: "fnc-form__step__header"
}, s0 = ["innerHTML"], r0 = {
  key: 2,
  class: "fnc-form__step__body"
}, l0 = /* @__PURE__ */ W({
  __name: "StepElement",
  props: {
    formName: {
      type: String,
      required: !0
    },
    step: {
      type: Object,
      required: !0
    },
    showStepTitles: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const { getFormByName: t, updateFormValue: n } = de(), o = e, a = (l) => {
      n(
        o.formName,
        l.name ?? "",
        l.value,
        l.isArray,
        l.elementName,
        l.element
      );
    }, s = (l) => _s(l), r = t(o.formName);
    return et(() => {
      Jo(o.formName);
    }), Y(
      () => r.form.steps.map(
        (l) => l.fields.map((i) => ({
          value: i.value,
          values: i.values
        }))
      ),
      () => {
        Jo(o.formName);
      },
      { deep: !0 }
    ), (l, i) => (b(), v("div", o0, [
      e.showStepTitles || e.step.description ? (b(), v("div", a0, [
        e.showStepTitles ? (b(), z(vt(e.step.labelTag || "h2"), {
          key: 0,
          class: "fnc-form__step__header__title",
          innerHTML: e.step.label
        }, null, 8, ["innerHTML"])) : P("", !0),
        e.step.description ? (b(), v("p", {
          key: 1,
          innerHTML: e.step.description
        }, null, 8, s0)) : P("", !0)
      ])) : P("", !0),
      e.loading ? (b(), z(xn, {
        key: 1,
        class: "coop-l-grid coop-u-flex-centered"
      })) : (b(), v("div", r0, [
        (b(!0), v(se, null, we(e.step.fields.filter((u) => u.show !== !1), (u) => (b(), v(se, {
          key: u.name
        }, [
          u.component ? (b(), z(vt(s(u.component)), {
            key: 0,
            data: u,
            onUpdateValue: a
          }, null, 40, ["data"])) : u.element === "expanded" || u.element === "accordion" ? (b(), z(Ya, {
            key: 1,
            collapsable: u.element === "accordion",
            label: u.label
          }, {
            default: He(() => [
              (b(!0), v(se, null, we(u.fields, (g) => (b(), v(se, {
                key: g.name
              }, [
                g.component ? (b(), z(vt(s(g.component)), {
                  key: 0,
                  data: g,
                  onUpdateValue: a
                }, null, 40, ["data"])) : (b(), z(Dt, {
                  key: 1,
                  "form-name": e.formName,
                  "element-name": u.name,
                  field: g
                }, null, 8, ["form-name", "element-name", "field"]))
              ], 64))), 128))
            ]),
            _: 2
          }, 1032, ["collapsable", "label"])) : (b(), z(Dt, {
            key: 2,
            "form-name": e.formName,
            field: u
          }, null, 8, ["form-name", "field"]))
        ], 64))), 128))
      ]))
    ]));
  }
}), i0 = { class: "fnc-form__buttons" }, u0 = /* @__PURE__ */ W({
  __name: "FormComponent",
  props: {
    formProp: {
      type: Object,
      required: !0
    },
    showValidationBox: {
      type: Boolean,
      default: !1
    },
    showStepTitles: {
      type: Boolean,
      default: !1
    },
    scrollToTop: {
      type: Boolean,
      default: !0
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["submitForm"],
  setup(e, { expose: t, emit: n }) {
    const { getFormByName: o, updateFormValue: a, validateStep: s, resetIgnoredSteps: r } = de(), l = e, i = n, u = B(o(l.formProp.name)), g = Ne("form-element"), _ = () => {
      s(l.formProp.name, u.value.currentStep) ? g.value?.scrollIntoView({ behavior: "smooth" }) : (r(l.formProp.name), i("submitForm"));
    };
    return Y(
      () => u.value.hasError,
      (p) => {
        p && g.value?.scrollIntoView({ behavior: "smooth" });
      }
    ), Y(
      () => u.value.currentStep,
      () => {
        l.scrollToTop && g.value?.scrollIntoView({ behavior: "smooth" });
      }
    ), t({
      updateValue: (p, f, h = !1, m) => {
        a(l.formProp.name, p, f, h, m);
      },
      validateFinalStep: _
    }), (p, f) => (b(), v("form", {
      ref: "form-element",
      class: "fnc-form",
      onSubmit: f[0] || (f[0] = Pe(() => {
      }, ["prevent"]))
    }, [
      e.showValidationBox ? (b(), z(Qd, {
        key: 0,
        "form-name": e.formProp.name
      }, null, 8, ["form-name"])) : P("", !0),
      V(l0, {
        "form-name": e.formProp.name,
        step: e.formProp.steps[u.value.currentStep],
        "show-step-titles": e.showStepTitles,
        loading: e.loading
      }, null, 8, ["form-name", "step", "show-step-titles", "loading"]),
      fe(C("div", i0, [
        e.formProp.steps.length > 1 && u.value.currentStep !== 0 ? ve(p.$slots, "previousButton", { key: 0 }) : P("", !0),
        e.formProp.steps.length > 1 && e.formProp.steps.length !== u.value.currentStep + 1 ? ve(p.$slots, "nextButton", { key: 1 }) : P("", !0),
        e.formProp.steps.length === u.value.currentStep + 1 ? ve(p.$slots, "submitButton", { key: 2 }) : P("", !0)
      ], 512), [
        [rt, !e.loading]
      ])
    ], 544));
  }
}), c0 = { class: "fnc-header" }, d0 = { class: "coop-l-container" }, p0 = { key: 2 }, m0 = /* @__PURE__ */ W({
  __name: "HeaderComponent",
  props: {
    title: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    gridClass: {
      type: String,
      default: ""
    },
    itemClass: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = (n) => /^(http|https):\/\//.test(n);
    return (n, o) => (b(), v("div", c0, [
      C("div", d0, [
        C("div", {
          class: q(["coop-l-grid", [e.gridClass]])
        }, [
          C("div", {
            class: q(["fnc-header__content coop-l-grid__item", [e.itemClass]])
          }, [
            e.url ? (b(), z(vt(t(e.url) ? "a" : "router-link"), {
              key: 0,
              href: t(e.url) ? e.url : void 0,
              to: t(e.url) ? void 0 : e.url
            }, {
              default: He(() => [
                V(ee, {
                  name: "coop-logo",
                  fill: "#00a1cc"
                })
              ]),
              _: 1
            }, 8, ["href", "to"])) : (b(), z(ee, {
              key: 1,
              name: "coop-logo",
              fill: "#00a1cc"
            })),
            e.title ? (b(), v("p", p0, L(e.title), 1)) : P("", !0)
          ], 2)
        ], 2)
      ])
    ]));
  }
}), f0 = /* @__PURE__ */ te(m0, [["__scopeId", "data-v-25ed4fb7"]]), { getFormByName: Yt, validateStep: h0, resetErrors: y0 } = de(), P0 = () => {
  const e = (a, s) => {
    const r = a.form.steps[a.currentStep];
    if (r.show = !0, r && r.condition) {
      let l = !0;
      for (let i = 0; i < r.condition.length; i++) {
        const u = r.condition[i];
        for (let g = 0; g < u.length; g++) {
          const _ = u[g];
          for (let w = 0; w < a.form.steps.length; w++) {
            const f = a.form.steps[w].fields.find((h) => h.name === _.fieldName);
            if (f) {
              const h = _.operator, m = _.value, d = f.value;
              switch (h) {
                case "==":
                  f.type === "checkbox" ? f.values?.includes(m) ? l = !0 : l = !1 : d !== m ? l = !1 : l = !0;
                  break;
                case "!=":
                  f.type === "checkbox" ? f.values?.includes(m) ? l = !1 : l = !0 : d === m ? l = !1 : l = !0;
                  break;
              }
            }
          }
          if (l === !1)
            break;
        }
        if (l === !0)
          break;
      }
      l || (r.show = !1, s === "next" ? a.currentStep++ : a.currentStep--, e(a, s));
    }
    return a.currentStep;
  };
  return {
    nextStep: (a) => {
      const s = Yt(a);
      return h0(s.name, s.currentStep) || s.currentStep++, e(s, "next");
    },
    previousStep: (a) => {
      const s = Yt(a);
      return y0(s.name), s.currentStep--, e(s, "previous");
    },
    changeToStep: (a, s) => {
      const r = Yt(a), l = r.form.steps.length;
      if (s > l && s < 0)
        throw new Error("Invalid step number");
      return r.currentStep = s, r.currentStep;
    }
  };
}, M0 = /* @__PURE__ */ Mn("session", () => {
  const e = B(null);
  return { sessionId: e, setSessionId: () => {
    e.value = ss();
  } };
}), _0 = (e, t) => {
  Array.isArray(window.dataLayer) ? window.dataLayer.push({
    event: e,
    ...t
  }) : window.dataLayer = [{ event: e, ...t }];
}, F0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  pushToDataLayer: _0
}, Symbol.toStringTag, { value: "Module" })), b0 = (e) => sessionStorage.getItem(e) !== null, g0 = (e, t) => {
  sessionStorage.setItem(e, JSON.stringify(t));
}, v0 = (e) => {
  const t = sessionStorage.getItem(e);
  return t ? JSON.parse(t) : null;
}, w0 = (e) => {
  sessionStorage.removeItem(e);
}, B0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clearStorage: w0,
  isValueInStorage: b0,
  loadFormFromStorage: v0,
  saveFormToStorage: g0
}, Symbol.toStringTag, { value: "Module" })), D0 = 1445, L0 = 25, R0 = 10, x0 = 20, I0 = 30, E0 = yn(ee, {
  shadowRoot: !1
}), C0 = yn(yd, {
  shadowRoot: !1
}), S0 = yn(xn, {
  shadowRoot: !1
});
typeof window < "u" && (customElements.get("fnc-icon") || customElements.define("fnc-icon", E0), customElements.get("fnc-branch-finder") || customElements.define("fnc-branch-finder", C0), customElements.get("fnc-spinner") || customElements.define("fnc-spinner", S0));
const N0 = {
  install(e) {
    if (!e._context.provides.pinia) {
      const t = Ka();
      e.use(t), Ue(t);
    }
    e.component("BranchFinderInput", as), e.component("BranchFinderList", Rn), e.component("BranchFinderResults", Sd), e.component("ButtonComponent", ot), e.component("ButtonIconComponent", Ad), e.component("ButtonLinkComponent", Nt), e.component("HeaderComponent", f0), e.component("IconComponent", ee), e.component("FormComponent", u0), e.component("AccordionComponent", Ya), e.component("BranchCardComponent", ls), e.component("NotificationComponent", mt), e.component("FindAddressComponent", qd), e.component("ACIWidget", xu), e.component("SpinnerComponent", xn), e.component("InputGroup", Dt), e.component("GoogleMapComponent", Ln), e.component("GoogleInfoWindow", Bn);
  }
};
export {
  xu as ACIWidget,
  Ya as AccordionComponent,
  ls as BranchCardComponent,
  as as BranchFinderInput,
  Rn as BranchFinderList,
  Sd as BranchFinderResults,
  C0 as BranchFinderWebComponent,
  yt as Breakpoints,
  ot as ButtonComponent,
  Ad as ButtonIconComponent,
  Nt as ButtonLinkComponent,
  ln as COMPANY_DISPLAY_NAME,
  R0 as DC_ASHES_COLLECT,
  I0 as DC_ASHES_RETURN,
  x0 as DC_ASHES_SCATTER,
  D0 as DC_BASE_PRICE,
  L0 as DC_MEMBERSHIP_DISCOUNT,
  rc as DaysOfTheWeek,
  J as ErrorMessages,
  qd as FindAddressComponent,
  u0 as FormComponent,
  Bn as GoogleInfoWindow,
  Ln as GoogleMapComponent,
  f0 as HeaderComponent,
  ee as IconComponent,
  E0 as IconWebComponent,
  Dt as InputGroup,
  mt as NotificationComponent,
  ie as PaymentType,
  Kt as SUPPORTED_AUTH_METHODS,
  Tt as SUPPORTED_PAYMENT_METHODS,
  xn as SpinnerComponent,
  S0 as SpinnerWebComponent,
  vi as createForm,
  N0 as default,
  O0 as dom,
  T0 as formatter,
  F0 as gtm,
  B0 as storage,
  he as useBranchFinderStore,
  de as useForm,
  Vt as useGoogleMapAPIStore,
  $t as useIsScreenSmallerThan,
  M0 as useSessionStore,
  P0 as useStep
};
